var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var dist = {};

var errors = {};

(function (exports) {
	// NOTE: don't construct errors here or they'll have the wrong stack trace.
	// NOTE: don't make custom error class; the JS engines use `SyntaxError`
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.errorMessages = exports.ErrorType = void 0;
	/**
	 * Keys for possible error messages used by `unraw`.
	 * Note: These do _not_ map to actual error object types. All errors thrown
	 * are `SyntaxError`.
	 */
	// Don't use const enum or JS users won't be able to access the enum values
	var ErrorType;
	(function (ErrorType) {
	    /**
	     * Thrown when a badly formed Unicode escape sequence is found. Possible
	     * reasons include the code being too short (`"\u25"`) or having invalid
	     * characters (`"\u2$A5"`).
	     */
	    ErrorType["MalformedUnicode"] = "MALFORMED_UNICODE";
	    /**
	     * Thrown when a badly formed hexadecimal escape sequence is found. Possible
	     * reasons include the code being too short (`"\x2"`) or having invalid
	     * characters (`"\x2$"`).
	     */
	    ErrorType["MalformedHexadecimal"] = "MALFORMED_HEXADECIMAL";
	    /**
	     * Thrown when a Unicode code point escape sequence has too high of a code
	     * point. The maximum code point allowed is `\u{10FFFF}`, so `\u{110000}` and
	     * higher will throw this error.
	     */
	    ErrorType["CodePointLimit"] = "CODE_POINT_LIMIT";
	    /**
	     * Thrown when an octal escape sequences is encountered and `allowOctals` is
	     * `false`. For example, `unraw("\234", false)`.
	     */
	    ErrorType["OctalDeprecation"] = "OCTAL_DEPRECATION";
	    /**
	     * Thrown only when a single backslash is found at the end of a string. For
	     * example, `"\\"` or `"test\\x24\\"`.
	     */
	    ErrorType["EndOfString"] = "END_OF_STRING";
	})(ErrorType = exports.ErrorType || (exports.ErrorType = {}));
	/** Map of error message names to the full text of the message. */
	exports.errorMessages = new Map([
	    [ErrorType.MalformedUnicode, "malformed Unicode character escape sequence"],
	    [
	        ErrorType.MalformedHexadecimal,
	        "malformed hexadecimal character escape sequence"
	    ],
	    [
	        ErrorType.CodePointLimit,
	        "Unicode codepoint must not be greater than 0x10FFFF in escape sequence"
	    ],
	    [
	        ErrorType.OctalDeprecation,
	        '"0"-prefixed octal literals and octal escape sequences are deprecated; ' +
	            'for octal literals use the "0o" prefix instead'
	    ],
	    [ErrorType.EndOfString, "malformed escape sequence at end of string"]
	]); 
} (errors));

(function (exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.unraw = exports.errorMessages = exports.ErrorType = void 0;
	const errors_1 = errors;
	Object.defineProperty(exports, "ErrorType", { enumerable: true, get: function () { return errors_1.ErrorType; } });
	Object.defineProperty(exports, "errorMessages", { enumerable: true, get: function () { return errors_1.errorMessages; } });
	/**
	 * Parse a string as a base-16 number. This is more strict than `parseInt` as it
	 * will not allow any other characters, including (for example) "+", "-", and
	 * ".".
	 * @param hex A string containing a hexadecimal number.
	 * @returns The parsed integer, or `NaN` if the string is not a valid hex
	 * number.
	 */
	function parseHexToInt(hex) {
	    const isOnlyHexChars = !hex.match(/[^a-f0-9]/i);
	    return isOnlyHexChars ? parseInt(hex, 16) : NaN;
	}
	/**
	 * Check the validity and length of a hexadecimal code and optionally enforces
	 * a specific number of hex digits.
	 * @param hex The string to validate and parse.
	 * @param errorName The name of the error message to throw a `SyntaxError` with
	 * if `hex` is invalid. This is used to index `errorMessages`.
	 * @param enforcedLength If provided, will throw an error if `hex` is not
	 * exactly this many characters.
	 * @returns The parsed hex number as a normal number.
	 * @throws {SyntaxError} If the code is not valid.
	 */
	function validateAndParseHex(hex, errorName, enforcedLength) {
	    const parsedHex = parseHexToInt(hex);
	    if (Number.isNaN(parsedHex) ||
	        (enforcedLength !== undefined && enforcedLength !== hex.length)) {
	        throw new SyntaxError(errors_1.errorMessages.get(errorName));
	    }
	    return parsedHex;
	}
	/**
	 * Parse a two-digit hexadecimal character escape code.
	 * @param code The two-digit hexadecimal number that represents the character to
	 * output.
	 * @returns The single character represented by the code.
	 * @throws {SyntaxError} If the code is not valid hex or is not the right
	 * length.
	 */
	function parseHexadecimalCode(code) {
	    const parsedCode = validateAndParseHex(code, errors_1.ErrorType.MalformedHexadecimal, 2);
	    return String.fromCharCode(parsedCode);
	}
	/**
	 * Parse a four-digit Unicode character escape code.
	 * @param code The four-digit unicode number that represents the character to
	 * output.
	 * @param surrogateCode Optional four-digit unicode surrogate that represents
	 * the other half of the character to output.
	 * @returns The single character represented by the code.
	 * @throws {SyntaxError} If the codes are not valid hex or are not the right
	 * length.
	 */
	function parseUnicodeCode(code, surrogateCode) {
	    const parsedCode = validateAndParseHex(code, errors_1.ErrorType.MalformedUnicode, 4);
	    if (surrogateCode !== undefined) {
	        const parsedSurrogateCode = validateAndParseHex(surrogateCode, errors_1.ErrorType.MalformedUnicode, 4);
	        return String.fromCharCode(parsedCode, parsedSurrogateCode);
	    }
	    return String.fromCharCode(parsedCode);
	}
	/**
	 * Test if the text is surrounded by curly braces (`{}`).
	 * @param text Text to check.
	 * @returns `true` if the text is in the form `{*}`.
	 */
	function isCurlyBraced(text) {
	    return text.charAt(0) === "{" && text.charAt(text.length - 1) === "}";
	}
	/**
	 * Parse a Unicode code point character escape code.
	 * @param codePoint A unicode escape code point, including the surrounding curly
	 * braces.
	 * @returns The single character represented by the code.
	 * @throws {SyntaxError} If the code is not valid hex or does not have the
	 * surrounding curly braces.
	 */
	function parseUnicodeCodePointCode(codePoint) {
	    if (!isCurlyBraced(codePoint)) {
	        throw new SyntaxError(errors_1.errorMessages.get(errors_1.ErrorType.MalformedUnicode));
	    }
	    const withoutBraces = codePoint.slice(1, -1);
	    const parsedCode = validateAndParseHex(withoutBraces, errors_1.ErrorType.MalformedUnicode);
	    try {
	        return String.fromCodePoint(parsedCode);
	    }
	    catch (err) {
	        throw err instanceof RangeError
	            ? new SyntaxError(errors_1.errorMessages.get(errors_1.ErrorType.CodePointLimit))
	            : err;
	    }
	}
	// Have to give overload that takes boolean for when compiler doesn't know if
	// true or false
	function parseOctalCode(code, error = false) {
	    if (error) {
	        throw new SyntaxError(errors_1.errorMessages.get(errors_1.ErrorType.OctalDeprecation));
	    }
	    // The original regex only allows digits so we don't need to have a strict
	    // octal parser like hexToInt. Length is not enforced for octals.
	    const parsedCode = parseInt(code, 8);
	    return String.fromCharCode(parsedCode);
	}
	/**
	 * Map of unescaped letters to their corresponding special JS escape characters.
	 * Intentionally does not include characters that map to themselves like "\'".
	 */
	const singleCharacterEscapes = new Map([
	    ["b", "\b"],
	    ["f", "\f"],
	    ["n", "\n"],
	    ["r", "\r"],
	    ["t", "\t"],
	    ["v", "\v"],
	    ["0", "\0"]
	]);
	/**
	 * Parse a single character escape sequence and return the matching character.
	 * If none is matched, defaults to `code`.
	 * @param code A single character code.
	 */
	function parseSingleCharacterCode(code) {
	    return singleCharacterEscapes.get(code) || code;
	}
	/**
	 * Matches every escape sequence possible, including invalid ones.
	 *
	 * All capture groups (described below) are unique (only one will match), except
	 * for 4, which can only potentially match if 3 does.
	 *
	 * **Capture Groups:**
	 * 0. A single backslash
	 * 1. Hexadecimal code
	 * 2. Unicode code point code with surrounding curly braces
	 * 3. Unicode escape code with surrogate
	 * 4. Surrogate code
	 * 5. Unicode escape code without surrogate
	 * 6. Octal code _NOTE: includes "0"._
	 * 7. A single character (will never be \, x, u, or 0-3)
	 */
	const escapeMatch = /\\(?:(\\)|x([\s\S]{0,2})|u(\{[^}]*\}?)|u([\s\S]{4})\\u([^{][\s\S]{0,3})|u([\s\S]{0,4})|([0-3]?[0-7]{1,2})|([\s\S])|$)/g;
	/**
	 * Replace raw escape character strings with their escape characters.
	 * @param raw A string where escape characters are represented as raw string
	 * values like `\'` rather than `'`.
	 * @param allowOctals If `true`, will process the now-deprecated octal escape
	 * sequences (ie, `\111`).
	 * @returns The processed string, with escape characters replaced by their
	 * respective actual Unicode characters.
	 */
	function unraw(raw, allowOctals = false) {
	    return raw.replace(escapeMatch, function (_, backslash, hex, codePoint, unicodeWithSurrogate, surrogate, unicode, octal, singleCharacter) {
	        // Compare groups to undefined because empty strings mean different errors
	        // Otherwise, `\u` would fail the same as `\` which is wrong.
	        if (backslash !== undefined) {
	            return "\\";
	        }
	        if (hex !== undefined) {
	            return parseHexadecimalCode(hex);
	        }
	        if (codePoint !== undefined) {
	            return parseUnicodeCodePointCode(codePoint);
	        }
	        if (unicodeWithSurrogate !== undefined) {
	            return parseUnicodeCode(unicodeWithSurrogate, surrogate);
	        }
	        if (unicode !== undefined) {
	            return parseUnicodeCode(unicode);
	        }
	        if (octal === "0") {
	            return "\0";
	        }
	        if (octal !== undefined) {
	            return parseOctalCode(octal, !allowOctals);
	        }
	        if (singleCharacter !== undefined) {
	            return parseSingleCharacterCode(singleCharacter);
	        }
	        throw new SyntaxError(errors_1.errorMessages.get(errors_1.ErrorType.EndOfString));
	    });
	}
	exports.unraw = unraw;
	exports.default = unraw; 
} (dist));

var parser = {};

var lexer = {};

var moo = {exports: {}};

(function (module) {
	(function(root, factory) {
	  if (module.exports) {
	    module.exports = factory();
	  } else {
	    root.moo = factory();
	  }
	}(commonjsGlobal, function() {

	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var toString = Object.prototype.toString;
	  var hasSticky = typeof new RegExp().sticky === 'boolean';

	  /***************************************************************************/

	  function isRegExp(o) { return o && toString.call(o) === '[object RegExp]' }
	  function isObject(o) { return o && typeof o === 'object' && !isRegExp(o) && !Array.isArray(o) }

	  function reEscape(s) {
	    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')
	  }
	  function reGroups(s) {
	    var re = new RegExp('|' + s);
	    return re.exec('').length - 1
	  }
	  function reCapture(s) {
	    return '(' + s + ')'
	  }
	  function reUnion(regexps) {
	    if (!regexps.length) return '(?!)'
	    var source =  regexps.map(function(s) {
	      return "(?:" + s + ")"
	    }).join('|');
	    return "(?:" + source + ")"
	  }

	  function regexpOrLiteral(obj) {
	    if (typeof obj === 'string') {
	      return '(?:' + reEscape(obj) + ')'

	    } else if (isRegExp(obj)) {
	      // TODO: consider /u support
	      if (obj.ignoreCase) throw new Error('RegExp /i flag not allowed')
	      if (obj.global) throw new Error('RegExp /g flag is implied')
	      if (obj.sticky) throw new Error('RegExp /y flag is implied')
	      if (obj.multiline) throw new Error('RegExp /m flag is implied')
	      return obj.source

	    } else {
	      throw new Error('Not a pattern: ' + obj)
	    }
	  }

	  function pad(s, length) {
	    if (s.length > length) {
	      return s
	    }
	    return Array(length - s.length + 1).join(" ") + s
	  }

	  function lastNLines(string, numLines) {
	    var position = string.length;
	    var lineBreaks = 0;
	    while (true) {
	      var idx = string.lastIndexOf("\n", position - 1);
	      if (idx === -1) {
	        break;
	      } else {
	        lineBreaks++;
	      }
	      position = idx;
	      if (lineBreaks === numLines) {
	        break;
	      }
	      if (position === 0) {
	        break;
	      }
	    }
	    var startPosition = 
	      lineBreaks < numLines ?
	      0 : 
	      position + 1;
	    return string.substring(startPosition).split("\n")
	  }

	  function objectToRules(object) {
	    var keys = Object.getOwnPropertyNames(object);
	    var result = [];
	    for (var i = 0; i < keys.length; i++) {
	      var key = keys[i];
	      var thing = object[key];
	      var rules = [].concat(thing);
	      if (key === 'include') {
	        for (var j = 0; j < rules.length; j++) {
	          result.push({include: rules[j]});
	        }
	        continue
	      }
	      var match = [];
	      rules.forEach(function(rule) {
	        if (isObject(rule)) {
	          if (match.length) result.push(ruleOptions(key, match));
	          result.push(ruleOptions(key, rule));
	          match = [];
	        } else {
	          match.push(rule);
	        }
	      });
	      if (match.length) result.push(ruleOptions(key, match));
	    }
	    return result
	  }

	  function arrayToRules(array) {
	    var result = [];
	    for (var i = 0; i < array.length; i++) {
	      var obj = array[i];
	      if (obj.include) {
	        var include = [].concat(obj.include);
	        for (var j = 0; j < include.length; j++) {
	          result.push({include: include[j]});
	        }
	        continue
	      }
	      if (!obj.type) {
	        throw new Error('Rule has no type: ' + JSON.stringify(obj))
	      }
	      result.push(ruleOptions(obj.type, obj));
	    }
	    return result
	  }

	  function ruleOptions(type, obj) {
	    if (!isObject(obj)) {
	      obj = { match: obj };
	    }
	    if (obj.include) {
	      throw new Error('Matching rules cannot also include states')
	    }

	    // nb. error and fallback imply lineBreaks
	    var options = {
	      defaultType: type,
	      lineBreaks: !!obj.error || !!obj.fallback,
	      pop: false,
	      next: null,
	      push: null,
	      error: false,
	      fallback: false,
	      value: null,
	      type: null,
	      shouldThrow: false,
	    };

	    // Avoid Object.assign(), so we support IE9+
	    for (var key in obj) {
	      if (hasOwnProperty.call(obj, key)) {
	        options[key] = obj[key];
	      }
	    }

	    // type transform cannot be a string
	    if (typeof options.type === 'string' && type !== options.type) {
	      throw new Error("Type transform cannot be a string (type '" + options.type + "' for token '" + type + "')")
	    }

	    // convert to array
	    var match = options.match;
	    options.match = Array.isArray(match) ? match : match ? [match] : [];
	    options.match.sort(function(a, b) {
	      return isRegExp(a) && isRegExp(b) ? 0
	           : isRegExp(b) ? -1 : isRegExp(a) ? +1 : b.length - a.length
	    });
	    return options
	  }

	  function toRules(spec) {
	    return Array.isArray(spec) ? arrayToRules(spec) : objectToRules(spec)
	  }

	  var defaultErrorRule = ruleOptions('error', {lineBreaks: true, shouldThrow: true});
	  function compileRules(rules, hasStates) {
	    var errorRule = null;
	    var fast = Object.create(null);
	    var fastAllowed = true;
	    var unicodeFlag = null;
	    var groups = [];
	    var parts = [];

	    // If there is a fallback rule, then disable fast matching
	    for (var i = 0; i < rules.length; i++) {
	      if (rules[i].fallback) {
	        fastAllowed = false;
	      }
	    }

	    for (var i = 0; i < rules.length; i++) {
	      var options = rules[i];

	      if (options.include) {
	        // all valid inclusions are removed by states() preprocessor
	        throw new Error('Inheritance is not allowed in stateless lexers')
	      }

	      if (options.error || options.fallback) {
	        // errorRule can only be set once
	        if (errorRule) {
	          if (!options.fallback === !errorRule.fallback) {
	            throw new Error("Multiple " + (options.fallback ? "fallback" : "error") + " rules not allowed (for token '" + options.defaultType + "')")
	          } else {
	            throw new Error("fallback and error are mutually exclusive (for token '" + options.defaultType + "')")
	          }
	        }
	        errorRule = options;
	      }

	      var match = options.match.slice();
	      if (fastAllowed) {
	        while (match.length && typeof match[0] === 'string' && match[0].length === 1) {
	          var word = match.shift();
	          fast[word.charCodeAt(0)] = options;
	        }
	      }

	      // Warn about inappropriate state-switching options
	      if (options.pop || options.push || options.next) {
	        if (!hasStates) {
	          throw new Error("State-switching options are not allowed in stateless lexers (for token '" + options.defaultType + "')")
	        }
	        if (options.fallback) {
	          throw new Error("State-switching options are not allowed on fallback tokens (for token '" + options.defaultType + "')")
	        }
	      }

	      // Only rules with a .match are included in the RegExp
	      if (match.length === 0) {
	        continue
	      }
	      fastAllowed = false;

	      groups.push(options);

	      // Check unicode flag is used everywhere or nowhere
	      for (var j = 0; j < match.length; j++) {
	        var obj = match[j];
	        if (!isRegExp(obj)) {
	          continue
	        }

	        if (unicodeFlag === null) {
	          unicodeFlag = obj.unicode;
	        } else if (unicodeFlag !== obj.unicode && options.fallback === false) {
	          throw new Error('If one rule is /u then all must be')
	        }
	      }

	      // convert to RegExp
	      var pat = reUnion(match.map(regexpOrLiteral));

	      // validate
	      var regexp = new RegExp(pat);
	      if (regexp.test("")) {
	        throw new Error("RegExp matches empty string: " + regexp)
	      }
	      var groupCount = reGroups(pat);
	      if (groupCount > 0) {
	        throw new Error("RegExp has capture groups: " + regexp + "\nUse (?: … ) instead")
	      }

	      // try and detect rules matching newlines
	      if (!options.lineBreaks && regexp.test('\n')) {
	        throw new Error('Rule should declare lineBreaks: ' + regexp)
	      }

	      // store regex
	      parts.push(reCapture(pat));
	    }


	    // If there's no fallback rule, use the sticky flag so we only look for
	    // matches at the current index.
	    //
	    // If we don't support the sticky flag, then fake it using an irrefutable
	    // match (i.e. an empty pattern).
	    var fallbackRule = errorRule && errorRule.fallback;
	    var flags = hasSticky && !fallbackRule ? 'ym' : 'gm';
	    var suffix = hasSticky || fallbackRule ? '' : '|';

	    if (unicodeFlag === true) flags += "u";
	    var combined = new RegExp(reUnion(parts) + suffix, flags);
	    return {regexp: combined, groups: groups, fast: fast, error: errorRule || defaultErrorRule}
	  }

	  function compile(rules) {
	    var result = compileRules(toRules(rules));
	    return new Lexer({start: result}, 'start')
	  }

	  function checkStateGroup(g, name, map) {
	    var state = g && (g.push || g.next);
	    if (state && !map[state]) {
	      throw new Error("Missing state '" + state + "' (in token '" + g.defaultType + "' of state '" + name + "')")
	    }
	    if (g && g.pop && +g.pop !== 1) {
	      throw new Error("pop must be 1 (in token '" + g.defaultType + "' of state '" + name + "')")
	    }
	  }
	  function compileStates(states, start) {
	    var all = states.$all ? toRules(states.$all) : [];
	    delete states.$all;

	    var keys = Object.getOwnPropertyNames(states);
	    if (!start) start = keys[0];

	    var ruleMap = Object.create(null);
	    for (var i = 0; i < keys.length; i++) {
	      var key = keys[i];
	      ruleMap[key] = toRules(states[key]).concat(all);
	    }
	    for (var i = 0; i < keys.length; i++) {
	      var key = keys[i];
	      var rules = ruleMap[key];
	      var included = Object.create(null);
	      for (var j = 0; j < rules.length; j++) {
	        var rule = rules[j];
	        if (!rule.include) continue
	        var splice = [j, 1];
	        if (rule.include !== key && !included[rule.include]) {
	          included[rule.include] = true;
	          var newRules = ruleMap[rule.include];
	          if (!newRules) {
	            throw new Error("Cannot include nonexistent state '" + rule.include + "' (in state '" + key + "')")
	          }
	          for (var k = 0; k < newRules.length; k++) {
	            var newRule = newRules[k];
	            if (rules.indexOf(newRule) !== -1) continue
	            splice.push(newRule);
	          }
	        }
	        rules.splice.apply(rules, splice);
	        j--;
	      }
	    }

	    var map = Object.create(null);
	    for (var i = 0; i < keys.length; i++) {
	      var key = keys[i];
	      map[key] = compileRules(ruleMap[key], true);
	    }

	    for (var i = 0; i < keys.length; i++) {
	      var name = keys[i];
	      var state = map[name];
	      var groups = state.groups;
	      for (var j = 0; j < groups.length; j++) {
	        checkStateGroup(groups[j], name, map);
	      }
	      var fastKeys = Object.getOwnPropertyNames(state.fast);
	      for (var j = 0; j < fastKeys.length; j++) {
	        checkStateGroup(state.fast[fastKeys[j]], name, map);
	      }
	    }

	    return new Lexer(map, start)
	  }

	  function keywordTransform(map) {

	    // Use a JavaScript Map to map keywords to their corresponding token type
	    // unless Map is unsupported, then fall back to using an Object:
	    var isMap = typeof Map !== 'undefined';
	    var reverseMap = isMap ? new Map : Object.create(null);

	    var types = Object.getOwnPropertyNames(map);
	    for (var i = 0; i < types.length; i++) {
	      var tokenType = types[i];
	      var item = map[tokenType];
	      var keywordList = Array.isArray(item) ? item : [item];
	      keywordList.forEach(function(keyword) {
	        if (typeof keyword !== 'string') {
	          throw new Error("keyword must be string (in keyword '" + tokenType + "')")
	        }
	        if (isMap) {
	          reverseMap.set(keyword, tokenType);
	        } else {
	          reverseMap[keyword] = tokenType;
	        }
	      });
	    }
	    return function(k) {
	      return isMap ? reverseMap.get(k) : reverseMap[k]
	    }
	  }

	  /***************************************************************************/

	  var Lexer = function(states, state) {
	    this.startState = state;
	    this.states = states;
	    this.buffer = '';
	    this.stack = [];
	    this.reset();
	  };

	  Lexer.prototype.reset = function(data, info) {
	    this.buffer = data || '';
	    this.index = 0;
	    this.line = info ? info.line : 1;
	    this.col = info ? info.col : 1;
	    this.queuedToken = info ? info.queuedToken : null;
	    this.queuedText = info ? info.queuedText: "";
	    this.queuedThrow = info ? info.queuedThrow : null;
	    this.setState(info ? info.state : this.startState);
	    this.stack = info && info.stack ? info.stack.slice() : [];
	    return this
	  };

	  Lexer.prototype.save = function() {
	    return {
	      line: this.line,
	      col: this.col,
	      state: this.state,
	      stack: this.stack.slice(),
	      queuedToken: this.queuedToken,
	      queuedText: this.queuedText,
	      queuedThrow: this.queuedThrow,
	    }
	  };

	  Lexer.prototype.setState = function(state) {
	    if (!state || this.state === state) return
	    this.state = state;
	    var info = this.states[state];
	    this.groups = info.groups;
	    this.error = info.error;
	    this.re = info.regexp;
	    this.fast = info.fast;
	  };

	  Lexer.prototype.popState = function() {
	    this.setState(this.stack.pop());
	  };

	  Lexer.prototype.pushState = function(state) {
	    this.stack.push(this.state);
	    this.setState(state);
	  };

	  var eat = hasSticky ? function(re, buffer) { // assume re is /y
	    return re.exec(buffer)
	  } : function(re, buffer) { // assume re is /g
	    var match = re.exec(buffer);
	    // will always match, since we used the |(?:) trick
	    if (match[0].length === 0) {
	      return null
	    }
	    return match
	  };

	  Lexer.prototype._getGroup = function(match) {
	    var groupCount = this.groups.length;
	    for (var i = 0; i < groupCount; i++) {
	      if (match[i + 1] !== undefined) {
	        return this.groups[i]
	      }
	    }
	    throw new Error('Cannot find token type for matched text')
	  };

	  function tokenToString() {
	    return this.value
	  }

	  Lexer.prototype.next = function() {
	    var index = this.index;

	    // If a fallback token matched, we don't need to re-run the RegExp
	    if (this.queuedGroup) {
	      var token = this._token(this.queuedGroup, this.queuedText, index);
	      this.queuedGroup = null;
	      this.queuedText = "";
	      return token
	    }

	    var buffer = this.buffer;
	    if (index === buffer.length) {
	      return // EOF
	    }

	    // Fast matching for single characters
	    var group = this.fast[buffer.charCodeAt(index)];
	    if (group) {
	      return this._token(group, buffer.charAt(index), index)
	    }

	    // Execute RegExp
	    var re = this.re;
	    re.lastIndex = index;
	    var match = eat(re, buffer);

	    // Error tokens match the remaining buffer
	    var error = this.error;
	    if (match == null) {
	      return this._token(error, buffer.slice(index, buffer.length), index)
	    }

	    var group = this._getGroup(match);
	    var text = match[0];

	    if (error.fallback && match.index !== index) {
	      this.queuedGroup = group;
	      this.queuedText = text;

	      // Fallback tokens contain the unmatched portion of the buffer
	      return this._token(error, buffer.slice(index, match.index), index)
	    }

	    return this._token(group, text, index)
	  };

	  Lexer.prototype._token = function(group, text, offset) {
	    // count line breaks
	    var lineBreaks = 0;
	    if (group.lineBreaks) {
	      var matchNL = /\n/g;
	      var nl = 1;
	      if (text === '\n') {
	        lineBreaks = 1;
	      } else {
	        while (matchNL.exec(text)) { lineBreaks++; nl = matchNL.lastIndex; }
	      }
	    }

	    var token = {
	      type: (typeof group.type === 'function' && group.type(text)) || group.defaultType,
	      value: typeof group.value === 'function' ? group.value(text) : text,
	      text: text,
	      toString: tokenToString,
	      offset: offset,
	      lineBreaks: lineBreaks,
	      line: this.line,
	      col: this.col,
	    };
	    // nb. adding more props to token object will make V8 sad!

	    var size = text.length;
	    this.index += size;
	    this.line += lineBreaks;
	    if (lineBreaks !== 0) {
	      this.col = size - nl + 1;
	    } else {
	      this.col += size;
	    }

	    // throw, if no rule with {error: true}
	    if (group.shouldThrow) {
	      var err = new Error(this.formatError(token, "invalid syntax"));
	      throw err;
	    }

	    if (group.pop) this.popState();
	    else if (group.push) this.pushState(group.push);
	    else if (group.next) this.setState(group.next);

	    return token
	  };

	  if (typeof Symbol !== 'undefined' && Symbol.iterator) {
	    var LexerIterator = function(lexer) {
	      this.lexer = lexer;
	    };

	    LexerIterator.prototype.next = function() {
	      var token = this.lexer.next();
	      return {value: token, done: !token}
	    };

	    LexerIterator.prototype[Symbol.iterator] = function() {
	      return this
	    };

	    Lexer.prototype[Symbol.iterator] = function() {
	      return new LexerIterator(this)
	    };
	  }

	  Lexer.prototype.formatError = function(token, message) {
	    if (token == null) {
	      // An undefined token indicates EOF
	      var text = this.buffer.slice(this.index);
	      var token = {
	        text: text,
	        offset: this.index,
	        lineBreaks: text.indexOf('\n') === -1 ? 0 : 1,
	        line: this.line,
	        col: this.col,
	      };
	    }
	    
	    var numLinesAround = 2;
	    var firstDisplayedLine = Math.max(token.line - numLinesAround, 1);
	    var lastDisplayedLine = token.line + numLinesAround;
	    var lastLineDigits = String(lastDisplayedLine).length;
	    var displayedLines = lastNLines(
	        this.buffer, 
	        (this.line - token.line) + numLinesAround + 1
	      )
	      .slice(0, 5);
	    var errorLines = [];
	    errorLines.push(message + " at line " + token.line + " col " + token.col + ":");
	    errorLines.push("");
	    for (var i = 0; i < displayedLines.length; i++) {
	      var line = displayedLines[i];
	      var lineNo = firstDisplayedLine + i;
	      errorLines.push(pad(String(lineNo), lastLineDigits) + "  " + line);
	      if (lineNo === token.line) {
	        errorLines.push(pad("", lastLineDigits + token.col + 1) + "^");
	      }
	    }
	    return errorLines.join("\n")
	  };

	  Lexer.prototype.clone = function() {
	    return new Lexer(this.states, this.state)
	  };

	  Lexer.prototype.has = function(tokenType) {
	    return true
	  };


	  return {
	    compile: compile,
	    states: compileStates,
	    error: Object.freeze({error: true}),
	    fallback: Object.freeze({fallback: true}),
	    keywords: keywordTransform,
	  }

	})); 
} (moo));

var mooExports = moo.exports;

(function (exports) {
	var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.lexer = exports.states = void 0;
	const moo_1 = __importDefault(mooExports);
	exports.states = {
	    body: {
	        doubleapos: { match: "''", value: () => "'" },
	        quoted: {
	            lineBreaks: true,
	            match: /'[{}#](?:[^]*?[^'])?'(?!')/u,
	            value: src => src.slice(1, -1).replace(/''/g, "'")
	        },
	        argument: {
	            lineBreaks: true,
	            match: /\{\s*[^\p{Pat_Syn}\p{Pat_WS}]+\s*/u,
	            push: 'arg',
	            value: src => src.substring(1).trim()
	        },
	        octothorpe: '#',
	        end: { match: '}', pop: 1 },
	        content: { lineBreaks: true, match: /[^][^{}#']*/u }
	    },
	    arg: {
	        select: {
	            lineBreaks: true,
	            match: /,\s*(?:plural|select|selectordinal)\s*,\s*/u,
	            next: 'select',
	            value: src => src.split(',')[1].trim()
	        },
	        'func-args': {
	            lineBreaks: true,
	            match: /,\s*[^\p{Pat_Syn}\p{Pat_WS}]+\s*,/u,
	            next: 'body',
	            value: src => src.split(',')[1].trim()
	        },
	        'func-simple': {
	            lineBreaks: true,
	            match: /,\s*[^\p{Pat_Syn}\p{Pat_WS}]+\s*/u,
	            value: src => src.substring(1).trim()
	        },
	        end: { match: '}', pop: 1 }
	    },
	    select: {
	        offset: {
	            lineBreaks: true,
	            match: /\s*offset\s*:\s*\d+\s*/u,
	            value: src => src.split(':')[1].trim()
	        },
	        case: {
	            lineBreaks: true,
	            match: /\s*(?:=\d+|[^\p{Pat_Syn}\p{Pat_WS}]+)\s*\{/u,
	            push: 'body',
	            value: src => src.substring(0, src.indexOf('{')).trim()
	        },
	        end: { match: /\s*\}/u, pop: 1 }
	    }
	};
	exports.lexer = moo_1.default.states(exports.states); 
} (lexer));

/**
 * An AST parser for ICU MessageFormat strings
 *
 * @packageDocumentation
 * @example
 * ```
 * import { parse } from '@messageformat/parser
 *
 * parse('So {wow}.')
 * [ { type: 'content', value: 'So ' },
 *   { type: 'argument', arg: 'wow' },
 *   { type: 'content', value: '.' } ]
 *
 *
 * parse('Such { thing }. { count, selectordinal, one {First} two {Second}' +
 *       '                  few {Third} other {#th} } word.')
 * [ { type: 'content', value: 'Such ' },
 *   { type: 'argument', arg: 'thing' },
 *   { type: 'content', value: '. ' },
 *   { type: 'selectordinal',
 *     arg: 'count',
 *     cases: [
 *       { key: 'one', tokens: [ { type: 'content', value: 'First' } ] },
 *       { key: 'two', tokens: [ { type: 'content', value: 'Second' } ] },
 *       { key: 'few', tokens: [ { type: 'content', value: 'Third' } ] },
 *       { key: 'other',
 *         tokens: [ { type: 'octothorpe' }, { type: 'content', value: 'th' } ] }
 *     ] },
 *   { type: 'content', value: ' word.' } ]
 *
 *
 * parse('Many{type,select,plural{ numbers}selectordinal{ counting}' +
 *                          'select{ choices}other{ some {type}}}.')
 * [ { type: 'content', value: 'Many' },
 *   { type: 'select',
 *     arg: 'type',
 *     cases: [
 *       { key: 'plural', tokens: [ { type: 'content', value: 'numbers' } ] },
 *       { key: 'selectordinal', tokens: [ { type: 'content', value: 'counting' } ] },
 *       { key: 'select', tokens: [ { type: 'content', value: 'choices' } ] },
 *       { key: 'other',
 *         tokens: [ { type: 'content', value: 'some ' }, { type: 'argument', arg: 'type' } ] }
 *     ] },
 *   { type: 'content', value: '.' } ]
 *
 *
 * parse('{Such compliance')
 * // ParseError: invalid syntax at line 1 col 7:
 * //
 * //  {Such compliance
 * //        ^
 *
 *
 * const msg = '{words, plural, zero{No words} one{One word} other{# words}}'
 * parse(msg)
 * [ { type: 'plural',
 *     arg: 'words',
 *     cases: [
 *       { key: 'zero', tokens: [ { type: 'content', value: 'No words' } ] },
 *       { key: 'one', tokens: [ { type: 'content', value: 'One word' } ] },
 *       { key: 'other',
 *         tokens: [ { type: 'octothorpe' }, { type: 'content', value: ' words' } ] }
 *     ] } ]
 *
 *
 * parse(msg, { cardinal: [ 'one', 'other' ], ordinal: [ 'one', 'two', 'few', 'other' ] })
 * // ParseError: The plural case zero is not valid in this locale at line 1 col 17:
 * //
 * //   {words, plural, zero{
 * //                   ^
 * ```
 */
Object.defineProperty(parser, "__esModule", { value: true });
var parse_1 = parser.parse = parser.ParseError = void 0;
const lexer_js_1 = lexer;
const getContext = (lt) => ({
    offset: lt.offset,
    line: lt.line,
    col: lt.col,
    text: lt.text,
    lineBreaks: lt.lineBreaks
});
const isSelectType = (type) => type === 'plural' || type === 'select' || type === 'selectordinal';
function strictArgStyleParam(lt, param) {
    let value = '';
    let text = '';
    for (const p of param) {
        const pText = p.ctx.text;
        text += pText;
        switch (p.type) {
            case 'content':
                value += p.value;
                break;
            case 'argument':
            case 'function':
            case 'octothorpe':
                value += pText;
                break;
            default:
                throw new ParseError(lt, `Unsupported part in strict mode function arg style: ${pText}`);
        }
    }
    const c = {
        type: 'content',
        value: value.trim(),
        ctx: Object.assign({}, param[0].ctx, { text })
    };
    return [c];
}
const strictArgTypes = [
    'number',
    'date',
    'time',
    'spellout',
    'ordinal',
    'duration'
];
const defaultPluralKeys = ['zero', 'one', 'two', 'few', 'many', 'other'];
/**
 * Thrown by {@link parse} on error
 *
 * @public
 */
class ParseError extends Error {
    /** @internal */
    constructor(lt, msg) {
        super(lexer_js_1.lexer.formatError(lt, msg));
    }
}
parser.ParseError = ParseError;
class Parser {
    constructor(src, opt) {
        var _a, _b, _c, _d;
        this.lexer = lexer_js_1.lexer.reset(src);
        this.cardinalKeys = (_a = opt === null || opt === void 0 ? void 0 : opt.cardinal) !== null && _a !== void 0 ? _a : defaultPluralKeys;
        this.ordinalKeys = (_b = opt === null || opt === void 0 ? void 0 : opt.ordinal) !== null && _b !== void 0 ? _b : defaultPluralKeys;
        this.strict = (_c = opt === null || opt === void 0 ? void 0 : opt.strict) !== null && _c !== void 0 ? _c : false;
        this.strictPluralKeys = (_d = opt === null || opt === void 0 ? void 0 : opt.strictPluralKeys) !== null && _d !== void 0 ? _d : true;
    }
    parse() {
        return this.parseBody(false, true);
    }
    checkSelectKey(lt, type, key) {
        if (key[0] === '=') {
            if (type === 'select')
                throw new ParseError(lt, `The case ${key} is not valid with select`);
        }
        else if (type !== 'select') {
            const keys = type === 'plural' ? this.cardinalKeys : this.ordinalKeys;
            if (this.strictPluralKeys && keys.length > 0 && !keys.includes(key)) {
                const msg = `The ${type} case ${key} is not valid in this locale`;
                throw new ParseError(lt, msg);
            }
        }
    }
    parseSelect({ value: arg }, inPlural, ctx, type) {
        const sel = { type, arg, cases: [], ctx };
        if (type === 'plural' || type === 'selectordinal')
            inPlural = true;
        else if (this.strict)
            inPlural = false;
        for (const lt of this.lexer) {
            switch (lt.type) {
                case 'offset':
                    if (type === 'select')
                        throw new ParseError(lt, 'Unexpected plural offset for select');
                    if (sel.cases.length > 0)
                        throw new ParseError(lt, 'Plural offset must be set before cases');
                    sel.pluralOffset = Number(lt.value);
                    ctx.text += lt.text;
                    ctx.lineBreaks += lt.lineBreaks;
                    break;
                case 'case': {
                    this.checkSelectKey(lt, type, lt.value);
                    sel.cases.push({
                        key: lt.value,
                        tokens: this.parseBody(inPlural),
                        ctx: getContext(lt)
                    });
                    break;
                }
                case 'end':
                    return sel;
                /* istanbul ignore next: never happens */
                default:
                    throw new ParseError(lt, `Unexpected lexer token: ${lt.type}`);
            }
        }
        throw new ParseError(null, 'Unexpected message end');
    }
    parseArgToken(lt, inPlural) {
        const ctx = getContext(lt);
        const argType = this.lexer.next();
        if (!argType)
            throw new ParseError(null, 'Unexpected message end');
        ctx.text += argType.text;
        ctx.lineBreaks += argType.lineBreaks;
        if (this.strict &&
            (argType.type === 'func-simple' || argType.type === 'func-args') &&
            !strictArgTypes.includes(argType.value)) {
            const msg = `Invalid strict mode function arg type: ${argType.value}`;
            throw new ParseError(lt, msg);
        }
        switch (argType.type) {
            case 'end':
                return { type: 'argument', arg: lt.value, ctx };
            case 'func-simple': {
                const end = this.lexer.next();
                if (!end)
                    throw new ParseError(null, 'Unexpected message end');
                /* istanbul ignore if: never happens */
                if (end.type !== 'end')
                    throw new ParseError(end, `Unexpected lexer token: ${end.type}`);
                ctx.text += end.text;
                if (isSelectType(argType.value.toLowerCase()))
                    throw new ParseError(argType, `Invalid type identifier: ${argType.value}`);
                return {
                    type: 'function',
                    arg: lt.value,
                    key: argType.value,
                    ctx
                };
            }
            case 'func-args': {
                if (isSelectType(argType.value.toLowerCase())) {
                    const msg = `Invalid type identifier: ${argType.value}`;
                    throw new ParseError(argType, msg);
                }
                let param = this.parseBody(this.strict ? false : inPlural);
                if (this.strict && param.length > 0)
                    param = strictArgStyleParam(lt, param);
                return {
                    type: 'function',
                    arg: lt.value,
                    key: argType.value,
                    param,
                    ctx
                };
            }
            case 'select':
                /* istanbul ignore else: never happens */
                if (isSelectType(argType.value))
                    return this.parseSelect(lt, inPlural, ctx, argType.value);
                else
                    throw new ParseError(argType, `Unexpected select type ${argType.value}`);
            /* istanbul ignore next: never happens */
            default:
                throw new ParseError(argType, `Unexpected lexer token: ${argType.type}`);
        }
    }
    parseBody(inPlural, atRoot) {
        const tokens = [];
        let content = null;
        for (const lt of this.lexer) {
            if (lt.type === 'argument') {
                if (content)
                    content = null;
                tokens.push(this.parseArgToken(lt, inPlural));
            }
            else if (lt.type === 'octothorpe' && inPlural) {
                if (content)
                    content = null;
                tokens.push({ type: 'octothorpe', ctx: getContext(lt) });
            }
            else if (lt.type === 'end' && !atRoot) {
                return tokens;
            }
            else {
                let value = lt.value;
                if (!inPlural && lt.type === 'quoted' && value[0] === '#') {
                    if (value.includes('{')) {
                        const errMsg = `Unsupported escape pattern: ${value}`;
                        throw new ParseError(lt, errMsg);
                    }
                    value = lt.text;
                }
                if (content) {
                    content.value += value;
                    content.ctx.text += lt.text;
                    content.ctx.lineBreaks += lt.lineBreaks;
                }
                else {
                    content = { type: 'content', value, ctx: getContext(lt) };
                    tokens.push(content);
                }
            }
        }
        if (atRoot)
            return tokens;
        throw new ParseError(null, 'Unexpected message end');
    }
}
/**
 * Parse an input string into an array of tokens
 *
 * @public
 * @remarks
 * The parser only supports the default `DOUBLE_OPTIONAL`
 * {@link http://www.icu-project.org/apiref/icu4c/messagepattern_8h.html#af6e0757e0eb81c980b01ee5d68a9978b | apostrophe mode}.
 */
function parse(src, options = {}) {
    const parser = new Parser(src, options);
    return parser.parse();
}
parse_1 = parser.parse = parse;

function processTokens(tokens, mapText) {
  if (!tokens.filter((token) => token.type !== "content").length) {
    return tokens.map((token) => mapText(token.value));
  }
  return tokens.map((token) => {
    if (token.type === "content") {
      return mapText(token.value);
    } else if (token.type === "octothorpe") {
      return "#";
    } else if (token.type === "argument") {
      return [token.arg];
    } else if (token.type === "function") {
      const _param = token?.param?.[0];
      if (_param) {
        return [token.arg, token.key, _param.value.trim()];
      } else {
        return [token.arg, token.key];
      }
    }
    const offset = token.pluralOffset;
    const formatProps = {};
    token.cases.forEach(({ key, tokens: tokens2 }) => {
      const prop = key[0] === "=" ? key.slice(1) : key;
      formatProps[prop] = processTokens(tokens2, mapText);
    });
    return [
      token.arg,
      token.type,
      {
        offset,
        ...formatProps
      }
    ];
  });
}
function compileMessage(message, mapText = (v) => v) {
  try {
    return processTokens(parse_1(message), mapText);
  } catch (e) {
    console.error(`${e.message} 

Message: ${message}`);
    return [message];
  }
}

const isString = (s) => typeof s === "string";
const isFunction = (f) => typeof f === "function";

const cache = /* @__PURE__ */ new Map();
const defaultLocale = "en";
function normalizeLocales(locales) {
  const out = Array.isArray(locales) ? locales : [locales];
  return [...out, defaultLocale];
}
function date(locales, value, format) {
  const _locales = normalizeLocales(locales);
  const formatter = getMemoized(
    () => cacheKey("date", _locales, format),
    () => new Intl.DateTimeFormat(_locales, format)
  );
  return formatter.format(isString(value) ? new Date(value) : value);
}
function number(locales, value, format) {
  const _locales = normalizeLocales(locales);
  const formatter = getMemoized(
    () => cacheKey("number", _locales, format),
    () => new Intl.NumberFormat(_locales, format)
  );
  return formatter.format(value);
}
function plural(locales, ordinal, value, { offset = 0, ...rules }) {
  const _locales = normalizeLocales(locales);
  const plurals = ordinal ? getMemoized(
    () => cacheKey("plural-ordinal", _locales),
    () => new Intl.PluralRules(_locales, { type: "ordinal" })
  ) : getMemoized(
    () => cacheKey("plural-cardinal", _locales),
    () => new Intl.PluralRules(_locales, { type: "cardinal" })
  );
  return rules[value] ?? rules[plurals.select(value - offset)] ?? rules.other;
}
function getMemoized(getKey, construct) {
  const key = getKey();
  let formatter = cache.get(key);
  if (!formatter) {
    formatter = construct();
    cache.set(key, formatter);
  }
  return formatter;
}
function cacheKey(type, locales, options) {
  const localeKey = locales.join("-");
  return `${type}-${localeKey}-${JSON.stringify(options)}`;
}

const UNICODE_REGEX = /\\u[a-fA-F0-9]{4}|\\x[a-fA-F0-9]{2}/;
const OCTOTHORPE_PH = "%__lingui_octothorpe__%";
const getDefaultFormats = (locale, passedLocales, formats = {}) => {
  const locales = passedLocales || locale;
  const style = (format) => {
    return typeof format === "object" ? format : formats[format] || { style: format };
  };
  const replaceOctothorpe = (value, message) => {
    const numberFormat = Object.keys(formats).length ? style("number") : void 0;
    const valueStr = number(locales, value, numberFormat);
    return message.replace(new RegExp(OCTOTHORPE_PH, "g"), valueStr);
  };
  return {
    plural: (value, cases) => {
      const { offset = 0 } = cases;
      const message = plural(locales, false, value, cases);
      return replaceOctothorpe(value - offset, message);
    },
    selectordinal: (value, cases) => {
      const { offset = 0 } = cases;
      const message = plural(locales, true, value, cases);
      return replaceOctothorpe(value - offset, message);
    },
    select: selectFormatter,
    number: (value, format) => number(locales, value, style(format)),
    date: (value, format) => date(locales, value, style(format))
  };
};
const selectFormatter = (value, rules) => rules[value] ?? rules.other;
function interpolate(translation, locale, locales) {
  return (values = {}, formats) => {
    const formatters = getDefaultFormats(locale, locales, formats);
    const formatMessage = (tokens, replaceOctothorpe = false) => {
      if (!Array.isArray(tokens))
        return tokens;
      return tokens.reduce((message, token) => {
        if (token === "#" && replaceOctothorpe) {
          return message + OCTOTHORPE_PH;
        }
        if (isString(token)) {
          return message + token;
        }
        const [name, type, format] = token;
        let interpolatedFormat = {};
        if (type === "plural" || type === "selectordinal" || type === "select") {
          Object.entries(format).forEach(
            ([key, value2]) => {
              interpolatedFormat[key] = formatMessage(
                value2,
                type === "plural" || type === "selectordinal"
              );
            }
          );
        } else {
          interpolatedFormat = format;
        }
        let value;
        if (type) {
          const formatter = formatters[type];
          value = formatter(values[name], interpolatedFormat);
        } else {
          value = values[name];
        }
        if (value == null) {
          return message;
        }
        return message + value;
      }, "");
    };
    const result = formatMessage(translation);
    if (isString(result) && UNICODE_REGEX.test(result)) {
      return dist.unraw(result.trim());
    }
    if (isString(result))
      return result.trim();
    return result ? String(result) : "";
  };
}

var __defProp$1 = Object.defineProperty;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField$1 = (obj, key, value) => {
  __defNormalProp$1(obj, key + "" , value);
  return value;
};
class EventEmitter {
  constructor() {
    __publicField$1(this, "_events", {});
  }
  on(event, listener) {
    var _a;
    (_a = this._events)[event] ?? (_a[event] = []);
    this._events[event].push(listener);
    return () => this.removeListener(event, listener);
  }
  removeListener(event, listener) {
    const maybeListeners = this._getListeners(event);
    if (!maybeListeners)
      return;
    const index = maybeListeners.indexOf(listener);
    if (~index)
      maybeListeners.splice(index, 1);
  }
  emit(event, ...args) {
    const maybeListeners = this._getListeners(event);
    if (!maybeListeners)
      return;
    maybeListeners.map((listener) => listener.apply(this, args));
  }
  _getListeners(event) {
    const maybeListeners = this._events[event];
    return Array.isArray(maybeListeners) ? maybeListeners : false;
  }
}

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class I18n extends EventEmitter {
  constructor(params) {
    super();
    __publicField(this, "_locale", "");
    __publicField(this, "_locales");
    __publicField(this, "_localeData", {});
    __publicField(this, "_messages", {});
    __publicField(this, "_missing");
    __publicField(this, "_messageCompiler");
    /**
     * Alias for {@see I18n._}
     */
    __publicField(this, "t", this._.bind(this));
    if (process.env.NODE_ENV !== "production") {
      this.setMessagesCompiler(compileMessage);
    }
    if (params.missing != null)
      this._missing = params.missing;
    if (params.messages != null)
      this.load(params.messages);
    if (params.localeData != null)
      this.loadLocaleData(params.localeData);
    if (typeof params.locale === "string" || params.locales) {
      this.activate(params.locale ?? defaultLocale, params.locales);
    }
  }
  get locale() {
    return this._locale;
  }
  get locales() {
    return this._locales;
  }
  get messages() {
    return this._messages[this._locale] ?? {};
  }
  /**
   * @deprecated this has no effect. Please remove this from the code. Deprecated in v4
   */
  get localeData() {
    return this._localeData[this._locale] ?? {};
  }
  _loadLocaleData(locale, localeData) {
    const maybeLocaleData = this._localeData[locale];
    if (!maybeLocaleData) {
      this._localeData[locale] = localeData;
    } else {
      Object.assign(maybeLocaleData, localeData);
    }
  }
  /**
   * Registers a `MessageCompiler` to enable the use of uncompiled catalogs at runtime.
   *
   * In production builds, the `MessageCompiler` is typically excluded to reduce bundle size.
   * By default, message catalogs should be precompiled during the build process. However,
   * if you need to compile catalogs at runtime, you can use this method to set a message compiler.
   *
   * Example usage:
   *
   * ```ts
   * import { compileMessage } from "@lingui/message-utils/compileMessage";
   *
   * i18n.setMessagesCompiler(compileMessage);
   * ```
   */
  setMessagesCompiler(compiler) {
    this._messageCompiler = compiler;
    return this;
  }
  /**
   * @deprecated Plurals automatically used from Intl.PluralRules you can safely remove this call. Deprecated in v4
   */
  // @ts-ignore deprecated, so ignore the reported error
  loadLocaleData(localeOrAllData, localeData) {
    if (localeData != null) {
      this._loadLocaleData(localeOrAllData, localeData);
    } else {
      Object.keys(localeOrAllData).forEach(
        (locale) => this._loadLocaleData(locale, localeOrAllData[locale])
      );
    }
    this.emit("change");
  }
  _load(locale, messages) {
    const maybeMessages = this._messages[locale];
    if (!maybeMessages) {
      this._messages[locale] = messages;
    } else {
      Object.assign(maybeMessages, messages);
    }
  }
  load(localeOrMessages, messages) {
    if (typeof localeOrMessages == "string" && typeof messages === "object") {
      this._load(localeOrMessages, messages);
    } else {
      Object.entries(localeOrMessages).forEach(
        ([locale, messages2]) => this._load(locale, messages2)
      );
    }
    this.emit("change");
  }
  /**
   * @param options {@link LoadAndActivateOptions}
   */
  loadAndActivate({ locale, locales, messages }) {
    this._locale = locale;
    this._locales = locales || void 0;
    this._messages[this._locale] = messages;
    this.emit("change");
  }
  activate(locale, locales) {
    if (process.env.NODE_ENV !== "production") {
      if (!this._messages[locale]) {
        console.warn(`Messages for locale "${locale}" not loaded.`);
      }
    }
    this._locale = locale;
    this._locales = locales;
    this.emit("change");
  }
  _(id, values, options) {
    let message = options?.message;
    if (!id) {
      id = "";
    }
    if (!isString(id)) {
      values = id.values || values;
      message = id.message;
      id = id.id;
    }
    const messageForId = this.messages[id];
    const messageMissing = messageForId === void 0;
    const missing = this._missing;
    if (missing && messageMissing) {
      return isFunction(missing) ? missing(this._locale, id) : missing;
    }
    if (messageMissing) {
      this.emit("missing", { id, locale: this._locale });
    }
    let translation = messageForId || message || id;
    if (isString(translation)) {
      if (this._messageCompiler) {
        translation = this._messageCompiler(translation);
      } else {
        console.warn(`Uncompiled message detected! Message:

> ${translation}

That means you use raw catalog or your catalog doesn't have a translation for the message and fallback was used.
ICU features such as interpolation and plurals will not work properly for that message. 

Please compile your catalog first. 
`);
      }
    }
    if (isString(translation) && UNICODE_REGEX.test(translation))
      return JSON.parse(`"${translation}"`);
    if (isString(translation))
      return translation;
    return interpolate(
      translation,
      this._locale,
      this._locales
    )(values, options?.formats);
  }
  date(value, format) {
    return date(this._locales || this._locale, value, format);
  }
  number(value, format) {
    return number(this._locales || this._locale, value, format);
  }
}
function setupI18n(params = {}) {
  return new I18n(params);
}

const i18n$1 = setupI18n();

var i18nGlobal = undefined;
var setI18nGlobal = function(i18n) {
    i18nGlobal = i18n;
};
var i18n = new Proxy({}, {
    get: function(target, property) {
        return (i18nGlobal === null || i18nGlobal === void 0 ? void 0 : i18nGlobal[property]) || i18n$1[property];
    }
});

/* eslint-disable header/header */ // THIS FILE IS GENERATED. DO NOT EDIT MANUALLY.
var actionConfirmations = {
    delete: {
        note: function(count) {
            return i18n._({
                id: "CWxSD9",
                values: {
                    count: count
                }
            });
        },
        item: function(count) {
            return i18n._({
                id: "tStMJq",
                values: {
                    count: count
                }
            });
        },
        reminder: function(count) {
            return i18n._({
                id: "cj47UA",
                values: {
                    count: count
                }
            });
        },
        notebook: function(count) {
            return i18n._({
                id: "ZaWu6Y",
                values: {
                    count: count
                }
            });
        },
        tag: function(count) {
            return i18n._({
                id: "H+9PFS",
                values: {
                    count: count
                }
            });
        },
        color: function(count) {
            return i18n._({
                id: "MGNoKX",
                values: {
                    count: count
                }
            });
        },
        attachment: function(count) {
            return i18n._({
                id: "ONGePp",
                values: {
                    count: count
                }
            });
        },
        unknown: function(type, count) {
            switch(type){
                case "note":
                    return actionConfirmations.delete.note(count);
                case "item":
                    return actionConfirmations.delete.item(count);
                case "reminder":
                    return actionConfirmations.delete.reminder(count);
                case "notebook":
                    return actionConfirmations.delete.notebook(count);
                case "tag":
                    return actionConfirmations.delete.tag(count);
                case "color":
                    return actionConfirmations.delete.color(count);
                case "attachment":
                    return actionConfirmations.delete.attachment(count);
                default:
                    return i18n._({
                        id: "tStMJq",
                        values: {
                            count: count
                        }
                    });
            }
        }
    },
    permanentlyDelete: {
        note: function(count) {
            return i18n._({
                id: "okkL3s",
                values: {
                    count: count
                }
            });
        },
        notebook: function(count) {
            return i18n._({
                id: "TQ6oVm",
                values: {
                    count: count
                }
            });
        },
        unknown: function(type, count) {
            switch(type){
                case "note":
                    return actionConfirmations.permanentlyDelete.note(count);
                case "notebook":
                    return actionConfirmations.permanentlyDelete.notebook(count);
                default:
                    return i18n._({
                        id: "oE5BSK",
                        values: {
                            count: count
                        }
                    });
            }
        }
    }
};

/* eslint-disable header/header */ // THIS FILE IS GENERATED. DO NOT EDIT MANUALLY.
var actionErrors = {
    unpublished: {
        note: function(count) {
            return i18n._({
                id: "3mDTua",
                values: {
                    count: count
                }
            });
        },
        unknown: function(type, count) {
            switch(type){
                case "note":
                    return actionErrors.unpublished.note(count);
                default:
                    return i18n._({
                        id: "zVyWQn",
                        values: {
                            count: count
                        }
                    });
            }
        }
    },
    published: {
        note: function(count) {
            return i18n._({
                id: "+GZ7eC",
                values: {
                    count: count
                }
            });
        },
        unknown: function(type, count) {
            switch(type){
                case "note":
                    return actionErrors.published.note(count);
                default:
                    return i18n._({
                        id: "aBB7wn",
                        values: {
                            count: count
                        }
                    });
            }
        }
    }
};

/* eslint-disable header/header */ // THIS FILE IS GENERATED. DO NOT EDIT MANUALLY.
var actions = {
    deleted: {
        attachment: function(count) {
            return i18n._({
                id: "UqgaO+",
                values: {
                    count: count
                }
            });
        },
        reminder: function(count) {
            return i18n._({
                id: "wJXs5t",
                values: {
                    count: count
                }
            });
        },
        tag: function(count) {
            return i18n._({
                id: "s6Mtp+",
                values: {
                    count: count
                }
            });
        },
        note: function(count) {
            return i18n._({
                id: "ZrlVCy",
                values: {
                    count: count
                }
            });
        },
        notebook: function(count) {
            return i18n._({
                id: "93epYh",
                values: {
                    count: count
                }
            });
        },
        unknown: function(type, count) {
            switch(type){
                case "attachment":
                    return actions.deleted.attachment(count);
                case "reminder":
                    return actions.deleted.reminder(count);
                case "tag":
                    return actions.deleted.tag(count);
                case "note":
                    return actions.deleted.note(count);
                case "notebook":
                    return actions.deleted.notebook(count);
                default:
                    return i18n._({
                        id: "RqysPk",
                        values: {
                            count: count
                        }
                    });
            }
        }
    },
    movedToTrash: {
        note: function(count) {
            return i18n._({
                id: "OyfJsT",
                values: {
                    count: count
                }
            });
        },
        notebook: function(count) {
            return i18n._({
                id: "2TZIlC",
                values: {
                    count: count
                }
            });
        },
        unknown: function(type, count) {
            switch(type){
                case "note":
                    return actions.movedToTrash.note(count);
                case "notebook":
                    return actions.movedToTrash.notebook(count);
                default:
                    return i18n._({
                        id: "mRCkVb",
                        values: {
                            count: count
                        }
                    });
            }
        }
    },
    permanentlyDeleted: {
        note: function(count) {
            return i18n._({
                id: "HRWIyU",
                values: {
                    count: count
                }
            });
        },
        notebook: function(count) {
            return i18n._({
                id: "MB3ARB",
                values: {
                    count: count
                }
            });
        },
        item: function(count) {
            return i18n._({
                id: "eNF85Q",
                values: {
                    count: count
                }
            });
        },
        unknown: function(type, count) {
            switch(type){
                case "note":
                    return actions.permanentlyDeleted.note(count);
                case "notebook":
                    return actions.permanentlyDeleted.notebook(count);
                case "item":
                    return actions.permanentlyDeleted.item(count);
                default:
                    return i18n._({
                        id: "eNF85Q",
                        values: {
                            count: count
                        }
                    });
            }
        }
    },
    published: {
        note: function(count) {
            return i18n._({
                id: "RZ2qc5",
                values: {
                    count: count
                }
            });
        },
        unknown: function(type, count) {
            switch(type){
                case "note":
                    return actions.published.note(count);
                default:
                    return i18n._({
                        id: "DLm3K/",
                        values: {
                            count: count
                        }
                    });
            }
        }
    },
    unpublished: {
        note: function(count) {
            return i18n._({
                id: "SOTTGb",
                values: {
                    count: count
                }
            });
        },
        unknown: function(type, count) {
            switch(type){
                case "note":
                    return actions.unpublished.note(count);
                default:
                    return i18n._({
                        id: "Gv2ZRn",
                        values: {
                            count: count
                        }
                    });
            }
        }
    },
    restored: {
        note: function(count) {
            return i18n._({
                id: "H/8uNq",
                values: {
                    count: count
                }
            });
        },
        notebook: function(count) {
            return i18n._({
                id: "EOnIk2",
                values: {
                    count: count
                }
            });
        },
        item: function(count) {
            return i18n._({
                id: "65yW1y",
                values: {
                    count: count
                }
            });
        },
        unknown: function(type, count) {
            switch(type){
                case "note":
                    return actions.restored.note(count);
                case "notebook":
                    return actions.restored.notebook(count);
                case "item":
                    return actions.restored.item(count);
                default:
                    return i18n._({
                        id: "65yW1y",
                        values: {
                            count: count
                        }
                    });
            }
        }
    },
    edited: {
        tag: function(count) {
            return i18n._({
                id: "FGWi7e",
                values: {
                    count: count
                }
            });
        },
        notebook: function(count) {
            return i18n._({
                id: "m5rWRR",
                values: {
                    count: count
                }
            });
        },
        unknown: function(type, count) {
            switch(type){
                case "tag":
                    return actions.edited.tag(count);
                case "notebook":
                    return actions.edited.notebook(count);
                default:
                    return i18n._({
                        id: "E5iC8J",
                        values: {
                            count: count
                        }
                    });
            }
        }
    },
    created: {
        notebook: function(count) {
            return i18n._({
                id: "MDneBL",
                values: {
                    count: count
                }
            });
        },
        tag: function(count) {
            return i18n._({
                id: "8PL9Cx",
                values: {
                    count: count
                }
            });
        },
        shortcut: function(count) {
            return i18n._({
                id: "Gwtknf",
                values: {
                    count: count
                }
            });
        },
        unknown: function(type, count) {
            switch(type){
                case "notebook":
                    return actions.created.notebook(count);
                case "tag":
                    return actions.created.tag(count);
                case "shortcut":
                    return actions.created.shortcut(count);
                default:
                    return i18n._({
                        id: "0v4tMn",
                        values: {
                            count: count
                        }
                    });
            }
        }
    },
    renamed: {
        color: function(count) {
            return i18n._({
                id: "1SheoY",
                values: {
                    count: count
                }
            });
        },
        unknown: function(type, count) {
            switch(type){
                case "color":
                    return actions.renamed.color(count);
                default:
                    return i18n._({
                        id: "Os6JxE",
                        values: {
                            count: count
                        }
                    });
            }
        }
    }
};

/* eslint-disable header/header */ // THIS FILE IS GENERATED. DO NOT EDIT MANUALLY.
var doActions = {
    delete: {
        note: function(count) {
            return i18n._({
                id: "C3uDf7",
                values: {
                    count: count
                }
            });
        },
        item: function(count) {
            return i18n._({
                id: "t1WEgs",
                values: {
                    count: count
                }
            });
        },
        reminder: function(count) {
            return i18n._({
                id: "vKYANA",
                values: {
                    count: count
                }
            });
        },
        notebook: function(count) {
            return i18n._({
                id: "ufAh8R",
                values: {
                    count: count
                }
            });
        },
        tag: function(count) {
            return i18n._({
                id: "cWt/GU",
                values: {
                    count: count
                }
            });
        },
        color: function(count) {
            return i18n._({
                id: "lh0e2s",
                values: {
                    count: count
                }
            });
        },
        attachment: function(count) {
            return i18n._({
                id: "22BQ7P",
                values: {
                    count: count
                }
            });
        },
        unknown: function(type, count) {
            switch(type){
                case "note":
                    return doActions.delete.note(count);
                case "item":
                    return doActions.delete.item(count);
                case "reminder":
                    return doActions.delete.reminder(count);
                case "notebook":
                    return doActions.delete.notebook(count);
                case "tag":
                    return doActions.delete.tag(count);
                case "color":
                    return doActions.delete.color(count);
                case "attachment":
                    return doActions.delete.attachment(count);
                default:
                    return i18n._({
                        id: "t1WEgs",
                        values: {
                            count: count
                        }
                    });
            }
        }
    },
    unpin: {
        note: function(count) {
            return i18n._({
                id: "rQCfht",
                values: {
                    count: count
                }
            });
        },
        notebook: function(count) {
            return i18n._({
                id: "S301dr",
                values: {
                    count: count
                }
            });
        },
        unknown: function(type, count) {
            switch(type){
                case "note":
                    return doActions.unpin.note(count);
                case "notebook":
                    return doActions.unpin.notebook(count);
                default:
                    return i18n._({
                        id: "capYth",
                        values: {
                            count: count
                        }
                    });
            }
        }
    },
    pin: {
        note: function(count) {
            return i18n._({
                id: "eWtqJz",
                values: {
                    count: count
                }
            });
        },
        notebook: function(count) {
            return i18n._({
                id: "l6Cf+n",
                values: {
                    count: count
                }
            });
        },
        unknown: function(type, count) {
            switch(type){
                case "note":
                    return doActions.pin.note(count);
                case "notebook":
                    return doActions.pin.notebook(count);
                default:
                    return i18n._({
                        id: "4sgISV",
                        values: {
                            count: count
                        }
                    });
            }
        }
    },
    unpublish: {
        note: function(count) {
            return i18n._({
                id: "Byxf7B",
                values: {
                    count: count
                }
            });
        },
        unknown: function(type, count) {
            switch(type){
                case "note":
                    return doActions.unpublish.note(count);
                default:
                    return i18n._({
                        id: "9WMYC7",
                        values: {
                            count: count
                        }
                    });
            }
        }
    },
    publish: {
        note: function(count) {
            return i18n._({
                id: "ANK6aV",
                values: {
                    count: count
                }
            });
        },
        unknown: function(type, count) {
            switch(type){
                case "note":
                    return doActions.publish.note(count);
                default:
                    return i18n._({
                        id: "QHqNXq",
                        values: {
                            count: count
                        }
                    });
            }
        }
    },
    permanentlyDelete: {
        attachment: function(count) {
            return i18n._({
                id: "eTsOe4",
                values: {
                    count: count
                }
            });
        },
        item: function(count) {
            return i18n._({
                id: "KZWFOw",
                values: {
                    count: count
                }
            });
        },
        unknown: function(type, count) {
            switch(type){
                case "attachment":
                    return doActions.permanentlyDelete.attachment(count);
                case "item":
                    return doActions.permanentlyDelete.item(count);
                default:
                    return i18n._({
                        id: "KZWFOw",
                        values: {
                            count: count
                        }
                    });
            }
        }
    },
    restore: {
        note: function(count) {
            return i18n._({
                id: "s9y1OW",
                values: {
                    count: count
                }
            });
        },
        notebook: function(count) {
            return i18n._({
                id: "wBpj8b",
                values: {
                    count: count
                }
            });
        },
        unknown: function(type, count) {
            switch(type){
                case "note":
                    return doActions.restore.note(count);
                case "notebook":
                    return doActions.restore.notebook(count);
                default:
                    return i18n._({
                        id: "/weMW8",
                        values: {
                            count: count
                        }
                    });
            }
        }
    },
    edit: {
        tag: function(count) {
            return i18n._({
                id: "Ky2x7H",
                values: {
                    count: count
                }
            });
        },
        notebook: function(count) {
            return i18n._({
                id: "kHPTAp",
                values: {
                    count: count
                }
            });
        },
        reminder: function(count) {
            return i18n._({
                id: "Lggf3/",
                values: {
                    count: count
                }
            });
        },
        unknown: function(type, count) {
            switch(type){
                case "tag":
                    return doActions.edit.tag(count);
                case "notebook":
                    return doActions.edit.notebook(count);
                case "reminder":
                    return doActions.edit.reminder(count);
                default:
                    return i18n._({
                        id: "tIStHm",
                        values: {
                            count: count
                        }
                    });
            }
        }
    },
    rename: {
        attachment: function(count) {
            return i18n._({
                id: "7wZiT+",
                values: {
                    count: count
                }
            });
        },
        color: function(count) {
            return i18n._({
                id: "z8rjg9",
                values: {
                    count: count
                }
            });
        },
        tag: function(count) {
            return i18n._({
                id: "JGWvIt",
                values: {
                    count: count
                }
            });
        },
        unknown: function(type, count) {
            switch(type){
                case "attachment":
                    return doActions.rename.attachment(count);
                case "color":
                    return doActions.rename.color(count);
                case "tag":
                    return doActions.rename.tag(count);
                default:
                    return i18n._({
                        id: "L+483j",
                        values: {
                            count: count
                        }
                    });
            }
        }
    },
    remove: {
        shortcut: function(count) {
            return i18n._({
                id: "einuaI",
                values: {
                    count: count
                }
            });
        },
        color: function(count) {
            return i18n._({
                id: "B+WXHr",
                values: {
                    count: count
                }
            });
        },
        attachment: function(count) {
            return i18n._({
                id: "aEUZSH",
                values: {
                    count: count
                }
            });
        },
        unknown: function(type, count) {
            switch(type){
                case "shortcut":
                    return doActions.remove.shortcut(count);
                case "color":
                    return doActions.remove.color(count);
                case "attachment":
                    return doActions.remove.attachment(count);
                default:
                    return i18n._({
                        id: "hf9Bpx",
                        values: {
                            count: count
                        }
                    });
            }
        }
    },
    download: {
        attachment: function(count) {
            return i18n._({
                id: "ie/kCj",
                values: {
                    count: count
                }
            });
        },
        unknown: function(type, count) {
            switch(type){
                case "attachment":
                    return doActions.download.attachment(count);
                default:
                    return i18n._({
                        id: "XAdhKR",
                        values: {
                            count: count
                        }
                    });
            }
        }
    }
};

/* eslint-disable header/header */ // THIS FILE IS GENERATED. DO NOT EDIT MANUALLY.
var inProgressActions = {
    deleting: {
        note: function(count) {
            return i18n._({
                id: "8jxqqg",
                values: {
                    count: count
                }
            });
        },
        notebook: function(count) {
            return i18n._({
                id: "BQWwx9",
                values: {
                    count: count
                }
            });
        },
        attachment: function(count) {
            return i18n._({
                id: "hr7Bu7",
                values: {
                    count: count
                }
            });
        },
        tag: function(count) {
            return i18n._({
                id: "Uigeho",
                values: {
                    count: count
                }
            });
        },
        reminder: function(count) {
            return i18n._({
                id: "rgX0id",
                values: {
                    count: count
                }
            });
        },
        unknown: function(type, count) {
            switch(type){
                case "note":
                    return inProgressActions.deleting.note(count);
                case "notebook":
                    return inProgressActions.deleting.notebook(count);
                case "attachment":
                    return inProgressActions.deleting.attachment(count);
                case "tag":
                    return inProgressActions.deleting.tag(count);
                case "reminder":
                    return inProgressActions.deleting.reminder(count);
                default:
                    return i18n._({
                        id: "MyVK4r",
                        values: {
                            count: count
                        }
                    });
            }
        }
    },
    restoring: {
        item: function(count) {
            return i18n._({
                id: "yIEa20",
                values: {
                    count: count
                }
            });
        },
        unknown: function(type, count) {
            switch(type){
                case "item":
                    return inProgressActions.restoring.item(count);
                default:
                    return i18n._({
                        id: "yIEa20",
                        values: {
                            count: count
                        }
                    });
            }
        }
    },
    permanentlyDeleting: {
        item: function(count) {
            return i18n._({
                id: "sD/DC7",
                values: {
                    count: count
                }
            });
        },
        unknown: function(type, count) {
            switch(type){
                case "item":
                    return inProgressActions.permanentlyDeleting.item(count);
                default:
                    return i18n._({
                        id: "sD/DC7",
                        values: {
                            count: count
                        }
                    });
            }
        }
    }
};

var SEARCH_IN_ROUTE_STRINGS = {
    Notes: function() {
        return i18n._({
            id: "wjJziS"
        });
    },
    Notebooks: function() {
        return i18n._({
            id: "+mOqzq"
        });
    },
    Notebook: function() {
        return i18n._({
            id: "RMWnOQ"
        });
    },
    Favorites: function() {
        return i18n._({
            id: "+WsHF1"
        });
    },
    Reminders: function() {
        return i18n._({
            id: "FuMujC"
        });
    },
    Trash: function() {
        return i18n._({
            id: "tVu5u9"
        });
    },
    Settings: function() {
        return i18n._({
            id: "e9ibLf"
        });
    },
    Tags: function() {
        return i18n._({
            id: "I/8qJ7"
        });
    },
    Editor: function() {
        return i18n._({
            id: "Rvxhg0"
        });
    },
    Home: function() {
        return i18n._({
            id: "KsVGx3"
        });
    },
    Search: function() {
        return i18n._({
            id: "2Iof/y"
        });
    },
    Monographs: function() {
        return i18n._({
            id: "oefTVd"
        });
    }
};
var TRANSACTION_STATUS = {
    completed: function() {
        return i18n._({
            id: "qqWcBV"
        });
    },
    refunded: function() {
        return i18n._({
            id: "On6jZJ"
        });
    },
    partially_refunded: function() {
        return i18n._({
            id: "pewEtW"
        });
    },
    disputed: function() {
        return i18n._({
            id: "bVKTQK"
        });
    }
};
var REMINDER_NOTIFICATION_MODES = {
    Silent: function() {
        return i18n._({
            id: "i2CkSD"
        });
    },
    Vibrate: function() {
        return i18n._({
            id: "7vL4t6"
        });
    },
    Urgent: function() {
        return i18n._({
            id: "BBUDfW"
        });
    }
};
var strings = {
    done: function() {
        return i18n._({
            id: "DPfwMq"
        });
    },
    verifyItsYou: function() {
        return i18n._({
            id: "tMpGOk"
        });
    },
    unlockNotes: function() {
        return i18n._({
            id: "56xXKG"
        });
    },
    note: function() {
        return i18n._({
            id: "KiJn9B"
        });
    },
    notes: function(count) {
        return i18n._({
            id: "HXKIJE",
            values: {
                count: count
            }
        });
    },
    downloading: function() {
        return i18n._({
            id: "9hg9mc"
        });
    },
    uploading: function() {
        return i18n._({
            id: "/eguJc"
        });
    },
    networkProgress: function(type) {
        return i18n._({
            id: "Q1k+wB",
            values: {
                type: type
            }
        });
    },
    tapToCancel: function() {
        return i18n._({
            id: "2of4KX"
        });
    },
    attachmentsDownloadFailed: function(count) {
        return i18n._({
            id: "d/CVyy",
            values: {
                count: count
            }
        });
    },
    attachmentsDownloaded: function(count, total, path) {
        return i18n._({
            id: "ynMDD7",
            values: {
                count: count,
                path: path,
                total: total
            }
        });
    },
    downloadAllAttachmentsConfirmation: function(count) {
        return i18n._({
            id: "ncYCaj",
            values: {
                count: count
            }
        });
    },
    noDownloads: function() {
        return i18n._({
            id: "oJ+jXF"
        });
    },
    noAttachments: function() {
        return i18n._({
            id: "74Qsfb"
        });
    },
    attachmentsEncryptedNote: function() {
        return i18n._({
            id: "gIWSTe"
        });
    },
    recoveryEmailSent: function() {
        return i18n._({
            id: "VyLw2+"
        });
    },
    recoveryEmailSentDesc: function() {
        return i18n._({
            id: "ByuUqf"
        });
    },
    dontHaveAccount: function() {
        return i18n._({
            id: "ln9/n9"
        });
    },
    signUp: function() {
        return i18n._({
            id: "e+RpCP"
        });
    },
    sessionExpired: function() {
        return i18n._({
            id: "gs/Yn6"
        });
    },
    sessionExpiredDesc: function(obfuscatedEmail) {
        return i18n._({
            id: "VH1nub",
            values: {
                obfuscatedEmail: obfuscatedEmail
            }
        });
    },
    signupAgreement: {
        0: function() {
            return i18n._({
                id: "uwd8ju"
            });
        },
        1: function() {
            return i18n._({
                id: "ExHQ+r"
            });
        },
        2: function() {
            return i18n._({
                id: "Z45eNi"
            });
        },
        3: function() {
            return i18n._({
                id: "NTN5VL"
            });
        },
        4: function() {
            return i18n._({
                id: "WzzT4o"
            });
        }
    },
    alreadyHaveAccount: function() {
        return i18n._({
            id: "8wYDMp"
        });
    },
    login: function() {
        return i18n._({
            id: "z0t9bb"
        });
    },
    "2fa": function() {
        return i18n._({
            id: "0s6zAM"
        });
    },
    select2faMethod: function() {
        return i18n._({
            id: "6OvXSV"
        });
    },
    select2faCodeHelpText: function() {
        return i18n._({
            id: "StTvyH"
        });
    },
    "2faCodeHelpText": {
        email: function() {
            return i18n._({
                id: "b/vS39"
            });
        },
        sms: function() {
            return i18n._({
                id: "ILztWe"
            });
        },
        app: function() {
            return i18n._({
                id: "czZONw"
            });
        },
        recoveryCode: function() {
            return i18n._({
                id: "3G+ZIw"
            });
        }
    },
    "2faCodeSecondaryMethodText": {
        email: function() {
            return i18n._({
                id: "aQkZm3"
            });
        },
        sms: function() {
            return i18n._({
                id: "P9m8YI"
            });
        },
        app: function() {
            return i18n._({
                id: "0Bj3Py"
            });
        },
        recoveryCode: function() {
            return i18n._({
                id: "WpU43s"
            });
        }
    },
    resend2faCode: function(seconds) {
        return i18n._({
            id: "ta1Q39",
            values: {
                seconds: seconds
            }
        });
    },
    sendCode: function() {
        return i18n._({
            id: "pfwAG5"
        });
    },
    sendCodeSms: function() {
        return i18n._({
            id: "sZT6ud"
        });
    },
    sendCodeEmail: function() {
        return i18n._({
            id: "AvHsBZ"
        });
    },
    authAppCode: function() {
        return i18n._({
            id: "feIvVG"
        });
    },
    recoveryCode: function() {
        return i18n._({
            id: "HWBTt0"
        });
    },
    attachImageHeading: function(count) {
        return i18n._({
            id: "neJM1S",
            values: {
                count: count
            }
        });
    },
    compress: function() {
        return i18n._({
            id: "vsF0B5"
        });
    },
    recommended: function() {
        return i18n._({
            id: "WEYdDv"
        });
    },
    compressionOffNotice: function() {
        return i18n._({
            id: "aurWmg"
        });
    },
    compressionOnNotice: function() {
        return i18n._({
            id: "amN3VM"
        });
    },
    loadingWithProgress: function(progress) {
        return i18n._({
            id: "2TD+hm",
            values: {
                0: progress ? "(".concat(progress, ")") : ""
            }
        });
    },
    vaultEnableBiometrics: function() {
        return i18n._({
            id: "8LPVho"
        });
    },
    deleteVault: function() {
        return i18n._({
            id: "VETTKy"
        });
    },
    clearVault: function() {
        return i18n._({
            id: "t0HtK8"
        });
    },
    enable: function() {
        return i18n._({
            id: "PaQ3df"
        });
    },
    revoke: function() {
        return i18n._({
            id: "GXsAby"
        });
    },
    change: function() {
        return i18n._({
            id: "o+XJ9D"
        });
    },
    delete: function() {
        return i18n._({
            id: "cnGeoo"
        });
    },
    share: function() {
        return i18n._({
            id: "Z8lGw6"
        });
    },
    open: function() {
        return i18n._({
            id: "1TNIig"
        });
    },
    unlock: function() {
        return i18n._({
            id: "VAOn4r"
        });
    },
    create: function() {
        return i18n._({
            id: "hYgDIe"
        });
    },
    lock: function() {
        return i18n._({
            id: "HD2Tiz"
        });
    },
    analyticsPermissionText: {
        0: function() {
            return i18n._({
                id: "Sq1wu7"
            });
        },
        1: function() {
            return i18n._({
                id: "7CZ2e4"
            });
        }
    },
    deletedOn: function(date) {
        return i18n._({
            id: "ySuYai",
            values: {
                date: date
            }
        });
    },
    disabled: function() {
        return i18n._({
            id: "E/QGRL"
        });
    },
    reminderRecurringMode: {
        day: function() {
            return i18n._({
                id: "U0sC6H"
            });
        },
        week: function() {
            return i18n._({
                id: "4XSc4l"
            });
        },
        month: function() {
            return i18n._({
                id: "+8Nek/"
            });
        },
        year: function() {
            return i18n._({
                id: "zkWmBh"
            });
        }
    },
    mergeConflict: {
        thisDevice: function() {
            return i18n._({
                id: "pmDHTY"
            });
        },
        otherDevice: function() {
            return i18n._({
                id: "RAMaAx"
            });
        }
    },
    noteHistoryPlaceholder: function() {
        return i18n._({
            id: "qmJCeg"
        });
    },
    noteHistoryNotice: {
        0: function() {
            return i18n._({
                id: "QcZo2W"
            });
        },
        1: function() {
            return i18n._({
                id: "iIGna8"
            });
        }
    },
    encryptedNoteHistoryNotice: function() {
        return i18n._({
            id: "ax/1Le"
        });
    },
    dateDescFromKey: function(key) {
        return i18n._({
            id: "iMwv4b",
            values: {
                key: key
            }
        });
    },
    noNotePropertiesNotice: function() {
        return i18n._({
            id: "B0jdqU"
        });
    },
    noteSyncedNoticeHeading: function() {
        return i18n._({
            id: "iWRZGn"
        });
    },
    noteSyncedNoticeDesc: function(type) {
        return i18n._({
            id: "Ow4uoX",
            values: {
                type: type
            }
        });
    },
    emptyPlaceholders: function(type) {
        return i18n._({
            id: "O5hEZ6",
            values: {
                type: type
            }
        });
    },
    untitledNote: function() {
        return i18n._({
            id: "wja8aL"
        });
    },
    newNote: function() {
        return i18n._({
            id: "zPPcuu"
        });
    },
    exportingNotes: function(status) {
        return i18n._({
            id: "J/hVSQ",
            values: {
                0: status ? status : "Exporting notes"
            }
        });
    },
    exportingNotesDesc: function() {
        return i18n._({
            id: "SsO6tU"
        });
    },
    exportingNote: function(title) {
        return i18n._({
            id: "u5anvV",
            values: {
                title: title
            }
        });
    },
    exportingNoteDesc: function() {
        return i18n._({
            id: "PesdBY"
        });
    },
    exportSuccessHeading: function(count) {
        return i18n._({
            id: "mvb9eS",
            values: {
                count: count
            }
        });
    },
    exportSuccessDesc: function(path) {
        return i18n._({
            id: "A9fS0D",
            values: {
                path: path
            }
        });
    },
    issueCreatedHeading: function() {
        return i18n._({
            id: "ST1eyI"
        });
    },
    issueCreatedDesc: {
        0: function() {
            return i18n._({
                id: "PMd0Z4"
            });
        },
        1: function() {
            return i18n._({
                id: "X5nItz"
            });
        }
    },
    issueNotice: {
        0: function() {
            return i18n._({
                id: "KBw8KH"
            });
        },
        1: function() {
            return i18n._({
                id: "hHp7aA"
            });
        },
        2: function() {
            return i18n._({
                id: "XxLsog"
            });
        }
    },
    linkNoteEmptyBlock: function() {
        return i18n._({
            id: "S323kL"
        });
    },
    linkNoteSelectedNote: function() {
        return i18n._({
            id: "zPms4Y"
        });
    },
    tapToDeselect: function() {
        return i18n._({
            id: "Mz4qSC"
        });
    },
    clickToDeselect: function() {
        return i18n._({
            id: "si/GPd"
        });
    },
    linkNoteToSection: function() {
        return i18n._({
            id: "/reUPB"
        });
    },
    migrationProgress: function(progress) {
        return i18n._({
            id: "rexar8",
            values: {
                0: progress ? "".concat(progress === null || progress === void 0 ? void 0 : progress.collection) : "",
                1: progress ? "(".concat(progress.current, "/").concat(progress.total, ") ") : ""
            }
        });
    },
    migrationError: function() {
        return i18n._({
            id: "osKN+g"
        });
    },
    migrationAppReset: function() {
        return i18n._({
            id: "b+PCA3"
        });
    },
    migrationErrorNotice: function() {
        return [
            i18n._({
                id: "c7Ly3h"
            }),
            i18n._({
                id: "8JBMrW"
            })
        ];
    },
    migrationFailed: function() {
        return i18n._({
            id: "n+9S/a"
        });
    },
    notebooks: function() {
        return i18n._({
            id: "jpeU/Z"
        });
    },
    syncingHeading: function() {
        return i18n._({
            id: "5g8jp2"
        });
    },
    syncingDesc: function() {
        return i18n._({
            id: "hhtvVa"
        });
    },
    downloadingAttachments: function() {
        return i18n._({
            id: "uVBZ/c"
        });
    },
    pleaseWait: function() {
        return i18n._({
            id: "tnHeOD"
        });
    },
    publishedAt: function() {
        return i18n._({
            id: "stjfz2"
        });
    },
    monographDesc: function() {
        return i18n._({
            id: "NgmAXu"
        });
    },
    openInBrowser: function() {
        return i18n._({
            id: "ZdWg0V"
        });
    },
    monographPassHeading: function() {
        return i18n._({
            id: "U0iwUz"
        });
    },
    monographPassDesc: function() {
        return i18n._({
            id: "WTE+LW"
        });
    },
    monographSelfDestructHeading: function() {
        return i18n._({
            id: "dx3CIt"
        });
    },
    monographSelfDestructDesc: function() {
        return i18n._({
            id: "aVL30r"
        });
    },
    monographLearnMore: function() {
        return i18n._({
            id: "ac2kDi"
        });
    },
    rateAppHeading: function() {
        return i18n._({
            id: "eFw1GE"
        });
    },
    rateAppDesc: function() {
        return i18n._({
            id: "T+ZINb"
        });
    },
    recoveryKeySavedConfirmation: function() {
        return i18n._({
            id: "uShxqr"
        });
    },
    noBlocksLinked: function() {
        return i18n._({
            id: "K59bWR"
        });
    },
    noReferencesFound: function() {
        return i18n._({
            id: "kZgbDW"
        });
    },
    notReferenced: function() {
        return i18n._({
            id: "tHxoBA"
        });
    },
    notLinked: function() {
        return i18n._({
            id: "ST5WKu"
        });
    },
    noLinksFound: function() {
        return i18n._({
            id: "uK1HcQ"
        });
    },
    noBlocksOnNote: function() {
        return i18n._({
            id: "wEO8Sz"
        });
    },
    dataTypes: {
        note: function() {
            return i18n._({
                id: "/hpEcX"
            });
        },
        notebook: function() {
            return i18n._({
                id: "nL1HM8"
            });
        },
        tag: function() {
            return i18n._({
                id: "jbrkB6"
            });
        },
        reminder: function() {
            return i18n._({
                id: "Jnrsqd"
            });
        },
        color: function() {
            return i18n._({
                id: "jOVHrX"
            });
        },
        attachment: function() {
            return i18n._({
                id: "MZLSHw"
            });
        },
        item: function() {
            return i18n._({
                id: "/uUlFU"
            });
        },
        shortcut: function() {
            return i18n._({
                id: "EDl6kE"
            });
        }
    },
    dataTypesCamelCase: {
        note: function() {
            return i18n._({
                id: "KiJn9B"
            });
        },
        notebook: function() {
            return i18n._({
                id: "jZh/Kp"
            });
        },
        tag: function() {
            return i18n._({
                id: "UL8A9w"
            });
        },
        reminder: function() {
            return i18n._({
                id: "/kpR4w"
            });
        },
        color: function() {
            return i18n._({
                id: "jZlrte"
            });
        },
        attachment: function() {
            return i18n._({
                id: "UY1vmE"
            });
        },
        item: function() {
            return i18n._({
                id: "HX5SVx"
            });
        },
        shortcut: function() {
            return i18n._({
                id: "8uA5Jn"
            });
        }
    },
    dataTypesPlural: {
        note: function() {
            return i18n._({
                id: "H+4oh7"
            });
        },
        notebook: function() {
            return i18n._({
                id: "te9guM"
            });
        },
        tag: function() {
            return i18n._({
                id: "pTyA/t"
            });
        },
        reminder: function() {
            return i18n._({
                id: "L1Oq1m"
            });
        },
        color: function() {
            return i18n._({
                id: "bb/24t"
            });
        },
        attachment: function() {
            return i18n._({
                id: "qmtY3J"
            });
        },
        item: function() {
            return i18n._({
                id: "hgr8eo"
            });
        },
        shortcut: function() {
            return i18n._({
                id: "IVp41R"
            });
        }
    },
    dataTypesPluralCamelCase: {
        note: function() {
            return i18n._({
                id: "1DBGsz"
            });
        },
        notebook: function() {
            return i18n._({
                id: "jpeU/Z"
            });
        },
        tag: function() {
            return i18n._({
                id: "OYHzN1"
            });
        },
        reminder: function() {
            return i18n._({
                id: "crwali"
            });
        },
        color: function() {
            return i18n._({
                id: "1HfW/F"
            });
        },
        attachment: function() {
            return i18n._({
                id: "w/Sphq"
            });
        },
        favorite: function() {
            return i18n._({
                id: "X9kySA"
            });
        },
        monograph: function() {
            return i18n._({
                id: "onn9nd"
            });
        },
        item: function() {
            return i18n._({
                id: "BzfzPK"
            });
        },
        shortcut: function() {
            return i18n._({
                id: "CTqTgr"
            });
        }
    },
    addItem: function(itemType) {
        return i18n._({
            id: "FUicPM",
            values: {
                itemType: itemType
            }
        });
    },
    reminderRepeatStrings: {
        day: function(date) {
            return i18n._({
                id: "4H9kjD",
                values: {
                    date: date
                }
            });
        },
        week: {
            daily: function(date) {
                return i18n._({
                    id: "7iobiM",
                    values: {
                        date: date
                    }
                });
            },
            selectDays: function() {
                return i18n._({
                    id: "N9RTjT"
                });
            }
        },
        year: function(date) {
            return i18n._({
                id: "d5N0Ne",
                values: {
                    date: date
                }
            });
        },
        month: {
            selectDays: function() {
                return i18n._({
                    id: "W4ZISR"
                });
            }
        },
        repeats: function(freq, mode, selectedDays, date) {
            var strings = {
                day: i18n._({
                    id: "SfQCPL",
                    values: {
                        freq: freq,
                        selectedDays: selectedDays,
                        date: date
                    }
                }),
                week: i18n._({
                    id: "pMEOfB",
                    values: {
                        freq: freq,
                        selectedDays: selectedDays,
                        date: date
                    }
                }),
                month: i18n._({
                    id: "moka2d",
                    values: {
                        freq: freq,
                        selectedDays: selectedDays,
                        date: date
                    }
                }),
                year: i18n._({
                    id: "m1ZCYL",
                    values: {
                        freq: freq,
                        selectedDays: selectedDays,
                        date: date
                    }
                })
            };
            return strings[mode];
        }
    },
    remindMeIn: function() {
        return i18n._({
            id: "PWWzbC"
        });
    },
    referencedIn: function() {
        return i18n._({
            id: "nzV3KU"
        });
    },
    restoreSelectFolder: function() {
        return i18n._({
            id: "RqWeYz"
        });
    },
    noBackupsFound: function() {
        return i18n._({
            id: "Ns5WaC"
        });
    },
    restoring: function() {
        return i18n._({
            id: "oajJTs"
        });
    },
    restoringCollection: function(collection) {
        return i18n._({
            id: "0Mbx2O",
            values: {
                collection: collection
            }
        });
    },
    checkNewVersion: function() {
        return i18n._({
            id: "4nrGjG"
        });
    },
    noUpdates: function() {
        return i18n._({
            id: "WcOvFp"
        });
    },
    updateAvailable: function() {
        return i18n._({
            id: "CifUuG"
        });
    },
    versionReleased: function(version, type) {
        return i18n._({
            id: "+sc1Cu",
            values: {
                type: type,
                version: version
            }
        });
    },
    readReleaseNotes: function() {
        return i18n._({
            id: "g+9cGo"
        });
    },
    settings: function() {
        return i18n._({
            id: "Tz0i8g"
        });
    },
    notLoggedIn: function() {
        return i18n._({
            id: "wMP6DT"
        });
    },
    loggedInAs: function(email) {
        return i18n._({
            id: "R4xK3J",
            values: {
                email: email
            }
        });
    },
    never: function() {
        return i18n._({
            id: "qqeAJM"
        });
    },
    syncing: function() {
        return i18n._({
            id: "EHu0x2"
        });
    },
    syncNow: function() {
        return i18n._({
            id: "lb/UU4"
        });
    },
    syncFailed: function() {
        return i18n._({
            id: "5TRY4+"
        });
    },
    synced: function() {
        return i18n._({
            id: "N2FcBE"
        });
    },
    offline: function() {
        return i18n._({
            id: "6Aih4U"
        });
    },
    editorFailedToLoad: function() {
        return i18n._({
            id: "Ibsk3H"
        });
    },
    gettingInformation: function() {
        return i18n._({
            id: "529IUo"
        });
    },
    enterSixDigitCode: function() {
        return i18n._({
            id: "A2VYSE"
        });
    },
    gettingRecoveryCodes: function() {
        return i18n._({
            id: "uJsztd"
        });
    },
    protectNotes: function() {
        return i18n._({
            id: "IQmesU"
        });
    },
    protectNotesDesc: function() {
        return i18n._({
            id: "ekObA0"
        });
    },
    loggingOut: function() {
        return i18n._({
            id: "fiGtWI"
        });
    },
    loggingOutDesc: function() {
        return i18n._({
            id: "N3lnKo"
        });
    },
    by: function() {
        return i18n._({
            id: "g+0MOn"
        });
    },
    noResultsForSearch: function(query) {
        return i18n._({
            id: "fOlAiK",
            values: {
                query: query
            }
        });
    },
    results: function(count) {
        return i18n._({
            id: "c4xQje",
            values: {
                count: count
            }
        });
    },
    noThemesFound: function() {
        return i18n._({
            id: "iHlcZh"
        });
    },
    errorLoadingThemes: function() {
        return i18n._({
            id: "sNm5dY"
        });
    },
    loadingThemes: function() {
        return i18n._({
            id: "DU0YtB"
        });
    },
    version: function() {
        return i18n._({
            id: "eE0JZ4"
        });
    },
    visitHomePage: function() {
        return i18n._({
            id: "Oc9/Is"
        });
    },
    tapToApplyAgain: function() {
        return i18n._({
            id: "66axBO"
        });
    },
    titleFormattingGuide: function() {
        return i18n._({
            id: "xS24ni"
        });
    },
    setYourName: function() {
        return i18n._({
            id: "h8mqWZ"
        });
    },
    presets: function() {
        return i18n._({
            id: "7RRujh"
        });
    },
    group: function() {
        return i18n._({
            id: "CY1KRk"
        });
    },
    groupedAllTools: function() {
        return i18n._({
            id: "g+NcGh"
        });
    },
    collapsed: function() {
        return i18n._({
            id: "M0bJFa"
        });
    },
    releaseNotes: function() {
        return i18n._({
            id: "/PACVa"
        });
    },
    passTooShort: function() {
        return i18n._({
            id: "U8mL/+"
        });
    },
    changePassword: function() {
        return i18n._({
            id: "GptGxg"
        });
    },
    accountRecovery: function() {
        return i18n._({
            id: "Fl0IbO"
        });
    },
    changeAppLockCredentials: function(mode, keyboardType) {
        return i18n._({
            id: "gEsM5Y",
            values: {
                mode: mode,
                keyboardType: keyboardType
            }
        });
    },
    createVault: function() {
        return i18n._({
            id: "NXxgNF"
        });
    },
    createVaultDesc: function() {
        return i18n._({
            id: "W0sv2f"
        });
    },
    vaultFingerprintUnlock: function() {
        return i18n._({
            id: "d6vy+t"
        });
    },
    revokeVaultFingerprintUnlock: function() {
        return i18n._({
            id: "oLPYky"
        });
    },
    changeVaultPassword: function() {
        return i18n._({
            id: "a+KjSd"
        });
    },
    deleteNote: function() {
        return doActions.delete.note(1);
    },
    shareNote: function() {
        return i18n._({
            id: "ZsMb6x"
        });
    },
    copyNote: function() {
        return i18n._({
            id: "unT7Am"
        });
    },
    goToEditor: function() {
        return i18n._({
            id: "sAV0yu"
        });
    },
    lockNote: function() {
        return i18n._({
            id: "f+jiV5"
        });
    },
    applyChanges: function() {
        return i18n._({
            id: "PWh9Ii"
        });
    },
    noteHistory: function() {
        return i18n._({
            id: "F/HfqE"
        });
    },
    selectNotebooks: function() {
        return i18n._({
            id: "M5HhaQ"
        });
    },
    selectNotebooksDesc: function() {
        return i18n._({
            id: "GdOnQN"
        });
    },
    selectNotebooksDesktopDesc: function(keyboardShortcut) {
        return i18n._({
            id: "JnTgG7",
            values: {
                keyboardShortcut: keyboardShortcut
            }
        });
    },
    enableMultiSelect: function() {
        return i18n._({
            id: "WY5SZA"
        });
    },
    changeEmail: function() {
        return i18n._({
            id: "pKCfXD"
        });
    },
    changeEmailDesc: function() {
        return i18n._({
            id: "TiV66Z"
        });
    },
    changeEmailNotice: function() {
        return i18n._({
            id: "LGwHtx"
        });
    },
    export: function() {
        return i18n._({
            id: "GS+Mus"
        });
    },
    exportNotes: function(notes) {
        return i18n._({
            id: "QQZZ/c",
            values: {
                notes: notes
            }
        });
    },
    issueTitle: function() {
        return i18n._({
            id: "k5vWBJ"
        });
    },
    issueDesc: function() {
        return i18n._({
            id: "8Vcbml"
        });
    },
    issueDesc2: function() {
        return i18n._({
            id: "dXtNw0"
        });
    },
    migrationSaveBackup: function() {
        return i18n._({
            id: "t7olqr"
        });
    },
    migrationSaveBackupDesc: function() {
        return i18n._({
            id: "C4dxeS"
        });
    },
    moveNotebook: function(count, title) {
        return i18n._({
            id: "Krni3b",
            values: {
                count: count,
                title: title
            }
        });
    },
    addNotesToNotebook: function(title) {
        return i18n._({
            id: "IctgSR",
            values: {
                title: title
            }
        });
    },
    publish: function() {
        return i18n._({
            id: "EEYbdt"
        });
    },
    publishNote: function() {
        return i18n._({
            id: "Lcru59"
        });
    },
    publishNoteDesc: function() {
        return i18n._({
            id: "lq32q5"
        });
    },
    saveRecoveryKey: function() {
        return i18n._({
            id: "0J1Go8"
        });
    },
    saveRecoveryKeyDesc: function() {
        return i18n._({
            id: "kgadg1"
        });
    },
    backups: function() {
        return i18n._({
            id: "llDXYJ"
        });
    },
    twoFactorAuth: function() {
        return i18n._({
            id: "EIU345"
        });
    },
    twoFactorAuthDesc: function() {
        return i18n._({
            id: "dKJR5o"
        });
    },
    saveRecoveryCodes: function() {
        return i18n._({
            id: "RSbH5D"
        });
    },
    saveRecoveryCodesDesc: function() {
        return i18n._({
            id: "2TCAkO"
        });
    },
    fallbackMethodEnabled: function() {
        return i18n._({
            id: "NaESCu"
        });
    },
    accountIsSecure: function() {
        return i18n._({
            id: "MbKrD5"
        });
    },
    twoFactorAuthEnabled: function() {
        return i18n._({
            id: "qwpE/S"
        });
    },
    listOf: function() {
        return i18n._({
            id: "lIRIBo"
        });
    },
    network: {
        downloading: function(progress) {
            return progress ? i18n._({
                id: "lL2fRx",
                values: {
                    progress: progress
                }
            }) : i18n._({
                id: "9hg9mc"
            });
        },
        downloaded: function() {
            return i18n._({
                id: "Vv4iDV"
            });
        },
        download: function() {
            return i18n._({
                id: "mzI/c+"
            });
        },
        upload: function() {
            return i18n._({
                id: "ONWvwQ"
            });
        },
        uploaded: function() {
            return i18n._({
                id: "3wG7HI"
            });
        },
        uploading: function() {
            return i18n._({
                id: "/eguJc"
            });
        },
        reupload: function() {
            return i18n._({
                id: "fPT/NQ"
            });
        },
        downloadSuccess: function() {
            return i18n._({
                id: "NABbXG"
            });
        },
        fileDownloaded: function(name) {
            return i18n._({
                id: "3r3eKT",
                values: {
                    0: name || "File"
                }
            });
        },
        dowloadCancelled: function() {
            return i18n._({
                id: "Mt3/fa"
            });
        },
        cancelDownload: function() {
            return i18n._({
                id: "VJWeaG"
            });
        },
        cancelUpload: function() {
            return i18n._({
                id: "k99j0U"
            });
        }
    },
    regenerate: function() {
        return i18n._({
            id: "6exX+8"
        });
    },
    redo: function() {
        return i18n._({
            id: "H3oH0g"
        });
    },
    createYourAccount: function() {
        return i18n._({
            id: "cpE88+"
        });
    },
    pinned: function() {
        return i18n._({
            id: "kNiQp6"
        });
    },
    editNotebook: function() {
        return doActions.edit.notebook(1);
    },
    newNotebook: function() {
        return i18n._({
            id: "awl1li"
        });
    },
    newInternalLink: function() {
        return i18n._({
            id: "1D6ged"
        });
    },
    editInternalLink: function() {
        return i18n._({
            id: "1P1fEz"
        });
    },
    newColor: function() {
        return i18n._({
            id: "Hdi1wJ"
        });
    },
    tabs: function() {
        return i18n._({
            id: "38Or+7"
        });
    },
    add: function() {
        return i18n._({
            id: "m16xKo"
        });
    },
    newVersion: function() {
        return i18n._({
            id: "O3o8ai"
        });
    },
    newVersionHighlights: function(version) {
        return i18n._({
            id: "f94RZV",
            values: {
                0: version ? "v".concat(version, " ") : "New version"
            }
        });
    },
    editReminder: function() {
        return doActions.edit.reminder(1);
    },
    newReminder: function() {
        return i18n._({
            id: "cVlvHe"
        });
    },
    sortBy: function() {
        return i18n._({
            id: "/HgF9q"
        });
    },
    groupBy: function() {
        return i18n._({
            id: "ALoP4W"
        });
    },
    toc: function() {
        return i18n._({
            id: "9FTolD"
        });
    },
    appliedDark: function() {
        return i18n._({
            id: "smNfCR"
        });
    },
    appliedLight: function() {
        return i18n._({
            id: "g5k3/N"
        });
    },
    basic: function() {
        return i18n._({
            id: "0wJVK+"
        });
    },
    loginToYourAccount: function() {
        return i18n._({
            id: "T4zr9t"
        });
    },
    continue: function() {
        return i18n._({
            id: "xGVfLh"
        });
    },
    unlockWithBiometrics: function() {
        return i18n._({
            id: "75N2tE"
        });
    },
    fileCheck: function() {
        return i18n._({
            id: "FEtfps"
        });
    },
    rename: function() {
        return i18n._({
            id: "2wxgft"
        });
    },
    no: function() {
        return i18n._({
            id: "1UzENP"
        });
    },
    yes: function() {
        return i18n._({
            id: "l75CjT"
        });
    },
    cancel: function() {
        return i18n._({
            id: "dEgA5A"
        });
    },
    skip: function() {
        return i18n._({
            id: "6Uau97"
        });
    },
    changePasswordConfirm: function() {
        return i18n._({
            id: "5nRXkk"
        });
    },
    next: function() {
        return i18n._({
            id: "hXzOVo"
        });
    },
    forgotPassword: function() {
        return i18n._({
            id: "UNMVei"
        });
    },
    cancelLogin: function() {
        return i18n._({
            id: "wnXe/B"
        });
    },
    logoutFromDevice: function() {
        return i18n._({
            id: "yuPSAu"
        });
    },
    useAccountPassword: function() {
        return i18n._({
            id: "7R6npp"
        });
    },
    addColor: function() {
        return i18n._({
            id: "Fz6khn"
        });
    },
    unlockNote: function() {
        return i18n._({
            id: "sAV0yu"
        });
    },
    couldNotUnlock: function() {
        return i18n._({
            id: "FsYSIB"
        });
    },
    unlockNoteDesc: function() {
        return i18n._({
            id: "cqBGvV"
        });
    },
    deleteAllNotes: function() {
        return i18n._({
            id: "Llxvbi"
        });
    },
    getStarted: function() {
        return i18n._({
            id: "ZDIydz"
        });
    },
    saveACopy: function() {
        return i18n._({
            id: "FuBQJT"
        });
    },
    discard: function() {
        return i18n._({
            id: "bzSI52"
        });
    },
    undo: function() {
        return i18n._({
            id: "9uI/rE"
        });
    },
    keep: function() {
        return i18n._({
            id: "PZ/kxo"
        });
    },
    restore: function() {
        return i18n._({
            id: "yKu/3Y"
        });
    },
    deletePermanently: function() {
        return i18n._({
            id: "AHveU+"
        });
    },
    viewAllLinkedNotebooks: function() {
        return i18n._({
            id: "2DRQ0C"
        });
    },
    learnMore: function() {
        return i18n._({
            id: "zwWKhA"
        });
    },
    addTag: function() {
        return i18n._({
            id: "M5mfAe"
        });
    },
    addTagDesc: function() {
        return i18n._({
            id: "qizPEI"
        });
    },
    save: function() {
        return i18n._({
            id: "tfDRzk"
        });
    },
    verify: function() {
        return i18n._({
            id: "uSMfoN"
        });
    },
    newTab: function() {
        return i18n._({
            id: "3YvS+c"
        });
    },
    openFileLocation: function() {
        return i18n._({
            id: "dzKDLw"
        });
    },
    exportAgain: function() {
        return i18n._({
            id: "uFgp/5"
        });
    },
    openIssue: function() {
        return i18n._({
            id: "f3QvKs"
        });
    },
    submit: function() {
        return i18n._({
            id: "hQRttt"
        });
    },
    createLink: function() {
        return i18n._({
            id: "vv176r"
        });
    },
    logoutAndClearData: function() {
        return i18n._({
            id: "PsAT8P"
        });
    },
    saveAndContinue: function() {
        return i18n._({
            id: "UgT6EY"
        });
    },
    moveToTop: function() {
        return i18n._({
            id: "+RIIrS"
        });
    },
    moveSelectedNotes: function() {
        return i18n._({
            id: "N15joT"
        });
    },
    gotIt: function() {
        return i18n._({
            id: "76gPWk"
        });
    },
    unpublish: function() {
        return i18n._({
            id: "4DLZUa"
        });
    },
    update: function() {
        return i18n._({
            id: "EkH9pt"
        });
    },
    rateApp: function() {
        return i18n._({
            id: "YY3QFm"
        });
    },
    later: function() {
        return i18n._({
            id: "FIq1Ba"
        });
    },
    copyToClipboard: function() {
        return i18n._({
            id: "/4gGIX"
        });
    },
    saveQRCode: function() {
        return i18n._({
            id: "UqhMS2"
        });
    },
    saveAsText: function() {
        return i18n._({
            id: "6Yzzpp"
        });
    },
    shareToCloud: function() {
        return i18n._({
            id: "9VOW9m"
        });
    },
    linkedNotes: function() {
        return i18n._({
            id: "UOHrYa"
        });
    },
    noLinkedNotes: function() {
        return i18n._({
            id: "VOe2ZG"
        });
    },
    reminderModes: function(mode) {
        return i18n._({
            id: "z2VHtS",
            values: {
                mode: mode
            }
        });
    },
    recurringModes: function(mode) {
        return i18n._({
            id: "ipdAJN",
            values: {
                mode: mode
            }
        });
    },
    weekDayNames: {
        0: function() {
            return i18n._({
                id: "DBC3t5"
            });
        },
        1: function() {
            return i18n._({
                id: "hty0d5"
            });
        },
        2: function() {
            return i18n._({
                id: "G3myU+"
            });
        },
        3: function() {
            return i18n._({
                id: "VAcXNz"
            });
        },
        4: function() {
            return i18n._({
                id: "kkDQ8m"
            });
        },
        5: function() {
            return i18n._({
                id: "39y5bn"
            });
        },
        6: function() {
            return i18n._({
                id: "+5kO8P"
            });
        }
    },
    weekDayNamesShort: {
        0: function() {
            return i18n._({
                id: "D89zck"
            });
        },
        1: function() {
            return i18n._({
                id: "fpMgHS"
            });
        },
        2: function() {
            return i18n._({
                id: "vq2WxD"
            });
        },
        3: function() {
            return i18n._({
                id: "0f7U0k"
            });
        },
        4: function() {
            return i18n._({
                id: "+FjWgX"
            });
        },
        5: function() {
            return i18n._({
                id: "xVhQZV"
            });
        },
        6: function() {
            return i18n._({
                id: "PiK6Ld"
            });
        }
    },
    selectDate: function() {
        return i18n._({
            id: "SJQM1I"
        });
    },
    reminderNotificationModes: function(mode) {
        return mode in REMINDER_NOTIFICATION_MODES ? REMINDER_NOTIFICATION_MODES[mode]() : mode;
    },
    selectBackupsFolder: function() {
        return i18n._({
            id: "h+mUQe"
        });
    },
    oldNew: function() {
        return i18n._({
            id: "fUQIt6"
        });
    },
    newOld: function() {
        return i18n._({
            id: "AxeM+E"
        });
    },
    latestFirst: function() {
        return i18n._({
            id: "JrNEbw"
        });
    },
    earliestFirst: function() {
        return i18n._({
            id: "8tfcD6"
        });
    },
    mostRelevantFirst: function() {
        return i18n._({
            id: "CFRc4/"
        });
    },
    leastRelevantFirst: function() {
        return i18n._({
            id: "wCNTpe"
        });
    },
    aToZ: function() {
        return i18n._({
            id: "oGcLFq"
        });
    },
    zToA: function() {
        return i18n._({
            id: "In2v7W"
        });
    },
    title: function() {
        return i18n._({
            id: "MHrjPM"
        });
    },
    sortByStrings: {
        dateModified: function() {
            return i18n._({
                id: "HORAJU"
            });
        },
        dateEdited: function() {
            return i18n._({
                id: "0MoRJL"
            });
        },
        dateCreated: function() {
            return i18n._({
                id: "u46WEi"
            });
        },
        title: function() {
            return i18n._({
                id: "MHrjPM"
            });
        },
        dueDate: function() {
            return i18n._({
                id: "XicmhT"
            });
        },
        dateDeleted: function() {
            return i18n._({
                id: "IW7Q+u"
            });
        },
        relevance: function() {
            return i18n._({
                id: "7dZnmw"
            });
        }
    },
    groupByStrings: {
        default: function() {
            return i18n._({
                id: "ovBPCi"
            });
        },
        none: function() {
            return i18n._({
                id: "EdQY6l"
            });
        },
        abc: function() {
            return i18n._({
                id: "vjd87W"
            });
        },
        year: function() {
            return i18n._({
                id: "3PAU4M"
            });
        },
        week: function() {
            return i18n._({
                id: "zx4BuL"
            });
        },
        month: function() {
            return i18n._({
                id: "HajiZl"
            });
        }
    },
    downloadUpdate: function() {
        return i18n._({
            id: "S08Cgg"
        });
    },
    stopReordering: function() {
        return i18n._({
            id: "nb7WFP"
        });
    },
    removeShortcut: function() {
        return doActions.remove.shortcut(1);
    },
    createShortcut: function() {
        return i18n._({
            id: "etpwvw"
        });
    },
    tip: function() {
        return i18n._({
            id: "oDGm7V"
        });
    },
    neverShowAgain: function() {
        return i18n._({
            id: "9C854J"
        });
    },
    skipIntroduction: function() {
        return i18n._({
            id: "t68krd"
        });
    },
    reloadEditor: function() {
        return i18n._({
            id: "qkev3v"
        });
    },
    copy: function() {
        return i18n._({
            id: "he3ygx"
        });
    },
    resendCode: function(seconds) {
        return i18n._({
            id: "N5Mlo1",
            values: {
                0: seconds ? " in ".concat(seconds) : ""
            }
        });
    },
    change2faMethod: function() {
        return i18n._({
            id: "NzpqiT"
        });
    },
    copyCodes: function() {
        return i18n._({
            id: "S9/u59"
        });
    },
    saveToFile: function() {
        return i18n._({
            id: "hD2OQm"
        });
    },
    secondary2faMethod: function() {
        return i18n._({
            id: "vqAcnL"
        });
    },
    confirmEmail: function() {
        return i18n._({
            id: "CMj4hw"
        });
    },
    confirmEmailDesc: function() {
        return i18n._({
            id: "XLr5Yc"
        });
    },
    manageSubDesktop: function() {
        return i18n._({
            id: "4Rjte/"
        });
    },
    resubFromPlaystore: function() {
        return i18n._({
            id: "e/CZum"
        });
    },
    resubToPro: function() {
        return i18n._({
            id: "65CtOS"
        });
    },
    getPro: function() {
        return i18n._({
            id: "wn2wX1"
        });
    },
    monthShort: function() {
        return i18n._({
            id: "pTc/Cy"
        });
    },
    yearShort: function() {
        return i18n._({
            id: "crrqaX"
        });
    },
    subscriptionProviderInfo: {
        0: {
            type: "Streetwriters",
            title: function() {
                return i18n._({
                    id: "M1Rx1V"
                });
            },
            desc: function() {
                return i18n._({
                    id: "ggriBh"
                });
            }
        },
        1: {
            type: "iOS",
            title: function() {
                return i18n._({
                    id: "Vj8x+0"
                });
            },
            desc: function() {
                return i18n._({
                    id: "pd7+fk"
                });
            },
            icon: "ios"
        },
        2: {
            type: "Android",
            title: function() {
                return i18n._({
                    id: "vCUl0h"
                });
            },
            desc: function() {
                return i18n._({
                    id: "nm+F3p"
                });
            },
            icon: "android"
        },
        3: {
            type: "Web",
            title: function() {
                return i18n._({
                    id: "FJgDqJ"
                });
            },
            desc: function() {
                return i18n._({
                    id: "QZA04j"
                });
            },
            icon: "web"
        },
        4: {
            type: "Gift card",
            title: function() {
                return i18n._({
                    id: "xptwHG"
                });
            },
            desc: function() {
                return i18n._({
                    id: "D3fnno"
                });
            }
        }
    },
    dark: function() {
        return i18n._({
            id: "pvnfJD"
        });
    },
    light: function() {
        return i18n._({
            id: "1njn7W"
        });
    },
    all: function() {
        return i18n._({
            id: "N40H+G"
        });
    },
    loadFromFile: function() {
        return i18n._({
            id: "OisMUD"
        });
    },
    setAsDarkTheme: function() {
        return i18n._({
            id: "QKdshy"
        });
    },
    setAsLightTheme: function() {
        return i18n._({
            id: "d8FwpI"
        });
    },
    createAGroup: function() {
        return i18n._({
            id: "A1AdWg"
        });
    },
    fileCheckFailed: function(reason) {
        return i18n._({
            id: "oPOHFj",
            values: {
                reason: reason
            }
        });
    },
    changePasswordNotice: function() {
        return i18n._({
            id: "YulyDH"
        });
    },
    changePasswordNotice2: function() {
        return i18n._({
            id: "UgDCDi"
        });
    },
    sideMenuNotice: function() {
        return i18n._({
            id: "pOLaRR"
        });
    },
    debugNotice: function() {
        return i18n._({
            id: "pNC+HW"
        });
    },
    configureToolbarNotice: function() {
        return i18n._({
            id: "L+Oucc"
        });
    },
    fileSaved: function(name, platform) {
        return i18n._({
            id: "Qf20Vl",
            values: {
                platform: platform,
                name: name
            }
        });
    },
    downloadError: function(message) {
        return i18n._({
            id: "NjEYHc",
            values: {
                message: message
            }
        });
    },
    invalid: function(type) {
        return i18n._({
            id: "+SzzI8",
            values: {
                type: type
            }
        });
    },
    upgradeToPro: function() {
        return i18n._({
            id: "IelE1h"
        });
    },
    fileCheckPassed: function() {
        return i18n._({
            id: "o0gFb/"
        });
    },
    renameFile: function() {
        return i18n._({
            id: "yckias"
        });
    },
    hashCopied: function() {
        return i18n._({
            id: "/cqh2v"
        });
    },
    mediaTypes: {
        all: function() {
            return i18n._({
                id: "3aeN7X"
            });
        },
        image: function() {
            return i18n._({
                id: "an5hVd"
            });
        },
        video: function() {
            return i18n._({
                id: "RKuImK"
            });
        },
        document: function() {
            return i18n._({
                id: "E/muDO"
            });
        },
        orphaned: function() {
            return i18n._({
                id: "UEdTEN"
            });
        },
        errors: function() {
            return i18n._({
                id: "UirGxE"
            });
        },
        audio: function() {
            return i18n._({
                id: "u8NwPJ"
            });
        }
    },
    orphaned: function() {
        return i18n._({
            id: "UEdTEN"
        });
    },
    uploads: function() {
        return i18n._({
            id: "TJhjLh"
        });
    },
    emailNotConfirmed: function() {
        return i18n._({
            id: "pWFH2/"
        });
    },
    emailNotConfirmedDesc: function() {
        return i18n._({
            id: "AH/2mg"
        });
    },
    allFieldsRequired: function() {
        return i18n._({
            id: "8VnPfl"
        });
    },
    allFieldsRequiredDesc: function() {
        return i18n._({
            id: "FgN700"
        });
    },
    backupFailed: function() {
        return i18n._({
            id: "feDSMB"
        });
    },
    passwordChangedSuccessfully: function() {
        return i18n._({
            id: "U7oi4r"
        });
    },
    passwordChangeFailed: function() {
        return i18n._({
            id: "nPIk8v"
        });
    },
    emailRequired: function() {
        return i18n._({
            id: "ZsZeV2"
        });
    },
    recoveryEmailFailed: function() {
        return i18n._({
            id: "MxgfX0"
        });
    },
    logoutDesc: function() {
        return i18n._({
            id: "szvalF"
        });
    },
    logout: function() {
        return i18n._({
            id: "nOhz3x"
        });
    },
    signupFailed: function() {
        return i18n._({
            id: "BQBr9J"
        });
    },
    loginFailed: function() {
        return i18n._({
            id: "4GKuCs"
        });
    },
    loginSuccess: function() {
        return i18n._({
            id: "6cPKtu"
        });
    },
    loginSuccessDesc: function(email) {
        return i18n._({
            id: "Zm5KFb",
            values: {
                email: email
            }
        });
    },
    applockDisabled: function() {
        return i18n._({
            id: "r1Q6sc"
        });
    },
    remove: function() {
        return i18n._({
            id: "t/YqKh"
        });
    },
    passwordIncorrect: function() {
        return i18n._({
            id: "QLXOgb"
        });
    },
    incorrect: function(type) {
        return i18n._({
            id: "HPcba9",
            values: {
                type: type
            }
        });
    },
    mismatch: function(type) {
        return i18n._({
            id: "bgnTH8",
            values: {
                type: type
            }
        });
    },
    noColorSelected: function() {
        return i18n._({
            id: "VzWHNC"
        });
    },
    colorExists: function(color) {
        return i18n._({
            id: "avtJpM",
            values: {
                color: color
            }
        });
    },
    pdfLocked: function() {
        return i18n._({
            id: "EeiuwF"
        });
    },
    pdfLockedDesc: function() {
        return i18n._({
            id: "L1qBWw"
        });
    },
    enterPassword: function() {
        return i18n._({
            id: "f7sXvi"
        });
    },
    failedToDownloadFile: function() {
        return i18n._({
            id: "m7AE5i"
        });
    },
    zipping: function() {
        return i18n._({
            id: "D3tmXK"
        });
    },
    savingZipFile: function(progress) {
        return progress ? i18n._({
            id: "NG43uK",
            values: {
                progress: progress
            }
        }) : i18n._({
            id: "OnLb5D"
        });
    },
    failedToZipFiles: function() {
        return i18n._({
            id: "R22E8r"
        });
    },
    fileVerificationFailed: function() {
        return i18n._({
            id: "ajwmKJ"
        });
    },
    fileLengthError: function() {
        return i18n._({
            id: "nM0Pn/"
        });
    },
    fileLengthMismatch: function(expectedSize, currentSize) {
        return i18n._({
            id: "cDRkuz",
            values: {
                expectedSize: expectedSize,
                currentSize: currentSize
            }
        });
    },
    failedToResolvedDownloadUrl: function() {
        return i18n._({
            id: "UCo+qX"
        });
    },
    fileSize: function() {
        return "File size";
    },
    donwloadStarted: function() {
        return i18n._({
            id: "7YIguj"
        });
    },
    passwordNotEntered: function() {
        return i18n._({
            id: "jYaKGB"
        });
    },
    passwordNotMatched: function() {
        return i18n._({
            id: "BTs71x"
        });
    },
    passwordUpdated: function() {
        return i18n._({
            id: "ogtYkT"
        });
    },
    noteLocked: function() {
        return i18n._({
            id: "fhQuLa"
        });
    },
    biometricUnlockEnabled: function() {
        return i18n._({
            id: "YaBGGS"
        });
    },
    biometricUnlockDisabled: function() {
        return i18n._({
            id: "E1YHoo"
        });
    },
    vaultCreated: function() {
        return i18n._({
            id: "u8/Hb5"
        });
    },
    noteUnlocked: function() {
        return i18n._({
            id: "2HT6mb"
        });
    },
    noteCopied: function() {
        return i18n._({
            id: "ATnxkq"
        });
    },
    introData: [
        {
            headings: [
                function() {
                    return i18n._({
                        id: "MZ4EQ7"
                    });
                },
                function() {
                    return i18n._({
                        id: "TNKn9M"
                    });
                },
                function() {
                    return i18n._({
                        id: "Sd5wlL"
                    });
                }
            ],
            body: function() {
                return i18n._({
                    id: "kxRAaM"
                });
            }
        },
        {
            headings: [
                function() {
                    return i18n._({
                        id: "U0c3Yc"
                    });
                },
                function() {
                    return i18n._({
                        id: "+7AKcW"
                    });
                },
                function() {
                    return i18n._({
                        id: "5wfhlH"
                    });
                }
            ],
            body: function() {
                return i18n._({
                    id: "UCLya4"
                });
            }
        },
        {
            tesimonial: function() {
                return i18n._({
                    id: "I7Sgp6"
                });
            },
            link: "https://twitter.com/andrewsayer/status/1637817220113002503",
            user: "@andrewsayer on Twitter"
        }
    ],
    shortcutCreated: function() {
        return actions.created.shortcut(1);
    },
    notebookRestored: function() {
        return actions.restored.notebook(1);
    },
    restoreNotebook: function() {
        return doActions.restore.notebook(1);
    },
    permanentlyDeletedNotebook: function() {
        return actions.permanentlyDeleted.notebook(1);
    },
    noteRestoredFromHistory: function() {
        return i18n._({
            id: "xe9Qfl"
        });
    },
    noteRestored: function() {
        return actions.restored.note(1);
    },
    deleteNoteConfirmation: function() {
        return actionConfirmations.permanentlyDelete.note(1);
    },
    noteDeleted: function() {
        return actions.deleted.note(1);
    },
    restored: function() {
        return i18n._({
            id: "g0VKLg"
        });
    },
    manageTags: function() {
        return i18n._({
            id: "qmz7va"
        });
    },
    linkNotebook: function() {
        return i18n._({
            id: "wF1gGm"
        });
    },
    move: function() {
        return i18n._({
            id: "QWdKwH"
        });
    },
    unlinkNotebook: function() {
        return i18n._({
            id: "NAeFDJ"
        });
    },
    unfavorite: function() {
        return i18n._({
            id: "oGlwk+"
        });
    },
    moveToTrash: function() {
        return i18n._({
            id: "rRZjIm"
        });
    },
    enterNotebookTitle: function() {
        return i18n._({
            id: "89H8c+"
        });
    },
    emailUpdated: function(email) {
        return i18n._({
            id: "4vQnhm",
            values: {
                email: email
            }
        });
    },
    noApplicationFound: function(fileToOpen) {
        return i18n._({
            id: "JVehEG",
            values: {
                fileToOpen: fileToOpen
            }
        });
    },
    moveNotebooks: function(count) {
        return i18n._({
            id: "HDtl9h",
            values: {
                count: count
            }
        });
    },
    moveNotebooksConfirm: function(count, selectedNotebookTitle) {
        return i18n._({
            id: "+kGIvl",
            values: {
                count: count,
                selectedNotebookTitle: selectedNotebookTitle
            }
        });
    },
    failedToPublish: function() {
        return i18n._({
            id: "R7PCiM"
        });
    },
    failedToUnpublish: function() {
        return i18n._({
            id: "38kHIz"
        });
    },
    notePublished: function() {
        return actions.published.note(1);
    },
    monographUrlCopied: function() {
        return i18n._({
            id: "mhsHqf"
        });
    },
    recoveryKeySaved: function() {
        return i18n._({
            id: "bk4f3I"
        });
    },
    recoveryKeySavedDesc: function() {
        return i18n._({
            id: "+jDePb"
        });
    },
    recoveryKeyQRCodeSaved: function() {
        return i18n._({
            id: "Q3y9BE"
        });
    },
    recoveryKeyTextFileSaved: function() {
        return i18n._({
            id: "DE6S/O"
        });
    },
    recoveryKeyCopied: function() {
        return i18n._({
            id: "CgBuKx"
        });
    },
    timeShort: {
        second: function() {
            return i18n._({
                id: "NPfgIB"
            });
        },
        minute: function() {
            return i18n._({
                id: "lWkKSO"
            });
        },
        hour: function() {
            return i18n._({
                id: "agP50o"
            });
        }
    },
    backupEncrypted: function() {
        return i18n._({
            id: "+G0XXK"
        });
    },
    password: function() {
        return i18n._({
            id: "8ZsakT"
        });
    },
    renameTag: function() {
        return doActions.rename.tag(1);
    },
    renameColor: function() {
        return doActions.rename.color(1);
    },
    renameColorDesc: function(color) {
        return i18n._({
            id: "c8+yvE",
            values: {
                color: color
            }
        });
    },
    name: function() {
        return i18n._({
            id: "6YtxFj"
        });
    },
    unlockToDelete: function() {
        return i18n._({
            id: "kApTiE"
        });
    },
    backupRestored: function() {
        return i18n._({
            id: "TrAMNt"
        });
    },
    restoreFailed: function() {
        return i18n._({
            id: "uM6jnS"
        });
    },
    reorder: function() {
        return i18n._({
            id: "toJdZA"
        });
    },
    turnOffReminder: function() {
        return i18n._({
            id: "qY5Nwo"
        });
    },
    turnOnReminder: function() {
        return i18n._({
            id: "su79zQ"
        });
    },
    addShortcut: function() {
        return i18n._({
            id: "Lsxpe5"
        });
    },
    addNotebook: function() {
        return i18n._({
            id: "a0qwku"
        });
    },
    removeAsDefault: function() {
        return i18n._({
            id: "Q2u5E9"
        });
    },
    setAsDefault: function() {
        return i18n._({
            id: "PPcets"
        });
    },
    moveNotes: function() {
        return i18n._({
            id: "7vMCKO"
        });
    },
    unpin: function() {
        return i18n._({
            id: "nWMRxa"
        });
    },
    pin: function() {
        return i18n._({
            id: "qVkGWK"
        });
    },
    lockedNotesPinnedFailed: function() {
        return i18n._({
            id: "PMopsw"
        });
    },
    loginRequired: function() {
        return i18n._({
            id: "Y3PKId"
        });
    },
    confirmEmailToPublish: function() {
        return i18n._({
            id: "SyF1rT"
        });
    },
    lockedNotesPublishFailed: function() {
        return i18n._({
            id: "ywYJZG"
        });
    },
    notePreparingForShare: function() {
        return i18n._({
            id: "bbXodq"
        });
    },
    removeFromNotebook: function() {
        return i18n._({
            id: "9uUgi0"
        });
    },
    attachments: function() {
        return i18n._({
            id: "w/Sphq"
        });
    },
    attachedFiles: function() {
        return i18n._({
            id: "2/fy8w"
        });
    },
    history: function() {
        return i18n._({
            id: "0caMy7"
        });
    },
    copyLink: function() {
        return i18n._({
            id: "y1eoq1"
        });
    },
    linkCopied: function() {
        return i18n._({
            id: "edWbV6"
        });
    },
    readOnly: function() {
        return i18n._({
            id: "uNQ6eB"
        });
    },
    syncOff: function() {
        return i18n._({
            id: "kUn+CN"
        });
    },
    syncOffConfirm: function(count) {
        return i18n._({
            id: "5BNaJh",
            values: {
                count: count
            }
        });
    },
    syncOffDesc: function(count) {
        return i18n._({
            id: "SD1h7M",
            values: {
                count: count
            }
        });
    },
    duplicate: function() {
        return i18n._({
            id: "euc6Ns"
        });
    },
    remindMe: function() {
        return i18n._({
            id: "+xMFF8"
        });
    },
    published: function() {
        return i18n._({
            id: "u3wRF+"
        });
    },
    unpinFromNotifications: function() {
        return i18n._({
            id: "2lBT/c"
        });
    },
    pinToNotifications: function() {
        return i18n._({
            id: "3bsV/O"
        });
    },
    linkNotebooks: function() {
        return i18n._({
            id: "eRDAhH"
        });
    },
    unlinkFromAll: function() {
        return i18n._({
            id: "AFoM4U"
        });
    },
    removeFromAll: function() {
        return i18n._({
            id: "/Gb+bV"
        });
    },
    assignTo: function() {
        return i18n._({
            id: "vAV5MB"
        });
    },
    addTags: function() {
        return i18n._({
            id: "1CYgqa"
        });
    },
    addTagsDesc: function() {
        return i18n._({
            id: "FPjRP/"
        });
    },
    references: function() {
        return i18n._({
            id: "9aloPG"
        });
    },
    moveNotebookFix: function() {
        return i18n._({
            id: "BkUrKX"
        });
    },
    failedToSubscribe: function() {
        return i18n._({
            id: "02tCw0"
        });
    },
    createNewNote: function() {
        return i18n._({
            id: "E1GwA2"
        });
    },
    monographs: function() {
        return i18n._({
            id: "onn9nd"
        });
    },
    encryptingAttachment: function() {
        return i18n._({
            id: "RJpuGH"
        });
    },
    encryptingAttachmentDesc: function() {
        var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "attachment";
        return i18n._({
            id: "ZzvDMP",
            values: {
                name: name
            }
        });
    },
    fileTooLarge: function() {
        return i18n._({
            id: "X00wAg"
        });
    },
    fileTooLargeDesc: function(sizeInMB) {
        return i18n._({
            id: "THHGjP",
            values: {
                sizeInMB: sizeInMB
            }
        });
    },
    imageTooLarge: function(sizeInMB) {
        return i18n._({
            id: "f4y9LF",
            values: {
                sizeInMB: sizeInMB
            }
        });
    },
    failToOpen: function() {
        return i18n._({
            id: "WYmRTB"
        });
    },
    fileMismatch: function() {
        return i18n._({
            id: "XyB6P/"
        });
    },
    noNoteProperties: function() {
        return i18n._({
            id: "u52Tlg"
        });
    },
    createNoteFirst: function() {
        return i18n._({
            id: "XvtKKn"
        });
    },
    noteLockedSave: function() {
        return i18n._({
            id: "YFBFPm"
        });
    },
    saveFailedVaultLocked: function() {
        return i18n._({
            id: "6dIS+G"
        });
    },
    yourFavorites: function() {
        return i18n._({
            id: "nngWPw"
        });
    },
    yourNotes: function() {
        return i18n._({
            id: "c/UJNe"
        });
    },
    yourTags: function() {
        return i18n._({
            id: "pK6d8q"
        });
    },
    yourNotebooks: function() {
        return i18n._({
            id: "SecRtN"
        });
    },
    yourReminders: function() {
        return i18n._({
            id: "7xWMng"
        });
    },
    yourMonographs: function() {
        return i18n._({
            id: "/QFN3b"
        });
    },
    yourArchive: function() {
        return i18n._({
            id: "fmN9CX"
        });
    },
    favoritesEmpty: function() {
        return i18n._({
            id: "flrg5S"
        });
    },
    notesEmpty: function() {
        return i18n._({
            id: "0fkA5v"
        });
    },
    tagsEmpty: function() {
        return i18n._({
            id: "PJupa2"
        });
    },
    notebooksEmpty: function() {
        return i18n._({
            id: "9t+zmI"
        });
    },
    remindersEmpty: function() {
        return i18n._({
            id: "f+cI+W"
        });
    },
    monographsEmpty: function() {
        return i18n._({
            id: "CBIsoi"
        });
    },
    loadingFavorites: function() {
        return i18n._({
            id: "RYHuci"
        });
    },
    loadingNotes: function() {
        return i18n._({
            id: "P81HiI"
        });
    },
    loadingTags: function() {
        return i18n._({
            id: "TGz9dm"
        });
    },
    loadingNotebooks: function() {
        return i18n._({
            id: "oDS/Dx"
        });
    },
    loadingReminders: function() {
        return i18n._({
            id: "W9Rafy"
        });
    },
    loadingMonographs: function() {
        return i18n._({
            id: "M4RQzc"
        });
    },
    loadingArchive: function() {
        return i18n._({
            id: "HuVsXQ"
        });
    },
    addFirstNote: function() {
        return i18n._({
            id: "Me0RO5"
        });
    },
    addFirstNotebook: function() {
        return i18n._({
            id: "0dNpir"
        });
    },
    setReminder: function() {
        return i18n._({
            id: "WMaMmu"
        });
    },
    learnMoreMonographs: function() {
        return i18n._({
            id: "iESm3m"
        });
    },
    mfaAuthAppTitle: function() {
        return i18n._({
            id: "/WpcgC"
        });
    },
    mfaAuthAppDesc: function() {
        return i18n._({
            id: "KAFFLj"
        });
    },
    mfaAuthAppSubtitle: function() {
        return i18n._({
            id: "NaNEM+"
        });
    },
    mfaAuthAppInstructions: function() {
        return i18n._({
            id: "L8D3a6"
        });
    },
    mfaAuthAppSelector: function() {
        return i18n._({
            id: "UA0CQn"
        });
    },
    mfaEmailTitle: function() {
        return i18n._({
            id: "gWoXjv"
        });
    },
    mfaEmailDesc: function() {
        return i18n._({
            id: "vUKhn6"
        });
    },
    mfaEmailSubtitle: function() {
        return i18n._({
            id: "8GNw/n"
        });
    },
    mfaEmailInstructions: function() {
        return i18n._({
            id: "qZV7FM"
        });
    },
    mfaEmailSelector: function() {
        return i18n._({
            id: "XmeNDK"
        });
    },
    mfaSmsTitle: function() {
        return i18n._({
            id: "gtwB5V"
        });
    },
    mfaSmsDesc: function() {
        return i18n._({
            id: "tMQrPq"
        });
    },
    mfaSmsSubtitle: function(phoneNumber) {
        return i18n._({
            id: "wQ6/Op",
            values: {
                0: phoneNumber ? phoneNumber : "your registered phone number."
            }
        });
    },
    mfaSmsInstructions: function() {
        return i18n._({
            id: "qZV7FM"
        });
    },
    mfaSmsSelector: function() {
        return i18n._({
            id: "MQO7um"
        });
    },
    mfaRecoveryCodeSubtitle: function() {
        return i18n._({
            id: "XKBl6P"
        });
    },
    mfaRecoveryCodeSelector: function() {
        return i18n._({
            id: "rfninE"
        });
    },
    enterRecoveryCode: function() {
        return i18n._({
            id: "MMjdHr"
        });
    },
    codesCopied: function() {
        return i18n._({
            id: "08n+ok"
        });
    },
    resendCodeWait: function() {
        return i18n._({
            id: "BPfHCN"
        });
    },
    phoneNumberNotEntered: function() {
        return i18n._({
            id: "lGVZa1"
        });
    },
    "2faCodeSentVia": function(method) {
        return i18n._({
            id: "oxGDdX",
            values: {
                method: method
            }
        });
    },
    errorSend2fa: function() {
        return i18n._({
            id: "PJAnV6"
        });
    },
    codesSaved: function() {
        return i18n._({
            id: "KkI+tM"
        });
    },
    logsCopied: function() {
        return i18n._({
            id: "TU55py"
        });
    },
    logsDownloaded: function() {
        return i18n._({
            id: "4zGmRP"
        });
    },
    clearLogs: function() {
        return i18n._({
            id: "x3osqj"
        });
    },
    clear: function() {
        return i18n._({
            id: "xCJdfg"
        });
    },
    clearLogsConfirmation: function(key) {
        return i18n._({
            id: "Z0IY3Q",
            values: {
                key: key
            }
        });
    },
    enterPasswordDesc: function() {
        return i18n._({
            id: "ml5D/e"
        });
    },
    verifyFailed: function() {
        return i18n._({
            id: "C09vPI"
        });
    },
    enterApplockPassword: function() {
        return i18n._({
            id: "vbzRN6"
        });
    },
    enterApplockPasswordDesc: function() {
        return i18n._({
            id: "BA3xyZ"
        });
    },
    enterApplockPin: function() {
        return i18n._({
            id: "v9WRzp"
        });
    },
    enterApplockPinDesc: function() {
        return i18n._({
            id: "pER/KN"
        });
    },
    account: function() {
        return i18n._({
            id: "AeXO77"
        });
    },
    subscribeToPro: function() {
        return i18n._({
            id: "8loBlq"
        });
    },
    trialStarted: function() {
        return i18n._({
            id: "MysssZ"
        });
    },
    trialStartedDesc: function() {
        return i18n._({
            id: "513lJO"
        });
    },
    subDetails: function() {
        return i18n._({
            id: "u50Zm/"
        });
    },
    signedUpOn: function(date) {
        return i18n._({
            id: "kAlOcT",
            values: {
                date: date
            }
        });
    },
    trialEndsOn: function(date) {
        return i18n._({
            id: "AAtw8K",
            values: {
                date: date
            }
        });
    },
    subEnded: function() {
        return i18n._({
            id: "pUGzzf"
        });
    },
    accountDowngradedIn: function(days) {
        return i18n._({
            id: "RUMot5",
            values: {
                days: days
            }
        });
    },
    subEndsOn: function(date) {
        return i18n._({
            id: "pY6JZ2",
            values: {
                date: date
            }
        });
    },
    subRenewOn: function(date) {
        return i18n._({
            id: "hyMUuX",
            values: {
                date: date
            }
        });
    },
    neverHesitate: function() {
        return i18n._({
            id: "BAgOGQ"
        });
    },
    manageAccount: function() {
        return i18n._({
            id: "77nMdq"
        });
    },
    manageAccountDesc: function() {
        return i18n._({
            id: "BCVsuD"
        });
    },
    removeProfilePicture: function() {
        return i18n._({
            id: "0gH/sc"
        });
    },
    removeProfilePictureDesc: function() {
        return i18n._({
            id: "7/P62A"
        });
    },
    removeProfilePictureConfirmation: function() {
        return i18n._({
            id: "vymKC4"
        });
    },
    removeFullName: function() {
        return i18n._({
            id: "IOgBqV"
        });
    },
    removeFullNameConfirmation: function() {
        return i18n._({
            id: "N9a8z1"
        });
    },
    removeFullNameDesc: function() {
        return i18n._({
            id: "BqZvbE"
        });
    },
    saveDataRecoveryKey: function() {
        return i18n._({
            id: "d4Byn3"
        });
    },
    saveDataRecoveryKeyDesc: function() {
        return i18n._({
            id: "r4X8uC"
        });
    },
    manageAttachments: function() {
        return i18n._({
            id: "qKWYY3"
        });
    },
    manageAttachmentsDesc: function() {
        return i18n._({
            id: "mqWe9v"
        });
    },
    changePasswordDesc: function() {
        return i18n._({
            id: "Ar5o5b"
        });
    },
    change2faMethodDesc: function() {
        return i18n._({
            id: "zTDe5I"
        });
    },
    addFallback2faMethod: function() {
        return i18n._({
            id: "zbsszH"
        });
    },
    addFallback2faMethodDesc: function() {
        return i18n._({
            id: "rKl3Nu"
        });
    },
    change2faFallbackMethod: function() {
        return i18n._({
            id: "DUmwRE"
        });
    },
    viewRecoveryCodes: function() {
        return i18n._({
            id: "abPz2s"
        });
    },
    viewRecoveryCodesDesc: function() {
        return i18n._({
            id: "O03KZ+"
        });
    },
    subscriptionNotActivated: function() {
        return i18n._({
            id: "E+hE7/"
        });
    },
    loadingSubscription: function() {
        return i18n._({
            id: "rBiq0U"
        });
    },
    loadingSubscriptionDesc: function() {
        return i18n._({
            id: "R4BqCY"
        });
    },
    notesnookPro: function() {
        return i18n._({
            id: "cnJeIp"
        });
    },
    subscribedOnVerify: function(date) {
        return i18n._({
            id: "Z5u+LR",
            values: {
                date: date
            }
        });
    },
    verifySubscription: function() {
        return i18n._({
            id: "13kJr2"
        });
    },
    subscriptionVerifyWait: function() {
        return i18n._({
            id: "vX5BLV"
        });
    },
    verifySubDesc: function() {
        return i18n._({
            id: "jBmsXa"
        });
    },
    logoutWarnin: function() {
        return i18n._({
            id: "HvM28j"
        });
    },
    logoutError: function() {
        return i18n._({
            id: "3UyhL/"
        });
    },
    deleteAccount: function() {
        return i18n._({
            id: "ZDGm40"
        });
    },
    deleteAccountDesc: function() {
        return i18n._({
            id: "jwLTJD"
        });
    },
    enterAccountPassword: function() {
        return i18n._({
            id: "WOxd6l"
        });
    },
    enterAccountPasswordDesc: function() {
        return i18n._({
            id: "goJTFd"
        });
    },
    failedToDeleteAccount: function() {
        return i18n._({
            id: "ykyODs"
        });
    },
    syncSettings: function() {
        return i18n._({
            id: "hT1Dua"
        });
    },
    syncSettingsDesc: function() {
        return i18n._({
            id: "joxbBU"
        });
    },
    disableAutoSync: function() {
        return i18n._({
            id: "+2SUL9"
        });
    },
    disableAutoSyncDesc: function() {
        return i18n._({
            id: "o9q1Uh"
        });
    },
    disableRealtimeSync: function() {
        return i18n._({
            id: "6vZygY"
        });
    },
    disableRealtimeSyncDesc: function() {
        return i18n._({
            id: "mgZBdJ"
        });
    },
    disableSync: function() {
        return i18n._({
            id: "lIn9L9"
        });
    },
    disableSyncDesc: function() {
        return i18n._({
            id: "dS17CC"
        });
    },
    backgroundSync: function() {
        return i18n._({
            id: "ZEA+hD"
        });
    },
    backgroundSyncDesc: function() {
        return i18n._({
            id: "GkmpCM"
        });
    },
    forcePullChanges: function() {
        return i18n._({
            id: "yL1zca"
        });
    },
    forcePullChangesDesc: function() {
        return [
            i18n._({
                id: "TppkdC"
            }),
            "",
            i18n._({
                id: "MfcQek"
            })
        ].join("\n");
    },
    forceSyncNotice: function() {
        return "This must only be used for troubleshooting. Using this regularly for sync is not recommended and will lead to unexpected data loss and other issues. If you are having persistent issues with sync, please report them to us at support@streetwriters.co.";
    },
    forcePushChanges: function() {
        return i18n._({
            id: "YCBzsa"
        });
    },
    forcePushChangesDesc: function() {
        return [
            i18n._({
                id: "yoy+HN"
            }),
            "",
            i18n._({
                id: "MfcQek"
            })
        ].join("\n");
    },
    start: function() {
        return i18n._({
            id: "tXkhj/"
        });
    },
    customization: function() {
        return i18n._({
            id: "qqLY+j"
        });
    },
    appearance: function() {
        return i18n._({
            id: "aAIQg2"
        });
    },
    appearanceDesc: function() {
        return i18n._({
            id: "SULyfj"
        });
    },
    themes: function() {
        return i18n._({
            id: "fJ3EbT"
        });
    },
    themesDesc: function() {
        return i18n._({
            id: "hO+/6k"
        });
    },
    useSystemTheme: function() {
        return i18n._({
            id: "cr3dJz"
        });
    },
    useSystemThemeDesc: function() {
        return i18n._({
            id: "XccgbS"
        });
    },
    darkMode: function() {
        return i18n._({
            id: "yB1YpA"
        });
    },
    darkModeDesc: function() {
        return i18n._({
            id: "sRqVbG"
        });
    },
    behavior: function() {
        return i18n._({
            id: "tK9OCv"
        });
    },
    behaviorDesc: function() {
        return i18n._({
            id: "JpHKTC"
        });
    },
    homepage: function() {
        return i18n._({
            id: "qY8wNa"
        });
    },
    homepageDesc: function() {
        return i18n._({
            id: "8sNMUE"
        });
    },
    imageCompression: function() {
        return i18n._({
            id: "xEqpfU"
        });
    },
    imageCompressionDesc: function() {
        return i18n._({
            id: "VAuA41"
        });
    },
    askEveryTime: function() {
        return i18n._({
            id: "6CTZeX"
        });
    },
    enableRecommended: function() {
        return i18n._({
            id: "u+6Zqn"
        });
    },
    dateFormat: function() {
        return i18n._({
            id: "Lhd0oQ"
        });
    },
    dateFormatDesc: function() {
        return i18n._({
            id: "27sf6l"
        });
    },
    timeFormat: function() {
        return i18n._({
            id: "n9nSNJ"
        });
    },
    timeFormatDesc: function() {
        return i18n._({
            id: "vnUehW"
        });
    },
    clearTrashInterval: function() {
        return i18n._({
            id: "XTtf5p"
        });
    },
    clearTrashIntervalDesc: function() {
        return i18n._({
            id: "b/9yhJ"
        });
    },
    clearDefaultNotebook: function() {
        return i18n._({
            id: "6dU1I3"
        });
    },
    clearDefaultNotebookDesc: function() {
        return i18n._({
            id: "STeUtY"
        });
    },
    defaultNotebookCleared: function() {
        return i18n._({
            id: "acdamg"
        });
    },
    editor: function() {
        return i18n._({
            id: "uBAxNB"
        });
    },
    editorDesc: function() {
        return i18n._({
            id: "6fK4+B"
        });
    },
    customizeToolbar: function() {
        return i18n._({
            id: "imBGtv"
        });
    },
    customizeToolbarDesc: function() {
        return i18n._({
            id: "A2jRH6"
        });
    },
    resetToolbar: function() {
        return i18n._({
            id: "cc0VD6"
        });
    },
    resetToolbarDesc: function() {
        return i18n._({
            id: "i7nqJp"
        });
    },
    toolbarReset: function() {
        return i18n._({
            id: "dMcu37"
        });
    },
    doubleSpacedLines: function() {
        return i18n._({
            id: "EeqPoj"
        });
    },
    doubleSpacedLinesDesc: function() {
        return i18n._({
            id: "Cz4iZL"
        });
    },
    lineSpacingChanged: function() {
        return i18n._({
            id: "gPju2o"
        });
    },
    defaultFontSize: function() {
        return i18n._({
            id: "w6yB+i"
        });
    },
    defaultFontSizeDesc: function() {
        return i18n._({
            id: "d0vCNL"
        });
    },
    defaultFontFamily: function() {
        return i18n._({
            id: "Pwt8It"
        });
    },
    defaultFontFamilyDesc: function() {
        return i18n._({
            id: "tFQIsa"
        });
    },
    titleFormat: function() {
        return i18n._({
            id: "lJnMP5"
        });
    },
    titleFormatDesc: function() {
        return i18n._({
            id: "IGDNGM"
        });
    },
    mardownShortcuts: function() {
        return i18n._({
            id: "1rTp8u"
        });
    },
    mardownShortcutsDesc: function() {
        return i18n._({
            id: "WqViqZ"
        });
    },
    privacyAndSecurity: function() {
        return i18n._({
            id: "67F5lC"
        });
    },
    telemetry: function() {
        return i18n._({
            id: "QrdbDX"
        });
    },
    telemetryDesc: function() {
        return i18n._({
            id: "LRnj3C"
        });
    },
    marketingEmails: function() {
        return i18n._({
            id: "N2gd1/"
        });
    },
    marketingEmailsDesc: function() {
        return i18n._({
            id: "VuS32U"
        });
    },
    corsBypass: function() {
        return i18n._({
            id: "nb7vib"
        });
    },
    corsBypassDesc: function() {
        return i18n._({
            id: "wNxNk0"
        });
    },
    vault: function() {
        return i18n._({
            id: "GAYFP2"
        });
    },
    vaultDesc: function() {
        return i18n._({
            id: "BULS9F"
        });
    },
    changeVaultPasswordDesc: function() {
        return i18n._({
            id: "TR1skl"
        });
    },
    clearVaultDesc: function() {
        return i18n._({
            id: "O97HLI"
        });
    },
    deleteVaultDesc: function() {
        return i18n._({
            id: "pElzrD"
        });
    },
    biometricUnlock: function() {
        return i18n._({
            id: "N/oaae"
        });
    },
    biometricUnlockDesc: function() {
        return i18n._({
            id: "FNNnvt"
        });
    },
    revokeBiometricUnlock: function() {
        return i18n._({
            id: "howlBO"
        });
    },
    privacyMode: function() {
        return i18n._({
            id: "+bqhYt"
        });
    },
    privacyModeDesc: function() {
        return i18n._({
            id: "D+wlMV"
        });
    },
    appLock: function() {
        return i18n._({
            id: "ytCTfj"
        });
    },
    appLockDesc: function() {
        return i18n._({
            id: "tDKWsC"
        });
    },
    enableAppLock: function() {
        return i18n._({
            id: "XmlwCQ"
        });
    },
    biometricsNotEnrolled: function() {
        return i18n._({
            id: "LPGZrz"
        });
    },
    biometricsNotEnrolledDesc: function() {
        return i18n._({
            id: "AIM070"
        });
    },
    appLockTimeout: function() {
        return i18n._({
            id: "Pnih/r"
        });
    },
    appLockTimeoutDesc: function() {
        return i18n._({
            id: "+/X+eO"
        });
    },
    setupAppLockPin: function() {
        return i18n._({
            id: "sep6xH"
        });
    },
    setupAppLockPinDesc: function() {
        return i18n._({
            id: "DTJwh3"
        });
    },
    setupAppLockPassword: function() {
        return i18n._({
            id: "eJgyFb"
        });
    },
    setupAppLockPasswordDesc: function() {
        return i18n._({
            id: "l5/xiQ"
        });
    },
    changeAppLockPin: function() {
        return i18n._({
            id: "1osFPE"
        });
    },
    changeAppLockPassword: function() {
        return i18n._({
            id: "C8r4iM"
        });
    },
    changeAppLockPinDesc: function() {
        return i18n._({
            id: "1cvfNK"
        });
    },
    changeAppLockPasswordDesc: function() {
        return i18n._({
            id: "1cvfNK"
        });
    },
    removeAppLockPin: function() {
        return i18n._({
            id: "/KcV6I"
        });
    },
    removeAppLockPassword: function() {
        return i18n._({
            id: "THDWi3"
        });
    },
    removeAppLockPinDesc: function() {
        return i18n._({
            id: "Q8MCzN"
        });
    },
    removeAppLockPasswordDesc: function() {
        return i18n._({
            id: "YvONfg"
        });
    },
    unlockWithBiometricsDesc: function() {
        return i18n._({
            id: "LcWGo+"
        });
    },
    appLockDisabled: function() {
        return i18n._({
            id: "r1Q6sc"
        });
    },
    backupRestore: function() {
        return i18n._({
            id: "/CRDzo"
        });
    },
    backupsDesc: function() {
        return i18n._({
            id: "NAhVjO"
        });
    },
    backupNow: function() {
        return i18n._({
            id: "uinbzV"
        });
    },
    backupNowWithAttachments: function() {
        return i18n._({
            id: "CrrcAL"
        });
    },
    backupNowWithAttachmentsDesc: function() {
        return i18n._({
            id: "U5VyHJ"
        });
    },
    backupNowDesc: function() {
        return i18n._({
            id: "8sqCxz"
        });
    },
    automaticBackups: function() {
        return i18n._({
            id: "KNC0YQ"
        });
    },
    automaticBackupsDesc: function() {
        return i18n._({
            id: "HDm/iv"
        });
    },
    automaticBackupsWithAttachments: function() {
        return i18n._({
            id: "DmJ8Em"
        });
    },
    automaticBackupsWithAttachmentsDesc: function() {
        return [
            i18n._({
                id: "3wougd"
            }),
            i18n._({
                id: "4WJ08D"
            })
        ];
    },
    selectBackupDir: function() {
        return i18n._({
            id: "MHFwp6"
        });
    },
    selectBackupDirDesc: function(path) {
        return [
            i18n._({
                id: "h1RrQB"
            }),
            i18n._({
                id: "ePq4+p",
                values: {
                    path: path
                }
            })
        ];
    },
    noDirectorySelected: function() {
        return i18n._({
            id: "E17fm/"
        });
    },
    changeBackupDir: function() {
        return i18n._({
            id: "FjCVaq"
        });
    },
    backupEncryption: function() {
        return i18n._({
            id: "OZO08I"
        });
    },
    backupEncryptionDesc: function() {
        return i18n._({
            id: "660uus"
        });
    },
    restoreBackup: function() {
        return i18n._({
            id: "3HSIfq"
        });
    },
    restoreBackupDesc: function() {
        return i18n._({
            id: "5ZIMbM"
        });
    },
    exportAllNotes: function() {
        return i18n._({
            id: "guqGIx"
        });
    },
    exportAllNotesDesc: function() {
        return i18n._({
            id: "P73PT/"
        });
    },
    productivity: function() {
        return i18n._({
            id: "N42ane"
        });
    },
    quickNoteNotification: function() {
        return i18n._({
            id: "HdwPad"
        });
    },
    quickNoteNotificationDesc: function() {
        return i18n._({
            id: "1GC3vx"
        });
    },
    reminders: function() {
        return i18n._({
            id: "crwali"
        });
    },
    remindersDesc: function() {
        return i18n._({
            id: "TD+vZE"
        });
    },
    reminderNotification: function() {
        return i18n._({
            id: "/oLyTX"
        });
    },
    reminderNotificationDesc: function() {
        return i18n._({
            id: "k7VXMj"
        });
    },
    defaultSnoozeTime: function() {
        return i18n._({
            id: "eL+CFB"
        });
    },
    defaultSnoozeTimeDesc: function() {
        return i18n._({
            id: "sRYgMr"
        });
    },
    setSnoozeTimePlaceholder: function() {
        return i18n._({
            id: "luxDbf"
        });
    },
    changeNotificationSound: function() {
        return i18n._({
            id: "oJvX0L"
        });
    },
    changeNotificationSoundDesc: function() {
        return i18n._({
            id: "VAq9r0"
        });
    },
    helpAndSupport: function() {
        return i18n._({
            id: "uBVswz"
        });
    },
    reportAnIssue: function() {
        return i18n._({
            id: "Q3LOVJ"
        });
    },
    reportAnIssueDesc: function() {
        return i18n._({
            id: "ZTYD93"
        });
    },
    emailSupport: function() {
        return i18n._({
            id: "jvneza"
        });
    },
    emailSupportDesc: function() {
        return i18n._({
            id: "qMtG5K"
        });
    },
    documentation: function() {
        return i18n._({
            id: "TvY/XA"
        });
    },
    documentationDesc: function() {
        return i18n._({
            id: "M9JXrj"
        });
    },
    debugging: function() {
        return i18n._({
            id: "Wf+eYa"
        });
    },
    debuggingDesc: function() {
        return i18n._({
            id: "Ho7NAj"
        });
    },
    debugLogs: function() {
        return i18n._({
            id: "jhc7w4"
        });
    },
    debugLogsDesc: function() {
        return i18n._({
            id: "itBujG"
        });
    },
    community: function() {
        return i18n._({
            id: "chL5IG"
        });
    },
    joinTelegram: function() {
        return i18n._({
            id: "ltkYLl"
        });
    },
    joinTelegramDesc: function() {
        return i18n._({
            id: "vHU2bL"
        });
    },
    joinMastodon: function() {
        return i18n._({
            id: "cR017D"
        });
    },
    joinMastodonDesc: function() {
        return i18n._({
            id: "ttXzX7"
        });
    },
    followOnX: function() {
        return i18n._({
            id: "I7Exsw"
        });
    },
    followOnXDesc: function() {
        return i18n._({
            id: "DqYeub"
        });
    },
    joinDiscord: function() {
        return i18n._({
            id: "2D9bv9"
        });
    },
    joinDiscordDesc: function() {
        return i18n._({
            id: "TLSX8e"
        });
    },
    tos: function() {
        return i18n._({
            id: "UCLeG0"
        });
    },
    tosDesc: function() {
        return i18n._({
            id: "sJDlD1"
        });
    },
    privacyPolicy: function() {
        return i18n._({
            id: "ScJ9fj"
        });
    },
    privacyPolicyDesc: function() {
        return i18n._({
            id: "4VtRPO"
        });
    },
    licenses: function() {
        return i18n._({
            id: "/srKz4"
        });
    },
    ossLibs: function() {
        return i18n._({
            id: "PfNrC4"
        });
    },
    about: function() {
        return i18n._({
            id: "uyJsf6"
        });
    },
    downloadOnDesktop: function() {
        return i18n._({
            id: "A5ruMX"
        });
    },
    downloadOnDesktopDesc: function() {
        return i18n._({
            id: "q0XOtj"
        });
    },
    roadmap: function() {
        return i18n._({
            id: "/gaSVU"
        });
    },
    roadmapDesc: function() {
        return i18n._({
            id: "P6y4DM"
        });
    },
    checkForUpdates: function() {
        return i18n._({
            id: "WMCwmR"
        });
    },
    checkForUpdatesDesc: function() {
        return i18n._({
            id: "e1EwCD"
        });
    },
    autoUpdateCheck: function() {
        return i18n._({
            id: "Pn7Jfk"
        });
    },
    autoUpdateCheckDesc: function() {
        return i18n._({
            id: "zQN87K"
        });
    },
    appVersion: function() {
        return i18n._({
            id: "TTLLTN"
        });
    },
    defaultSound: function() {
        return i18n._({
            id: "vwt60Z"
        });
    },
    subNotSupported: function() {
        return i18n._({
            id: "z3rOUr"
        });
    },
    goToWebApp: function() {
        return i18n._({
            id: "0c1JJi"
        });
    },
    subOnWeb: function() {
        return i18n._({
            id: "phiyAL"
        });
    },
    openInBrowserToManageSub: function() {
        return i18n._({
            id: "O/TtJy"
        });
    },
    editProfilePicture: function() {
        return i18n._({
            id: "gqpp8T"
        });
    },
    editProfilePictureDesc: function() {
        return i18n._({
            id: "uGdYO3"
        });
    },
    setFullName: function() {
        return i18n._({
            id: "jtFXLF"
        });
    },
    setFullNameDesc: function() {
        return i18n._({
            id: "jK6cbZ"
        });
    },
    enterFullName: function() {
        return i18n._({
            id: "qQ3il2"
        });
    },
    deleteGroup: function() {
        return i18n._({
            id: "k/RLDM"
        });
    },
    deleteGroupDesc: function() {
        return i18n._({
            id: "TJfk8t"
        });
    },
    homePageChangedTo: function(name) {
        return i18n._({
            id: "uufeMC",
            values: {
                name: name
            }
        });
    },
    restartAppToApplyChanges: function() {
        return i18n._({
            id: "I/iPQ8"
        });
    },
    deleteCollapsed: function() {
        return i18n._({
            id: "OaTJ++"
        });
    },
    deleteCollapsedDesc: function() {
        return i18n._({
            id: "Ua1zrz"
        });
    },
    clearTrash: function() {
        return i18n._({
            id: "TpKw5f"
        });
    },
    areYouSure: function() {
        return i18n._({
            id: "6foA8n"
        });
    },
    clearTrashConfirm: function() {
        return i18n._({
            id: "9AHp+s"
        });
    },
    trashCleared: function() {
        return i18n._({
            id: "rXsNna"
        });
    },
    trash: function() {
        return i18n._({
            id: "GQ3O42"
        });
    },
    loadingTrash: function() {
        return i18n._({
            id: "KxtOp1"
        });
    },
    trashCleanupIntervalTextDaily: function() {
        return i18n._({
            id: "bjs7q7"
        });
    },
    trashCleanupIntervalTextDays: function(days) {
        return i18n._({
            id: "Ll1hws",
            values: {
                days: days
            }
        });
    },
    noTrashCleanupInterval: function() {
        return i18n._({
            id: "78IwEn"
        });
    },
    select: function() {
        return i18n._({
            id: "rG3WVm"
        });
    },
    backupComplete: function() {
        return i18n._({
            id: "eIAXHI"
        });
    },
    backupSaved: function(platform) {
        return i18n._({
            id: "0QBLnJ",
            values: {
                platform: platform
            }
        });
    },
    shareBackup: function() {
        return i18n._({
            id: "0Ht3qM"
        });
    },
    neverAskAgain: function() {
        return i18n._({
            id: "kA3ZWQ"
        });
    },
    backingUpData: function(type) {
        return i18n._({
            id: "bHjkTd",
            values: {
                0: type === "full" ? " full" : ""
            }
        });
    },
    backupDataDesc: function() {
        return i18n._({
            id: "IJgP4W"
        });
    },
    backupSuccess: function() {
        return i18n._({
            id: "+fJJG7"
        });
    },
    biometricsAuthFailed: function() {
        return i18n._({
            id: "hivs5z"
        });
    },
    biometricsAuthFailedDesc: function() {
        return i18n._({
            id: "U1I0gd"
        });
    },
    biometricsAuthCancelled: function() {
        return i18n._({
            id: "79ghn2"
        });
    },
    biometricsAuthError: function() {
        return i18n._({
            id: "htuqBH"
        });
    },
    tryAgain: function() {
        return i18n._({
            id: "c+lbQk"
        });
    },
    rateAppMessage: function() {
        return i18n._({
            id: "Ph1M2u"
        });
    },
    rateAppActionText: function(platform) {
        return platform === "ios" ? i18n._({
            id: "zAjDqO"
        }) : i18n._({
            id: "Yb7OXX"
        });
    },
    recoveryKeyMessage: function() {
        return i18n._({
            id: "eOTIys"
        });
    },
    recoveryKeyMessageActionText: function() {
        return i18n._({
            id: "6k1ADa"
        });
    },
    loginMessage: function() {
        return i18n._({
            id: "oRvYGq"
        });
    },
    loginMessageActionText: function() {
        return i18n._({
            id: "Eib9XX"
        });
    },
    syncDisabled: function() {
        return i18n._({
            id: "LW+QkZ"
        });
    },
    syncDisabledActionText: function() {
        return i18n._({
            id: "cR8J/3"
        });
    },
    autoBackupsOffMessage: function() {
        return i18n._({
            id: "1HAOMr"
        });
    },
    autoBackupsOffActionText: function() {
        return i18n._({
            id: "z+Z9LF"
        });
    },
    newUpdateMessage: function() {
        return i18n._({
            id: "OaoXkB"
        });
    },
    newUpdateActionText: function() {
        return i18n._({
            id: "nCpUFZ"
        });
    },
    updateNow: function() {
        return i18n._({
            id: "Q15keH"
        });
    },
    quickNoteTitle: function() {
        return i18n._({
            id: "wktClL"
        });
    },
    quickNoteContent: function() {
        return i18n._({
            id: "tg2cYb"
        });
    },
    takeNote: function() {
        return i18n._({
            id: "UC1Nrp"
        });
    },
    quickNotePlaceholder: function() {
        return i18n._({
            id: "TLU/h0"
        });
    },
    hide: function() {
        return i18n._({
            id: "vLyv1R"
        });
    },
    disable: function() {
        return i18n._({
            id: "cO9+2L"
        });
    },
    notificationsDisabled: function() {
        return i18n._({
            id: "/XG/5D"
        });
    },
    notificationsDisabledDesc: function() {
        return i18n._({
            id: "MDl1XM"
        });
    },
    openSettings: function() {
        return i18n._({
            id: "Yp+Hi/"
        });
    },
    close: function() {
        return i18n._({
            id: "yz7wBu"
        });
    },
    getNotesnookPro: function() {
        return i18n._({
            id: "RmAziD"
        });
    },
    colorsProMessage: function() {
        return i18n._({
            id: "ZxlGHM"
        });
    },
    exportProMessage: function() {
        return i18n._({
            id: "YK1ql5"
        });
    },
    tagsProMessage: function() {
        return i18n._({
            id: "bPVflK"
        });
    },
    notebookProMessage: function() {
        return i18n._({
            id: "zCP6jh"
        });
    },
    vaultProMessage: function() {
        return i18n._({
            id: "KD8Qmw"
        });
    },
    emailConfirmationLinkSent: function() {
        return i18n._({
            id: "8Xg27R"
        });
    },
    confirmEmailTroubleshoot: function() {
        return i18n._({
            id: "i2V8g/"
        });
    },
    confirmEmailTroubleshootNotice: function() {
        return [
            i18n._({
                id: "AavQMC"
            }),
            i18n._({
                id: "iOs30/"
            }),
            i18n._({
                id: "igbKJw"
            })
        ];
    },
    waitBeforeResendEmail: function() {
        return i18n._({
            id: "M5ttjP"
        });
    },
    verificationEmailSent: function() {
        return i18n._({
            id: "I6Q2R9"
        });
    },
    failedToSendVerificationEmail: function() {
        return i18n._({
            id: "yI9fD4"
        });
    },
    resendEmail: function() {
        return i18n._({
            id: "G42SNI"
        });
    },
    trialEndingSoon: function() {
        return i18n._({
            id: "qknw89"
        });
    },
    trialExpired: function() {
        return i18n._({
            id: "4wODSa"
        });
    },
    tips: [
        {
            text: function() {
                return i18n._({
                    id: "HnREL/"
                });
            },
            contexts: [
                "notes",
                "first-note"
            ]
        },
        {
            text: function() {
                return i18n._({
                    id: "LcD33k"
                });
            },
            contexts: [
                "notes",
                "notebook",
                "notebook",
                "tags",
                "topics"
            ]
        },
        {
            text: function() {
                return i18n._({
                    id: "/c6/Vq"
                });
            },
            contexts: [
                "monographs"
            ]
        },
        {
            text: function() {
                return i18n._({
                    id: "4fGUUi"
                });
            },
            contexts: [
                "monographs"
            ]
        },
        {
            text: function() {
                return i18n._({
                    id: "2bPwYh"
                });
            },
            contexts: [
                "notebook",
                "notebooks"
            ]
        },
        {
            text: function() {
                return i18n._({
                    id: "WT60vS"
                });
            },
            contexts: [
                "notebook",
                "topics"
            ]
        },
        {
            text: function() {
                return i18n._({
                    id: "H8dUNE"
                });
            },
            contexts: [
                "notebook",
                "topics"
            ]
        },
        {
            text: function() {
                return i18n._({
                    id: "0uW54m"
                });
            },
            contexts: [
                "notes"
            ]
        },
        {
            text: function() {
                return i18n._({
                    id: "7EVf1B"
                });
            },
            contexts: [
                "notes"
            ]
        },
        {
            text: function() {
                return i18n._({
                    id: "EV1sF2"
                });
            },
            contexts: [
                "notes"
            ]
        }
    ],
    popups: [
        {
            id: "sortmenu",
            text: function() {
                return i18n._({
                    id: "BqjWGI"
                });
            }
        },
        {
            id: "jumpto",
            text: function() {
                return i18n._({
                    id: "jusWxe"
                });
            }
        },
        {
            id: "compactmode",
            text: function() {
                return i18n._({
                    id: "DqR6Xm"
                });
            }
        },
        {
            id: "searchreplace",
            text: function() {
                return i18n._({
                    id: "E9jrUn"
                });
            }
        },
        {
            id: "notebookshortcut",
            text: function() {
                return i18n._({
                    id: "oZaJgk"
                });
            }
        }
    ],
    someNotesPublished: function() {
        return i18n._({
            id: "lMYYiU"
        });
    },
    unpublishToDelete: function() {
        return i18n._({
            id: "SODaSW"
        });
    },
    filterAttachments: function() {
        return i18n._({
            id: "CUO5hz"
        });
    },
    oldPassword: function() {
        return i18n._({
            id: "Pn2B7/"
        });
    },
    newPassword: function() {
        return i18n._({
            id: "/nT6AE"
        });
    },
    email: function() {
        return i18n._({
            id: "O3oNi5"
        });
    },
    emailInvalid: function() {
        return i18n._({
            id: "B2Tpo0"
        });
    },
    confirmPassword: function() {
        return i18n._({
            id: "xnWESi"
        });
    },
    currentPin: function() {
        return i18n._({
            id: "+FPp99"
        });
    },
    currentPassword: function() {
        return i18n._({
            id: "Pn2B7/"
        });
    },
    newPin: function() {
        return i18n._({
            id: "61prUC"
        });
    },
    confirmPin: function() {
        return i18n._({
            id: "/hQy0K"
        });
    },
    confirmNewPassword: function() {
        return i18n._({
            id: "JRQitQ"
        });
    },
    colorTitle: function() {
        return i18n._({
            id: "fjPxN9"
        });
    },
    enterNotebookDescription: function() {
        return i18n._({
            id: "B+4Z8u"
        });
    },
    searchNotebooks: function() {
        return i18n._({
            id: "BrGo6h"
        });
    },
    enterNewEmail: function() {
        return i18n._({
            id: "zBeWzx"
        });
    },
    verifyNewEmail: function() {
        return i18n._({
            id: "4fMHhW"
        });
    },
    issueTitlePlaceholder: function() {
        return i18n._({
            id: "E/IcL0"
        });
    },
    issuePlaceholder: function() {
        return i18n._({
            id: "6W5DNm"
        });
    },
    searchSectionToLinkPlaceholder: function() {
        return i18n._({
            id: "UA16nF"
        });
    },
    searchNoteToLinkPlaceholder: function() {
        return i18n._({
            id: "dzxAiB"
        });
    },
    searchForTags: function() {
        return i18n._({
            id: "ESZwT5"
        });
    },
    searchANote: function() {
        return i18n._({
            id: "LuSPV4"
        });
    },
    remindeMeOf: function() {
        return i18n._({
            id: "sjBZtX"
        });
    },
    addShortNote: function() {
        return i18n._({
            id: "2ZqWpM"
        });
    },
    searchingFor: function(query) {
        return i18n._({
            id: "rGR3Zf",
            values: {
                query: query
            }
        });
    },
    typeAKeyword: function() {
        return i18n._({
            id: "/tTfHS"
        });
    },
    search: function() {
        return i18n._({
            id: "A1taO8"
        });
    },
    enterEmailAddress: function() {
        return i18n._({
            id: "r5FOa9"
        });
    },
    enterValidEmail: function() {
        return i18n._({
            id: "OtjenF"
        });
    },
    enterValidPhone: function() {
        return i18n._({
            id: "11o9i4"
        });
    },
    errorGettingCodes: function() {
        return i18n._({
            id: "S5CEnX"
        });
    },
    noResultsFound: function(query) {
        return query ? i18n._({
            id: "SVF205",
            values: {
                query: query
            }
        }) : i18n._({
            id: "AxPAXW"
        });
    },
    routes: {
        Notes: function() {
            return i18n._({
                id: "1DBGsz"
            });
        },
        Notebooks: function() {
            return i18n._({
                id: "jpeU/Z"
            });
        },
        Notebook: function() {
            return i18n._({
                id: "jZh/Kp"
            });
        },
        Favorites: function() {
            return i18n._({
                id: "X9kySA"
            });
        },
        Reminders: function() {
            return i18n._({
                id: "crwali"
            });
        },
        Trash: function() {
            return i18n._({
                id: "GQ3O42"
            });
        },
        Settings: function() {
            return i18n._({
                id: "Tz0i8g"
            });
        },
        Tags: function() {
            return i18n._({
                id: "OYHzN1"
            });
        },
        Editor: function() {
            return i18n._({
                id: "uBAxNB"
            });
        },
        Home: function() {
            return i18n._({
                id: "i0qMbr"
            });
        },
        Search: function() {
            return i18n._({
                id: "A1taO8"
            });
        },
        Monographs: function() {
            return i18n._({
                id: "onn9nd"
            });
        },
        Archive: function() {
            return i18n._({
                id: "B495Gs"
            });
        }
    },
    searchInRoute: function(routeName) {
        var _SEARCH_IN_ROUTE_STRINGS_routeName;
        return ((_SEARCH_IN_ROUTE_STRINGS_routeName = SEARCH_IN_ROUTE_STRINGS[routeName]) === null || _SEARCH_IN_ROUTE_STRINGS_routeName === void 0 ? void 0 : _SEARCH_IN_ROUTE_STRINGS_routeName.call(SEARCH_IN_ROUTE_STRINGS)) || i18n._({
            id: "DCaMCU",
            values: {
                routeName: routeName
            }
        });
    },
    logoutConfirmation: function() {
        return i18n._({
            id: "BrWarS"
        });
    },
    backupDataBeforeLogout: function() {
        return i18n._({
            id: "R3edBv"
        });
    },
    unsyncedChangesWarning: function() {
        return i18n._({
            id: "YaAylK"
        });
    },
    databaseSetupFailed: function() {
        return i18n._({
            id: "2p6i+I"
        });
    },
    streamingNotSupported: function() {
        return i18n._({
            id: "OtWkNU"
        });
    },
    unableToResolveDownloadUrl: function() {
        return i18n._({
            id: "7EFlob"
        });
    },
    pleaseWaitBeforeSendEmail: function() {
        return i18n._({
            id: "M5ttjP"
        });
    },
    unableToSend2faCode: function() {
        return i18n._({
            id: "6O0qBI"
        });
    },
    emailOrPasswordIncorrect: function() {
        return i18n._({
            id: "Q1bc5E"
        });
    },
    errorApplyingPromoCode: function() {
        return i18n._({
            id: "xGX8Rk"
        });
    },
    noNotificationPermission: function() {
        return i18n._({
            id: "3MpPb8"
        });
    },
    selectDayError: function() {
        return i18n._({
            id: "/JegvY"
        });
    },
    setTitleError: function() {
        return i18n._({
            id: "FrOT7Z"
        });
    },
    dateError: function() {
        return i18n._({
            id: "iQ2RjF"
        });
    },
    failedToDecryptBackup: function() {
        return i18n._({
            id: "LWiEXd"
        });
    },
    backupDirectoryNotSelected: function() {
        return i18n._({
            id: "EoPH2E"
        });
    },
    legal: function() {
        return i18n._({
            id: "vifyyw"
        });
    },
    days: function(days) {
        return i18n._({
            id: "RWodu9",
            values: {
                days: days
            }
        });
    },
    daily: function() {
        return i18n._({
            id: "U0sC6H"
        });
    },
    weekly: function() {
        return i18n._({
            id: "4XSc4l"
        });
    },
    monthly: function() {
        return i18n._({
            id: "+8Nek/"
        });
    },
    yearly: function() {
        return i18n._({
            id: "zkWmBh"
        });
    },
    minutes: function(count) {
        return i18n._({
            id: "EhiTx1",
            values: {
                count: count
            }
        });
    },
    hours: function(count) {
        return i18n._({
            id: "Zy02Vw",
            values: {
                count: count
            }
        });
    },
    immediately: function() {
        return i18n._({
            id: "Ujzz/n"
        });
    },
    "12-hour": function() {
        return i18n._({
            id: "CsrDsg"
        });
    },
    "24-hour": function() {
        return i18n._({
            id: "NfZ8rc"
        });
    },
    noteTitle: function() {
        return i18n._({
            id: "jDThel"
        });
    },
    changesNotSaved: function() {
        return i18n._({
            id: "XRVFMa"
        });
    },
    savingNoteTakingTooLong: function() {
        return i18n._({
            id: "1fpjLG"
        });
    },
    changesNotSavedDesc: function() {
        return i18n._({
            id: "nUJhN3"
        });
    },
    changesNotSavedStep1: function() {
        return i18n._({
            id: "VkKpza"
        });
    },
    changesNotSavedStep2: function() {
        return i18n._({
            id: "OBRu3K"
        });
    },
    thisNoteLocked: function() {
        return i18n._({
            id: "eW2Uyt"
        });
    },
    noteLockedBlockLink: function() {
        return i18n._({
            id: "hX14ia"
        });
    },
    dismiss: function() {
        return i18n._({
            id: "1QfxQT"
        });
    },
    totalWords: function(words) {
        return i18n._({
            id: "gqERK4",
            values: {
                words: words
            }
        });
    },
    addATag: function() {
        return i18n._({
            id: "kiL8cg"
        });
    },
    startWritingNote: function() {
        return i18n._({
            id: "9qW8kl"
        });
    },
    off: function() {
        return i18n._({
            id: "az8lvo"
        });
    },
    exportedNotesLocked: function() {
        return i18n._({
            id: "AzdbRo"
        });
    },
    selectFolderForBackupFilesDesc: function() {
        return i18n._({
            id: "SzzbCT"
        });
    },
    selectBackupFolder: function() {
        return i18n._({
            id: "azcekV"
        });
    },
    selectBackupFileDesc: function() {
        return i18n._({
            id: "xAdNvS"
        });
    },
    restoreFromFiles: function() {
        return i18n._({
            id: "WrYFyi"
        });
    },
    recentBackups: function() {
        return i18n._({
            id: "drPitk"
        });
    },
    restoringBackup: function() {
        return i18n._({
            id: "+DSMOo"
        });
    },
    restoringBackupDesc: function() {
        return i18n._({
            id: "gG8g2T"
        });
    },
    decryptingBackup: function() {
        return i18n._({
            id: "eVYovz"
        });
    },
    preparingBackupRestore: function() {
        return i18n._({
            id: "3ma+5W"
        });
    },
    readingBackupFile: function() {
        return i18n._({
            id: "sG6NDK"
        });
    },
    cleaningUp: function() {
        return i18n._({
            id: "g28jQ9"
        });
    },
    extractingFiles: function() {
        return i18n._({
            id: "KQDXwN"
        });
    },
    copyingBackupFileToCache: function() {
        return i18n._({
            id: "1moHXN"
        });
    },
    backupEnterPassword: function() {
        return i18n._({
            id: "MesFcl"
        });
    },
    useEncryptionKey: function() {
        return i18n._({
            id: "hXESBQ"
        });
    },
    testConnection: function() {
        return i18n._({
            id: "e2zZ3E"
        });
    },
    syncServer: function() {
        return i18n._({
            id: "GvZj0K"
        });
    },
    syncServerDesc: function() {
        return i18n._({
            id: "zgxGIu"
        });
    },
    authServer: function() {
        return i18n._({
            id: "YmARQ8"
        });
    },
    authServerDesc: function() {
        return i18n._({
            id: "K91zdY"
        });
    },
    sseServer: function() {
        return i18n._({
            id: "Z9cabd"
        });
    },
    sseServerDesc: function() {
        return i18n._({
            id: "KrzcV1"
        });
    },
    monographServer: function() {
        return i18n._({
            id: "ilIwhe"
        });
    },
    monographServerDesc: function() {
        return i18n._({
            id: "PLVKDf"
        });
    },
    logoutToChangeServerUrls: function() {
        return i18n._({
            id: "WfyFOR"
        });
    },
    enterValidUrl: function() {
        return i18n._({
            id: "jEw0Mr"
        });
    },
    connectedToServer: function() {
        return i18n._({
            id: "133yxV"
        });
    },
    allServerUrlsRequired: function() {
        return i18n._({
            id: "kYeKxA"
        });
    },
    serverNotFound: function(host) {
        return i18n._({
            id: "BhsrU4",
            values: {
                host: host
            }
        });
    },
    couldNotConnectTo: function(server) {
        return i18n._({
            id: "9+It1a",
            values: {
                server: server
            }
        });
    },
    incorrectServerUrl: function(url, server) {
        return i18n._({
            id: "QH46aJ",
            values: {
                url: url,
                server: server
            }
        });
    },
    serverVersionMismatch: function(title, url) {
        return i18n._({
            id: "/ZF8Jn",
            values: {
                title: title,
                url: url
            }
        });
    },
    testConnectionBeforeSave: function() {
        return i18n._({
            id: "Pyw3hX"
        });
    },
    serverUrlChanged: function() {
        return i18n._({
            id: "ncdK+l"
        });
    },
    restartAppToTakeEffect: function() {
        return i18n._({
            id: "ompEI9"
        });
    },
    resetServerUrls: function() {
        return i18n._({
            id: "w4H2bu"
        });
    },
    serverUrlsReset: function() {
        return i18n._({
            id: "Ray+1B"
        });
    },
    dismissAnnouncement: function() {
        return i18n._({
            id: "f15WLC"
        });
    },
    uploaded: function() {
        return i18n._({
            id: "3wG7HI"
        });
    },
    waitingForUpload: function() {
        return i18n._({
            id: "+Yiawb"
        });
    },
    webAuthTitles: [
        function() {
            return i18n._({
                id: "hUkMdj"
            });
        },
        function() {
            return i18n._({
                id: "hQ8KdK"
            });
        },
        function() {
            return i18n._({
                id: "IryJYq"
            });
        },
        function() {
            return i18n._({
                id: "lJQucm"
            });
        },
        function() {
            return "❤️ = 🔒 + 🗒️";
        }
    ],
    restoreThisVersion: function() {
        return i18n._({
            id: "RFQ1Yx"
        });
    },
    autoSaveOff: function() {
        return i18n._({
            id: "au2Os1"
        });
    },
    selectedWords: function(words) {
        return i18n._({
            id: "qZNuZX",
            values: {
                words: words
            }
        });
    },
    dropFilesToAttach: function() {
        return i18n._({
            id: "0n78nG"
        });
    },
    loadingEditor: function() {
        return i18n._({
            id: "8Vztzy"
        });
    },
    noHeadingsFound: function() {
        return i18n._({
            id: "gnHTMg"
        });
    },
    somethingWentWrong: function() {
        return i18n._({
            id: "nwtY4N"
        });
    },
    whatWentWrong: function() {
        return i18n._({
            id: "tq89gP"
        });
    },
    howToFix: function() {
        return i18n._({
            id: "yE0ocX"
        });
    },
    fixIt: function() {
        return i18n._({
            id: "2IexzH"
        });
    },
    reloadApp: function() {
        return i18n._({
            id: "cN9w0B"
        });
    },
    contactSupport: function() {
        return i18n._({
            id: "mpby9d"
        });
    },
    databaseCorruptExplain: function() {
        return i18n._({
            id: "tEMbOb"
        });
    },
    databaseCorruptFix: function() {
        return i18n._({
            id: "uhEnTE"
        });
    },
    decryptKeyErrorExplain: function() {
        return i18n._({
            id: "wwT73K"
        });
    },
    decryptKeyErrorFix: function() {
        return i18n._({
            id: "rKAAZX"
        });
    },
    searchIndexCorrupt: function() {
        return i18n._({
            id: "MD6y4t"
        });
    },
    searchIndexCorruptFix: function() {
        return i18n._({
            id: "eZHe/T"
        });
    },
    installNotesnook: function() {
        return i18n._({
            id: "kWz0NC"
        });
    },
    installNotesnookDesc: function(platform) {
        return i18n._({
            id: "VWqvho",
            values: {
                platform: platform
            }
        });
    },
    nativeFeatures: function() {
        return [
            i18n._({
                id: "B6yjd0"
            }),
            i18n._({
                id: "KNC0YQ"
            }),
            i18n._({
                id: "nfqpcl"
            }),
            i18n._({
                id: "EvBBiU"
            }),
            i18n._({
                id: "+g4IP6"
            }),
            i18n._({
                id: "ytCTfj"
            })
        ];
    },
    loading: function() {
        return i18n._({
            id: "yQE2r9"
        });
    },
    errorsInAttachments: function(count) {
        return i18n._({
            id: "5fe12Q",
            values: {
                count: count
            }
        });
    },
    goToNextPage: function() {
        return i18n._({
            id: "40lLFI"
        });
    },
    goToPreviousPage: function() {
        return i18n._({
            id: "Svkela"
        });
    },
    zoomOut: function() {
        return i18n._({
            id: "FjkaiT"
        });
    },
    zoomIn: function() {
        return i18n._({
            id: "AWOSPo"
        });
    },
    enterFullScreen: function() {
        return i18n._({
            id: "JWj1N3"
        });
    },
    syncingYourNotes: function() {
        return i18n._({
            id: "mDbpO5"
        });
    },
    items: function() {
        return i18n._({
            id: "hgr8eo"
        });
    },
    downloadingImages: function() {
        return i18n._({
            id: "e73HCM"
        });
    },
    checkingForUpdates: function() {
        return i18n._({
            id: "7IsvrP"
        });
    },
    updating: function(percentage) {
        return i18n._({
            id: "amQJb/",
            values: {
                percentage: percentage
            }
        });
    },
    updateCompleted: function(version) {
        return "v".concat(version, " downloaded (click to install)");
    },
    updateNewVersionAvailable: function(version) {
        return i18n._({
            id: "tHCw9Q",
            values: {
                version: version
            }
        });
    },
    unlocking: function() {
        return i18n._({
            id: "vjn5CW"
        });
    },
    reminderStarts: function(date, time) {
        return i18n._({
            id: "zB41vu",
            values: {
                date: date,
                time: time
            }
        });
    },
    files: function(count) {
        return i18n._({
            id: "eM80Pk",
            values: {
                count: count
            }
        });
    },
    of: function() {
        return i18n._({
            id: "BwJKBw"
        });
    },
    installs: function() {
        return i18n._({
            id: "YUOOki"
        });
    },
    licenseUnder: function(license) {
        return i18n._({
            id: "Tj/bMJ",
            values: {
                license: license
            }
        });
    },
    pro: function() {
        return i18n._({
            id: "3fPjUY"
        });
    },
    mfaScanQrCode: function() {
        return i18n._({
            id: "aECGsi"
        });
    },
    scanQrError: function() {
        return i18n._({
            id: "Cd+5Jn"
        });
    },
    mfaScanQrCodeHelpText: function() {
        return i18n._({
            id: "xdyZd4"
        });
    },
    mfaDone: function() {
        return i18n._({
            id: "MbKrD5"
        });
    },
    sms: function() {
        return i18n._({
            id: "4SyDW4"
        });
    },
    app: function() {
        return i18n._({
            id: "CGnyKv"
        });
    },
    mfaFallbackMethodText: function(fallback, primary) {
        return "You will now receive your 2FA codes on your ".concat(strings[fallback]().toLocaleLowerCase(), " in case you lose access to your ").concat(strings[primary]().toLocaleLowerCase(), ".");
    },
    transactionStatusToText: function(key) {
        return key in TRANSACTION_STATUS ? TRANSACTION_STATUS[key]() : key;
    },
    viewReceipt: function() {
        return i18n._({
            id: "AO44G/"
        });
    },
    customDictWords: function(count) {
        return i18n._({
            id: "EloH9X",
            values: {
                count: count
            }
        });
    },
    notesImported: function() {
        return i18n._({
            id: "1f7ALo"
        });
    },
    importCompleted: function() {
        return i18n._({
            id: "2DXRvH"
        });
    },
    errorsOccured: function(count) {
        return i18n._({
            id: "Bx93zD",
            values: {
                count: count
            }
        });
    },
    startOver: function() {
        return i18n._({
            id: "i88wdJ"
        });
    },
    filesReadyToImport: function(count) {
        return i18n._({
            id: "BMX9GU",
            values: {
                count: count
            }
        });
    },
    selectFilesToImport: function() {
        return i18n._({
            id: "KLY5Gj"
        });
    },
    importerHelpText: function() {
        return [
            i18n._({
                id: "27AjU0"
            }),
            i18n._({
                id: "itSBP+"
            }),
            i18n._({
                id: "8FltEe"
            })
        ];
    },
    dropFilesHere: function() {
        return i18n._({
            id: "cMKfzx"
        });
    },
    dragAndDropFiles: function() {
        return i18n._({
            id: "xgFw+6"
        });
    },
    onlyZipSupported: function() {
        return i18n._({
            id: "yCw49i"
        });
    },
    clickToRemove: function() {
        return i18n._({
            id: "fb/FjL"
        });
    },
    currentPlan: function() {
        return i18n._({
            id: "wqYEmY"
        });
    },
    appWillReloadIn: function(sec) {
        return i18n._({
            id: "B4Duko",
            values: {
                sec: sec
            }
        });
    },
    changesReflectOnStart: function() {
        return i18n._({
            id: "RPLx0h"
        });
    },
    edit: function() {
        return i18n._({
            id: "ePK91l"
        });
    },
    yourFullName: function() {
        return i18n._({
            id: "qUkLpp"
        });
    },
    memberSince: function(date) {
        return i18n._({
            id: "HyvPW0",
            values: {
                date: date
            }
        });
    },
    betaLoginNotice: function() {
        return i18n._({
            id: "0ng112"
        });
    },
    loggingIn: function() {
        return i18n._({
            id: "wIGnZX"
        });
    },
    pleaseWaitLogin: function() {
        return i18n._({
            id: "T6W21l"
        });
    },
    emailConfirmed: function() {
        return i18n._({
            id: "ZoYbhZ"
        });
    },
    confirmEmailThankyou: function() {
        return i18n._({
            id: "mOwfJj"
        });
    },
    shareWithFriends: function() {
        return i18n._({
            id: "RqLWns"
        });
    },
    tagPromoWinText: function() {
        return [
            i18n._({
                id: "DsBeuB"
            }),
            i18n._({
                id: "Lnb0Ry"
            }),
            i18n._({
                id: "9rUrvE"
            })
        ];
    },
    shareWithFriendsDesc: function() {
        return i18n._({
            id: "UHq3jt"
        });
    },
    notebooksAllCaps: function() {
        return i18n._({
            id: "j6C/C2"
        });
    },
    authenticatedAs: function(email) {
        return i18n._({
            id: "V20Szg",
            values: {
                email: email
            }
        });
    },
    rememberedYourPassword: function() {
        return i18n._({
            id: "cVqf24"
        });
    },
    chooseRecoveryMethod: function() {
        return i18n._({
            id: "cscG0v"
        });
    },
    chooseRecoveryMethodDesc: function() {
        return i18n._({
            id: "b1G8+1"
        });
    },
    recoveryKeyMethod: function() {
        return i18n._({
            id: "y21V+P"
        });
    },
    recoveryKeyMethodDesc: function() {
        return i18n._({
            id: "w+jD1A"
        });
    },
    backupFileMethod: function() {
        return i18n._({
            id: "iFPl18"
        });
    },
    backupFileMethodDesc: function() {
        return i18n._({
            id: "xvs33b"
        });
    },
    clearDataAndResetMethod: function() {
        return i18n._({
            id: "9rPucK"
        });
    },
    clearDataAndResetMethodDesc: function() {
        return i18n._({
            id: "kcUHgt"
        });
    },
    browse: function() {
        return i18n._({
            id: "O2UpM1"
        });
    },
    dontShowAgain: function() {
        return i18n._({
            id: "VbN7mk"
        });
    },
    dontShowAgainConfirm: function() {
        return i18n._({
            id: "Yx15h4"
        });
    },
    toggleDarkLightMode: function() {
        return i18n._({
            id: "buq7x4"
        });
    },
    goTo: function() {
        return i18n._({
            id: "LmLruJ"
        });
    },
    goToTag: function(tag) {
        return i18n._({
            id: "/GpxuO",
            values: {
                tag: tag
            }
        });
    },
    tagNotFound: function() {
        return "Tag not found";
    },
    downloadAllAttachments: function() {
        return i18n._({
            id: "cAwkZz"
        });
    },
    selectProfilePicture: function() {
        return i18n._({
            id: "jj0TaD"
        });
    },
    changeProfilePicture: function() {
        return i18n._({
            id: "6xavyZ"
        });
    },
    editFullName: function() {
        return i18n._({
            id: "ZhlI6j"
        });
    },
    reset: function() {
        return i18n._({
            id: "OfhWJH"
        });
    },
    resetSelection: function() {
        return i18n._({
            id: "PMHFbb"
        });
    },
    startImportingNow: function() {
        return i18n._({
            id: "uYjZia"
        });
    },
    activatingTrial: function() {
        return i18n._({
            id: "187w+l"
        });
    },
    tryFreeFor14Days: function() {
        return i18n._({
            id: "vUnKPC"
        });
    },
    startImport: function() {
        return i18n._({
            id: "TdaJPU"
        });
    },
    cancelSub: function() {
        return i18n._({
            id: "fHXMPy"
        });
    },
    unlockWithSecurityKey: function() {
        return i18n._({
            id: "ir0Q4L"
        });
    },
    reloginToYourAccount: function() {
        return i18n._({
            id: "cYWR/G"
        });
    },
    skipAndGoToApp: function() {
        return i18n._({
            id: "9re12G"
        });
    },
    startAccountRecovery: function() {
        return i18n._({
            id: "ZfwQuv"
        });
    },
    dontHaveRecoveryKey: function() {
        return i18n._({
            id: "T2RjI0"
        });
    },
    dontHaveBackupFile: function() {
        return i18n._({
            id: "wA+w8M"
        });
    },
    filterLanguages: function() {
        return i18n._({
            id: "G/mWXb"
        });
    },
    searchThemes: function() {
        return i18n._({
            id: "Xz/J7R"
        });
    },
    olderVersion: function() {
        return i18n._({
            id: "hjUom+"
        });
    },
    currentNote: function() {
        return i18n._({
            id: "nVk4n3"
        });
    },
    incomingNote: function() {
        return i18n._({
            id: "CyXpk2"
        });
    },
    description: function() {
        return i18n._({
            id: "Nu4oKW"
        });
    },
    date: function() {
        return i18n._({
            id: "mYGY3B"
        });
    },
    month: function() {
        return i18n._({
            id: "HajiZl"
        });
    },
    day: function() {
        return i18n._({
            id: "H7OUPr"
        });
    },
    time: function() {
        return i18n._({
            id: "LhMjLm"
        });
    },
    encryptionKey: function() {
        return i18n._({
            id: "BNzXTM"
        });
    },
    color: function() {
        return i18n._({
            id: "jZlrte"
        });
    },
    sixDigitCode: function() {
        return i18n._({
            id: "jiqMn1"
        });
    },
    newEmail: function() {
        return i18n._({
            id: "3RwJHq"
        });
    },
    accountPassword: function() {
        return i18n._({
            id: "DX/Wkz"
        });
    },
    phoneNumber: function() {
        return i18n._({
            id: "ZuLy43"
        });
    },
    createAccount: function() {
        return i18n._({
            id: "1hMWR6"
        });
    },
    accountRecoverHelpText: function() {
        return i18n._({
            id: "Eadyob"
        });
    },
    enterRecoveryKey: function() {
        return i18n._({
            id: "wFc7ca"
        });
    },
    enterRecoveryKeyHelp: function() {
        return i18n._({
            id: "Uwgj9H"
        });
    },
    selectBackupFile: function() {
        return i18n._({
            id: "dMSuQW"
        });
    },
    newPasswordHelp: function() {
        return i18n._({
            id: "OIyTII"
        });
    },
    optional: function() {
        return i18n._({
            id: "LLAa/9"
        });
    },
    backupFileHelpText: function() {
        return i18n._({
            id: "XoKOot"
        });
    },
    sendRecoveryEmail: function() {
        return i18n._({
            id: "dxLOG+"
        });
    },
    downloadBackupFile: function() {
        return i18n._({
            id: "Y8yMWH"
        });
    },
    enterPasswordToUnlockVersion: function() {
        return i18n._({
            id: "I3um2i"
        });
    },
    openNote: function() {
        return i18n._({
            id: "1+Oxi9"
        });
    },
    enterPasswordToUnlockNote: function() {
        return i18n._({
            id: "GoDHkX"
        });
    },
    properties: function() {
        return i18n._({
            id: "l/UFPv"
        });
    },
    clickToPreview: function() {
        return i18n._({
            id: "iae2w3"
        });
    },
    clearCache: function() {
        return i18n._({
            id: "jecXQD"
        });
    },
    clearCacheDesc: function(cacheSize) {
        return i18n._({
            id: "4TBk8e",
            values: {
                cacheSize: cacheSize
            }
        });
    },
    clearCacheConfirm: function() {
        return i18n._({
            id: "exVgRE"
        });
    },
    clearCacheConfirmDesc: function() {
        return i18n._({
            id: "tPEL5V"
        });
    },
    cacheCleared: function() {
        return i18n._({
            id: "HcONKe"
        });
    },
    gettingEncryptionKey: function() {
        return i18n._({
            id: "SfT4p9"
        });
    },
    keyBackedUp: function() {
        return i18n._({
            id: "0qqpDM"
        });
    },
    groupAdded: function() {
        return i18n._({
            id: "NODEUe"
        });
    },
    welcomeBack: function() {
        return i18n._({
            id: "rxWA39"
        });
    },
    verifyingEmail: function() {
        return i18n._({
            id: "2wBR2/"
        });
    },
    authWait: function() {
        return i18n._({
            id: "T6W21l"
        });
    },
    accountPassDesc: function() {
        return i18n._({
            id: "HT/M0J"
        });
    },
    creatingAccount: function() {
        return "Creating your account";
    },
    creatingAccountDesc: function() {
        return i18n._({
            id: "O21dBo"
        });
    },
    sendingRecoveryEmail: function() {
        return i18n._({
            id: "fgBcyO"
        });
    },
    sendingRecoveryEmailDesc: function() {
        return i18n._({
            id: "m7JN/Q"
        });
    },
    authenticatingUser: function() {
        return i18n._({
            id: "Tqg4SQ"
        });
    },
    accountRecoveryWithKey: function() {
        return i18n._({
            id: "AqTQz6"
        });
    },
    keyRecoveryProgressDesc: function() {
        return i18n._({
            id: "/kAT3W"
        });
    },
    verifying2faCode: function() {
        return i18n._({
            id: "Xsn/MD"
        });
    },
    coreRequired: function() {
        return i18n._({
            id: "XZy3pB"
        });
    },
    backupFileRecoveryError: function() {
        return i18n._({
            id: "3JLaYV"
        });
    },
    backupYourData: function() {
        return "Backup your data";
    },
    backupYourDataDesc: function() {
        return i18n._({
            id: "0wBbVu"
        });
    },
    backingUpDataWait: function() {
        return i18n._({
            id: "sTlzyO"
        });
    },
    resetAccountPassword: function() {
        return i18n._({
            id: "x/U5fb"
        });
    },
    resettingAccountPassword: function(progress) {
        return i18n._({
            id: "XrXXM0",
            values: {
                progress: progress
            }
        });
    },
    resetPasswordWait: function() {
        return i18n._({
            id: "gDo+iS"
        });
    },
    recoverySuccess: function() {
        return i18n._({
            id: "Fl/olT"
        });
    },
    recoverySuccessDesc: function() {
        return i18n._({
            id: "G23mn+"
        });
    },
    upgradeNow: function() {
        return i18n._({
            id: "IURrEe"
        });
    },
    backupSavedAt: function(path) {
        return i18n._({
            id: "1n/D0G",
            values: {
                path: path
            }
        });
    },
    irreverisibleAction: function() {
        return i18n._({
            id: "iQR4c0"
        });
    },
    doActions: doActions,
    actions: actions,
    inProgressActions: inProgressActions,
    actionErrors: actionErrors,
    actionConfirmations: actionConfirmations,
    deleting: function() {
        return i18n._({
            id: "s3caR3"
        });
    },
    backupReadyToDownload: function() {
        return i18n._({
            id: "JE+p0R"
        });
    },
    vaultUnlocked: function() {
        return i18n._({
            id: "3/Ucsd"
        });
    },
    vaultLocked: function() {
        return i18n._({
            id: "PxZLbK"
        });
    },
    unlockVault: function() {
        return i18n._({
            id: "6f7oMe"
        });
    },
    unlockVaultDesc: function() {
        return i18n._({
            id: "80Kj+q"
        });
    },
    imagePreviewFailed: function() {
        return i18n._({
            id: "taavYz"
        });
    },
    attachmentPreviewFailed: function() {
        return i18n._({
            id: "qJa7Ly"
        });
    },
    failedToCopyNote: function() {
        return i18n._({
            id: "ZSkudh"
        });
    },
    upgradeToProToUseFeature: function() {
        var feature = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "default";
        var features = {
            color: i18n._({
                id: "1dtby4"
            }),
            tags: i18n._({
                id: "TvOYLb"
            }),
            notebook: i18n._({
                id: "EOZzzX"
            }),
            vault: i18n._({
                id: "yj1Us+"
            }),
            customPresets: i18n._({
                id: "AJh2Y/"
            }),
            customizeToolbar: i18n._({
                id: "2L4Xu7"
            }),
            default: i18n._({
                id: "Kfjjhn"
            })
        };
        return features[feature];
    },
    noteDoesNotExist: function() {
        return i18n._({
            id: "Xb/lAC"
        });
    },
    couldNotConvertNote: function(format) {
        return i18n._({
            id: "5xFb51",
            values: {
                format: format
            }
        });
    },
    remindersNotSupported: function() {
        return i18n._({
            id: "W4IFzU"
        });
    },
    invalidHexColor: function() {
        return i18n._({
            id: "q4SSUB"
        });
    },
    profileUpdated: function() {
        return i18n._({
            id: "srPuxS"
        });
    },
    assignedToNotebookMessage: function(notes, added, removed) {
        var n = i18n._({
            id: "3yc19W",
            values: {
                notes: notes
            }
        });
        if (added === 0 && removed > 0) return i18n._({
            id: "WDdSEK",
            values: {
                n: n,
                removed: removed
            }
        });
        else if (added > 0 && removed === 0) return i18n._({
            id: "mAMDtX",
            values: {
                n: n,
                added: added
            }
        });
        else return i18n._({
            id: "L4gzwQ",
            values: {
                n: n,
                added: added,
                removed: removed
            }
        });
    },
    noEncryptionKeyFound: function() {
        return i18n._({
            id: "5oeEKT"
        });
    },
    couldNotActivateTrial: function() {
        return i18n._({
            id: "qDMHKW"
        });
    },
    pleaseTryAgain: function() {
        return i18n._({
            id: "P+gnB7"
        });
    },
    securityKeyRegistered: function() {
        return i18n._({
            id: "bjNhZD"
        });
    },
    restartNow: function() {
        return i18n._({
            id: "MSqvmc"
        });
    },
    copied: function() {
        return i18n._({
            id: "6V3Ea3"
        });
    },
    invalidCors: function() {
        return i18n._({
            id: "c5U6Ql"
        });
    },
    vaultCleared: function() {
        return i18n._({
            id: "+A3HuF"
        });
    },
    vaultDeleted: function() {
        return i18n._({
            id: "ix7AUp"
        });
    },
    subgroupAdded: function() {
        return i18n._({
            id: "XT+mLk"
        });
    },
    subCanceled: function() {
        return i18n._({
            id: "qg56Ux"
        });
    },
    refundIssued: function() {
        return i18n._({
            id: "flschu"
        });
    },
    failedToInstallTheme: function() {
        return i18n._({
            id: "pCCwz4"
        });
    },
    fullNameUpdated: function() {
        return i18n._({
            id: "zPIbaG"
        });
    },
    shortcutRemoved: function() {
        return i18n._({
            id: "jtt6C5"
        });
    },
    recheckFailed: function() {
        return i18n._({
            id: "pd8yYO"
        });
    },
    failedToDelete: function() {
        return i18n._({
            id: "92o1+U"
        });
    },
    failedToRegisterTask: function() {
        return i18n._({
            id: "pYrsmd"
        });
    },
    couldNotClearTrash: function() {
        return i18n._({
            id: "9BxiN1"
        });
    },
    automaticBackupsDisabled: function() {
        return i18n._({
            id: "fvVOmn"
        });
    },
    automaticBackupsDisabledDesc: function() {
        return i18n._({
            id: "JoLZUY"
        });
    },
    default: function() {
        return i18n._({
            id: "ovBPCi"
        });
    },
    minimal: function() {
        return i18n._({
            id: "8GG+Pa"
        });
    },
    custom: function() {
        return i18n._({
            id: "8Tg/JR"
        });
    },
    disableEditorMargins: function() {
        return i18n._({
            id: "LLlYq0"
        });
    },
    enableEditorMargins: function() {
        return i18n._({
            id: "y3+oZ1"
        });
    },
    exitFullScreen: function() {
        return i18n._({
            id: "sQpDn6"
        });
    },
    normalMode: function() {
        return i18n._({
            id: "zYigR9"
        });
    },
    focusMode: function() {
        return i18n._({
            id: "ynYwHn"
        });
    },
    closeOthers: function() {
        return i18n._({
            id: "omXJcU"
        });
    },
    closeToRight: function() {
        return i18n._({
            id: "NJG4Ej"
        });
    },
    closeToLeft: function() {
        return i18n._({
            id: "ltLGoV"
        });
    },
    closeAll: function() {
        return i18n._({
            id: "WyXG7w"
        });
    },
    revealInList: function() {
        return i18n._({
            id: "WZ3jr1"
        });
    },
    keepOpen: function() {
        return i18n._({
            id: "GH02QY"
        });
    },
    orderBy: function() {
        return i18n._({
            id: "ye7QWw"
        });
    },
    oldestToNewest: function() {
        return i18n._({
            id: "cqRQL/"
        });
    },
    newestToOldest: function() {
        return i18n._({
            id: "Jd3ycC"
        });
    },
    sort: function() {
        return i18n._({
            id: "f6Hub0"
        });
    },
    jumpToGroup: function() {
        return i18n._({
            id: "LXmDCb"
        });
    },
    rotateLeft: function() {
        return i18n._({
            id: "BhoGBm"
        });
    },
    rotateRight: function() {
        return i18n._({
            id: "bXGoJA"
        });
    },
    website: function() {
        return i18n._({
            id: "On0aF2"
        });
    },
    resetSidebar: function() {
        return i18n._({
            id: "eAL7su"
        });
    },
    removeColor: function() {
        return doActions.remove.color(1);
    },
    favorite: function() {
        return i18n._({
            id: "6Ki4Pv"
        });
    },
    assignColor: function() {
        return i18n._({
            id: "g28wyQ"
        });
    },
    print: function() {
        return i18n._({
            id: "BZz12Q"
        });
    },
    exportAs: function(format) {
        return i18n._({
            id: "2nOZEC",
            values: {
                0: format ? " " + format : ""
            }
        });
    },
    copyAs: function(format) {
        return i18n._({
            id: "nHQToU",
            values: {
                0: format ? " " + format : ""
            }
        });
    },
    activate: function() {
        return i18n._({
            id: "FQBaXG"
        });
    },
    deactivate: function() {
        return i18n._({
            id: "5y3O+A"
        });
    },
    minimize: function() {
        return i18n._({
            id: "3TSz9S"
        });
    },
    maximize: function() {
        return i18n._({
            id: "gz6UQ3"
        });
    },
    size: function() {
        return i18n._({
            id: "Cj2Gtd"
        });
    },
    dateUploaded: function() {
        return i18n._({
            id: "pvdHNZ"
        });
    },
    editingTagDesc: function(tag) {
        return i18n._({
            id: "BvEQ4q",
            values: {
                tag: tag
            }
        });
    },
    applyingChanges: function() {
        return i18n._({
            id: "1zWb+e"
        });
    },
    thisMayTakeAWhile: function() {
        return i18n._({
            id: "/i7dVl"
        });
    },
    processing: function() {
        return i18n._({
            id: "k1ifdL"
        });
    },
    processingCollection: function(collection) {
        return i18n._({
            id: "7srpuV",
            values: {
                collection: collection
            }
        });
    },
    root: function() {
        return i18n._({
            id: "eyRsaH"
        });
    },
    credientials: function() {
        return i18n._({
            id: "HAzhV7"
        });
    },
    thankYouForReporting: function() {
        return i18n._({
            id: "Oxog+x"
        });
    },
    thankYouForFeedback: function() {
        return i18n._({
            id: "nhMhRr"
        });
    },
    yourSupportRequestHasBeenForwarded: function() {
        return i18n._({
            id: "gNAJyk"
        });
    },
    bugReportMessage: function(url) {
        return i18n._({
            id: "lG0Nds",
            values: {
                url: url
            }
        });
    },
    supportEmailMessage: function() {
        return i18n._({
            id: "XGeX/7"
        });
    },
    featureRequestMessage: function(url) {
        return i18n._({
            id: "6KP71N",
            values: {
                url: url
            }
        });
    },
    safeEncryptedNotes: function() {
        return i18n._({
            id: "qMbL/p"
        });
    },
    writeWithFreedom: function() {
        return i18n._({
            id: "Ez31T2"
        });
    },
    chooseYourStyle: function() {
        return i18n._({
            id: "BsoM2l"
        });
    },
    changeTheme: function() {
        return i18n._({
            id: "Z3ENFH"
        });
    },
    crossPlatformEncrypted: function() {
        return i18n._({
            id: "2V/hwM"
        });
    },
    encryptsEverything: function() {
        return i18n._({
            id: "SWhGFG"
        });
    },
    joinTheCause: function() {
        return i18n._({
            id: "hNeWbM"
        });
    },
    meetPrivacyMinded: function() {
        return i18n._({
            id: "2E8MOG"
        });
    },
    nextLevelPrivateNoteTaking: function() {
        return i18n._({
            id: "+96hxO"
        });
    },
    welcomeToNotesnookPro: function() {
        return i18n._({
            id: "L95k9i"
        });
    },
    thankYouPrivacy: function() {
        return i18n._({
            id: "xIjoC8"
        });
    },
    weAreAlwaysListening: function() {
        return i18n._({
            id: "pkqAHv"
        });
    },
    importYourNotes: function() {
        return i18n._({
            id: "i9tgJp"
        });
    },
    congratulations: function() {
        return i18n._({
            id: "ryWxhG"
        });
    },
    passwordPin: function() {
        return i18n._({
            id: "KJq6ZO"
        });
    },
    passwordPinDescription: function() {
        return i18n._({
            id: "YNxGYx"
        });
    },
    securityKey: function() {
        return i18n._({
            id: "oG1so1"
        });
    },
    securityKeyDescription: function() {
        return i18n._({
            id: "iKOf5w"
        });
    },
    unregister: function() {
        return i18n._({
            id: "lnV9JE"
        });
    },
    register: function() {
        return i18n._({
            id: "fgLNSM"
        });
    },
    enterPasswordOrPin: function() {
        return i18n._({
            id: "Rs/9x0"
        });
    },
    securityKeyUsername: function() {
        return i18n._({
            id: "2d/OiW"
        });
    },
    securityKeyUsernameDesc: function() {
        return i18n._({
            id: "alXkPl"
        });
    },
    general: function() {
        return i18n._({
            id: "Weq9zb"
        });
    },
    zoomFactor: function() {
        return i18n._({
            id: "n6aA4V"
        });
    },
    zoomFactorDescription: function() {
        return i18n._({
            id: "4XuSgy"
        });
    },
    colorScheme: function() {
        return i18n._({
            id: "tvmuQ0"
        });
    },
    colorSchemeDescription: function() {
        return i18n._({
            id: "xIG2QS"
        });
    },
    auto: function() {
        return i18n._({
            id: "R9Khdg"
        });
    },
    selectTheme: function() {
        return i18n._({
            id: "yrT8pq"
        });
    },
    current2faMethod: function(method) {
        return i18n._({
            id: "zZLsFT",
            values: {
                method: method
            }
        });
    },
    partialBackupDescription: function() {
        return i18n._({
            id: "zuaoc+"
        });
    },
    chooseBackupFormat: function() {
        return i18n._({
            id: "cClD0P"
        });
    },
    backup: function() {
        return i18n._({
            id: "rLgPvm"
        });
    },
    backupWithAttachments: function() {
        return i18n._({
            id: "gHSmZw"
        });
    },
    dateAndTime: function() {
        return i18n._({
            id: "As7Osr"
        });
    },
    desktopApp: function() {
        return i18n._({
            id: "dmXc7z"
        });
    },
    automaticUpdates: function() {
        return i18n._({
            id: "XN/sSd"
        });
    },
    automaticUpdatesDesc: function() {
        return i18n._({
            id: "kxHqAS"
        });
    },
    desktopIntegration: function() {
        return i18n._({
            id: "cc8xVN"
        });
    },
    autoStartOnSystemStartup: function() {
        return i18n._({
            id: "qSv+0R"
        });
    },
    autoStartDescription: function() {
        return i18n._({
            id: "QKhlFD"
        });
    },
    startMinimized: function() {
        return i18n._({
            id: "/TSvMG"
        });
    },
    startMinimizedDescription: function() {
        return i18n._({
            id: "PFuGOL"
        });
    },
    minimizeToSystemTray: function() {
        return i18n._({
            id: "vJCMyI"
        });
    },
    minimizeToSystemTrayDescription: function() {
        return i18n._({
            id: "y/yt21"
        });
    },
    closeToSystemTray: function() {
        return i18n._({
            id: "LbbiIW"
        });
    },
    closeToSystemTrayDescription: function() {
        return i18n._({
            id: "0fa/xj"
        });
    },
    useNativeTitlebar: function() {
        return i18n._({
            id: "JiSX/w"
        });
    },
    useNativeTitlebarDescription: function() {
        return i18n._({
            id: "iKGww+"
        });
    },
    spellCheck: function() {
        return i18n._({
            id: "LECpWm"
        });
    },
    enableSpellChecker: function() {
        return i18n._({
            id: "22bXNX"
        });
    },
    languages: function() {
        return i18n._({
            id: "GAmD3h"
        });
    },
    spellCheckerLanguagesDescription: function() {
        return i18n._({
            id: "gFrENx"
        });
    },
    customDictionaryWords: function() {
        return i18n._({
            id: "9OJASK"
        });
    },
    toolbar: function() {
        return i18n._({
            id: "1aBMyR"
        });
    },
    profile: function() {
        return i18n._({
            id: "vERlcd"
        });
    },
    authentication: function() {
        return i18n._({
            id: "P8fBlG"
        });
    },
    sync: function() {
        return i18n._({
            id: "Nu4DdT"
        });
    },
    behaviour: function() {
        return i18n._({
            id: "PnX/UF"
        });
    },
    notifications: function() {
        return i18n._({
            id: "iDNBZe"
        });
    },
    servers: function() {
        return i18n._({
            id: "4Jvw4q"
        });
    },
    serversConfiguration: function() {
        return i18n._({
            id: "TQ42Qt"
        });
    },
    importExport: function() {
        return i18n._({
            id: "cPFvGL"
        });
    },
    backupExport: function() {
        return i18n._({
            id: "cuqiXV"
        });
    },
    notesnookImporter: function() {
        return i18n._({
            id: "jxoF1a"
        });
    },
    securityPrivacy: function() {
        return i18n._({
            id: "rzHSGO"
        });
    },
    privacy: function() {
        return i18n._({
            id: "rjGI/Q"
        });
    },
    other: function() {
        return i18n._({
            id: "/IX/7x"
        });
    },
    newVersionAvailable: function(version) {
        return "New version (v".concat(version, ") is available for download.");
    },
    installUpdate: function() {
        return i18n._({
            id: "7IMhdJ"
        });
    },
    sourceCode: function() {
        return i18n._({
            id: "joolK7"
        });
    },
    sourceCodeDescription: function() {
        return i18n._({
            id: "B/tM4J"
        });
    },
    viewSourceCode: function() {
        return i18n._({
            id: "k3vkE9"
        });
    },
    checkRoadmap: function() {
        return i18n._({
            id: "mMLo8N"
        });
    },
    availableOnIOS: function() {
        return i18n._({
            id: "j8+xbO"
        });
    },
    availableOnIOSAndAndroid: function() {
        return i18n._({
            id: "gFQJAP"
        });
    },
    availableOnIOSDescription: function() {
        return i18n._({
            id: "FGvhwV"
        });
    },
    availableOnIOSAndAndroidDescription: function() {
        return i18n._({
            id: "Nu+AmX"
        });
    },
    joinCommunity: function() {
        return i18n._({
            id: "toDogE"
        });
    },
    license: function() {
        return i18n._({
            id: "iQmbPb"
        });
    },
    licenseDescription: function() {
        return i18n._({
            id: "r25kLk"
        });
    },
    follow: function() {
        return i18n._({
            id: "MKEPCY"
        });
    },
    report: function() {
        return i18n._({
            id: "gjpdaf"
        });
    },
    send: function() {
        return i18n._({
            id: "JlFcis"
        });
    },
    marketingEmailsDescription: function() {
        return i18n._({
            id: "woStU+"
        });
    },
    hideNoteTitle: function() {
        return i18n._({
            id: "7YT7bT"
        });
    },
    hideNoteTitleDescription: function() {
        return i18n._({
            id: "QMhX/X"
        });
    },
    advanced: function() {
        return i18n._({
            id: "sxkWRg"
        });
    },
    useCustomDns: function() {
        return i18n._({
            id: "ZLCFAw"
        });
    },
    customDnsDescription: function() {
        return i18n._({
            id: "EoGWM0"
        });
    },
    changeProxy: function() {
        return i18n._({
            id: "lo0Qu5"
        });
    },
    proxy: function() {
        return i18n._({
            id: "E8bXne"
        });
    },
    proxyDescription: function() {
        return i18n._({
            id: "kWwAHB"
        });
    },
    sessions: function() {
        return i18n._({
            id: "4cEClj"
        });
    },
    loggedOut: function() {
        return i18n._({
            id: "012be5"
        });
    },
    logoutAllOtherDevices: function() {
        return i18n._({
            id: "1/Hh/c"
        });
    },
    logoutAllOtherDevicesDescription: function() {
        return i18n._({
            id: "zuMRaA"
        });
    },
    clearSessions: function() {
        return i18n._({
            id: "kKDMNt"
        });
    },
    loggedOutAllOtherDevices: function() {
        return i18n._({
            id: "kuwLvk"
        });
    },
    paymentMethod: function() {
        return i18n._({
            id: "ENEPLY"
        });
    },
    changePaymentMethodDescription: function() {
        return i18n._({
            id: "uENNGO"
        });
    },
    billingHistory: function() {
        return i18n._({
            id: "dSjFxR"
        });
    },
    failedToTakeBackup: function() {
        return i18n._({
            id: "+n4iez"
        });
    },
    failedToTakeBackupMessage: function() {
        return i18n._({
            id: "79afNk"
        });
    },
    fullOfflineMode: function() {
        return i18n._({
            id: "qmEhDV"
        });
    },
    fullOfflineModeDesc: function() {
        return i18n._({
            id: "PD+Qz/"
        });
    },
    havingProblemsWithSync: function() {
        return i18n._({
            id: "M3oxuk"
        });
    },
    understand: function() {
        return i18n._({
            id: "5ZRfjk"
        });
    },
    havingProblemsWithSyncDesc: function() {
        return i18n._({
            id: "bdbXwn"
        });
    },
    checkingAttachments: function() {
        return "Checking attachments";
    },
    orderId: function() {
        return i18n._({
            id: "oI/hGR"
        });
    },
    amount: function() {
        return i18n._({
            id: "hehnjM"
        });
    },
    status: function() {
        return i18n._({
            id: "uAQUqI"
        });
    },
    receipt: function() {
        return i18n._({
            id: "OQo7Bl"
        });
    },
    subgroupOne: function() {
        return i18n._({
            id: "jixXSo"
        });
    },
    goBackToNotebooks: function() {
        return i18n._({
            id: "+aNBMm"
        });
    },
    goBackToTags: function() {
        return i18n._({
            id: "GVKZ3l"
        });
    },
    okay: function() {
        return i18n._({
            id: "UaXeX3"
        });
    },
    clearTrashDesc: function() {
        return i18n._({
            id: "43jpUi"
        });
    },
    createdAt: function() {
        return i18n._({
            id: "YeUQpx"
        });
    },
    lastEditedAt: function() {
        return i18n._({
            id: "swQ95C"
        });
    },
    enter6DigitCode: function() {
        return i18n._({
            id: "NaNEM+"
        });
    },
    insertLink: function() {
        return i18n._({
            id: "p0Iq25"
        });
    },
    editLink: function() {
        return i18n._({
            id: "/PoNoq"
        });
    },
    insert: function() {
        return i18n._({
            id: "S8Yqbl"
        });
    },
    moveToTrashDesc: function(interval) {
        return i18n._({
            id: "Tqc9Tg",
            values: {
                interval: interval
            }
        });
    },
    editNotebookDesc: function(notebookTitle) {
        return i18n._({
            id: "wfojYz",
            values: {
                notebookTitle: notebookTitle
            }
        });
    },
    newNotebookDesc: function() {
        return i18n._({
            id: "8yzZaI"
        });
    },
    encryptedBackup: function() {
        return i18n._({
            id: "os2qhG"
        });
    },
    encryptedBackupDesc: function() {
        return i18n._({
            id: "HhcoFZ"
        });
    },
    addToDictionary: function() {
        return i18n._({
            id: "rrKn14"
        });
    },
    cut: function() {
        return i18n._({
            id: "cCd8Bs"
        });
    },
    copyLinkText: function() {
        return i18n._({
            id: "UykgGK"
        });
    },
    copyImage: function() {
        return i18n._({
            id: "GWCG6Y"
        });
    },
    paste: function() {
        return i18n._({
            id: "HzVv6g"
        });
    },
    pasteAndMatchStyle: function() {
        return i18n._({
            id: "D3ocTw"
        });
    },
    pasteWithoutFormatting: function() {
        return i18n._({
            id: "kFXv0V"
        });
    },
    configure: function() {
        return i18n._({
            id: "iAL9tI"
        });
    },
    usingOfficialInstance: function() {
        return i18n._({
            id: "nRL3IJ"
        });
    },
    usingInstance: function(instance, version) {
        return i18n._({
            id: "eKXHcu",
            values: {
                instance: instance,
                version: version
            }
        });
    },
    bold: function() {
        return i18n._({
            id: "KmydK6"
        });
    },
    italic: function() {
        return i18n._({
            id: "pzutoc"
        });
    },
    underline: function() {
        return i18n._({
            id: "YyXtnN"
        });
    },
    strikethrough: function() {
        return i18n._({
            id: "WhOsNE"
        });
    },
    noteLink: function() {
        return i18n._({
            id: "8dQtzR"
        });
    },
    link: function() {
        return i18n._({
            id: "yzF66j"
        });
    },
    linkEdit: function() {
        return i18n._({
            id: "/PoNoq"
        });
    },
    linkRemove: function() {
        return i18n._({
            id: "484LKL"
        });
    },
    openLink: function() {
        return i18n._({
            id: "x57cJf"
        });
    },
    // copyLink: () => t`Copy link`,
    linkSettings: function() {
        return i18n._({
            id: "T4mpdP"
        });
    },
    code: function() {
        return i18n._({
            id: "EWPtMO"
        });
    },
    codeRemove: function() {
        return i18n._({
            id: "Yr6KHA"
        });
    },
    formatClear: function() {
        return i18n._({
            id: "LH0QIQ"
        });
    },
    subscript: function() {
        return i18n._({
            id: "EdNI4G"
        });
    },
    superscript: function() {
        return i18n._({
            id: "6DPjZO"
        });
    },
    // insert: () => t`Insert`,
    bulletList: function() {
        return i18n._({
            id: "ijLc3m"
        });
    },
    numberedList: function() {
        return i18n._({
            id: "M3G9ZD"
        });
    },
    checklist: function() {
        return i18n._({
            id: "ANtE4t"
        });
    },
    fontFamily: function() {
        return i18n._({
            id: "oXmBnV"
        });
    },
    fontSize: function() {
        return i18n._({
            id: "q3il6U"
        });
    },
    headings: function() {
        return i18n._({
            id: "PKjGhT"
        });
    },
    alignCenter: function() {
        return i18n._({
            id: "ukH0aS"
        });
    },
    ltr: function() {
        return i18n._({
            id: "Nxcm2P"
        });
    },
    highlight: function() {
        return i18n._({
            id: "gtEbeW"
        });
    },
    textColor: function() {
        return i18n._({
            id: "MapzEo"
        });
    },
    mathInline: function() {
        return i18n._({
            id: "dn272K"
        });
    },
    tableSettings: function() {
        return i18n._({
            id: "A2UGvJ"
        });
    },
    columnProperties: function() {
        return i18n._({
            id: "MARejF"
        });
    },
    rowProperties: function() {
        return i18n._({
            id: "YX00AI"
        });
    },
    cellProperties: function() {
        return i18n._({
            id: "BQPmlp"
        });
    },
    insertColumnLeft: function() {
        return i18n._({
            id: "ZJ99sD"
        });
    },
    insertColumnRight: function() {
        return i18n._({
            id: "9EykGQ"
        });
    },
    moveColumnLeft: function() {
        return i18n._({
            id: "cKNfyZ"
        });
    },
    moveColumnRight: function() {
        return i18n._({
            id: "1zP4bW"
        });
    },
    deleteColumn: function() {
        return i18n._({
            id: "GAohqx"
        });
    },
    splitCells: function() {
        return i18n._({
            id: "E7ydgs"
        });
    },
    mergeCells: function() {
        return i18n._({
            id: "HNtOdD"
        });
    },
    insertRowAbove: function() {
        return i18n._({
            id: "JrqL/z"
        });
    },
    insertRowBelow: function() {
        return i18n._({
            id: "CUmCwI"
        });
    },
    moveRowUp: function() {
        return i18n._({
            id: "v0YG7U"
        });
    },
    moveRowDown: function() {
        return i18n._({
            id: "oU2ZXu"
        });
    },
    deleteRow: function() {
        return i18n._({
            id: "0cspe/"
        });
    },
    deleteTable: function() {
        return i18n._({
            id: "HSI88F"
        });
    },
    cellBackgroundColor: function() {
        return i18n._({
            id: "a08Aie"
        });
    },
    backgroundColor: function() {
        return i18n._({
            id: "MLZyiY"
        });
    },
    cellBorderColor: function() {
        return i18n._({
            id: "xu8wQg"
        });
    },
    cellTextColor: function() {
        return i18n._({
            id: "Aarp3o"
        });
    },
    cellBorderWidth: function() {
        return i18n._({
            id: "K3sDV7"
        });
    },
    none: function() {
        return i18n._({
            id: "K3sDV7"
        });
    },
    imageSettings: function() {
        return i18n._({
            id: "pO5YI4"
        });
    },
    // alignCenter: () => t`Align center`,
    alignLeft: function() {
        return i18n._({
            id: "IR6Txi"
        });
    },
    alignRight: function() {
        return i18n._({
            id: "pd0UH2"
        });
    },
    imageProperties: function() {
        return i18n._({
            id: "nAfxS1"
        });
    },
    previewAttachment: function() {
        return i18n._({
            id: "thhVS9"
        });
    },
    more: function() {
        return i18n._({
            id: "2FYpfJ"
        });
    },
    attachmentSettings: function() {
        return i18n._({
            id: "ICfz3/"
        });
    },
    downloadAttachment: function() {
        return i18n._({
            id: "ueLv9s"
        });
    },
    removeAttachment: function() {
        return i18n._({
            id: "uowbPn"
        });
    },
    embedSettings: function() {
        return i18n._({
            id: "iOhM3z"
        });
    },
    // alignCenter: () => t`Align center`,
    // alignLeft: () => t`Align left`,
    // alignRight: () => t`Align right`,
    embedProperties: function() {
        return i18n._({
            id: "TLOMzy"
        });
    },
    webclipSettings: function() {
        return i18n._({
            id: "6yRl2N"
        });
    },
    fullscreen: function() {
        return i18n._({
            id: "OwIqiD"
        });
    },
    openInNewTab: function() {
        return i18n._({
            id: "Alx2/L"
        });
    },
    openSource: function() {
        return i18n._({
            id: "v+Wp++"
        });
    },
    outdent: function() {
        return i18n._({
            id: "3mMPT3"
        });
    },
    indent: function() {
        return i18n._({
            id: "Iq3jGm"
        });
    },
    chooseBlockToInsert: function() {
        return i18n._({
            id: "PP+r3Y"
        });
    },
    horizontalRule: function() {
        return i18n._({
            id: "ipm1Dq"
        });
    },
    codeBlock: function() {
        return i18n._({
            id: "4A3Yzu"
        });
    },
    quote: function() {
        return i18n._({
            id: "ZhhOwV"
        });
    },
    mathAndFormulas: function() {
        return i18n._({
            id: "8JoDlo"
        });
    },
    callout: function() {
        return i18n._({
            id: "1a850p"
        });
    },
    image: function() {
        return i18n._({
            id: "hG89Ed"
        });
    },
    insertImage: function() {
        return i18n._({
            id: "3Lcj6W"
        });
    },
    uploadFromDisk: function() {
        return i18n._({
            id: "oC+7Ym"
        });
    },
    takePhotoUsingCamera: function() {
        return i18n._({
            id: "wTb1WC"
        });
    },
    table: function() {
        return i18n._({
            id: "4hJhzz"
        });
    },
    insertTable: function() {
        return i18n._({
            id: "odgaNs"
        });
    },
    embed: function() {
        return i18n._({
            id: "KKBlUU"
        });
    },
    insertEmbed: function() {
        return i18n._({
            id: "NMH/6v"
        });
    },
    attachment: function() {
        return i18n._({
            id: "UY1vmE"
        });
    },
    taskList: function() {
        return i18n._({
            id: "E1/c72"
        });
    },
    outlineList: function() {
        return i18n._({
            id: "Chmc39"
        });
    },
    attachImageFromURL: function() {
        return i18n._({
            id: "izK+f+"
        });
    },
    paragraph: function() {
        return i18n._({
            id: "bkQRMh"
        });
    },
    heading: function(level) {
        return i18n._({
            id: "1nLERW",
            values: {
                level: level
            }
        });
    },
    toggleIndentationMode: function() {
        return i18n._({
            id: "6XgMyc"
        });
    },
    changeLanguage: function() {
        return i18n._({
            id: "+DEogc"
        });
    },
    selectLanguage: function() {
        return i18n._({
            id: "k/sb6z"
        });
    },
    spaces: function() {
        return i18n._({
            id: "9jlHZC"
        });
    },
    lineColumn: function(line, column) {
        return i18n._({
            id: "GQt2H0",
            values: {
                line: line,
                column: column
            }
        });
    },
    selectedCode: function(selected) {
        return i18n._({
            id: "8hjugz",
            values: {
                selected: selected
            }
        });
    },
    searchLanguages: function() {
        return i18n._({
            id: "i6o7XB"
        });
    },
    untitled: function() {
        return i18n._({
            id: "wja8aL"
        });
    },
    readonlyTaskList: function() {
        return i18n._({
            id: "DIQdMJ"
        });
    },
    sortTaskList: function() {
        return i18n._({
            id: "ueug/t"
        });
    },
    clearCompletedTasks: function() {
        return i18n._({
            id: "juhPML"
        });
    },
    chooseCustomColor: function() {
        return i18n._({
            id: "VN11G5"
        });
    },
    deleteMode: function() {
        return i18n._({
            id: "lXe4lf"
        });
    },
    fromURL: function() {
        return i18n._({
            id: "LD6dSx"
        });
    },
    enterEmbedSourceURL: function() {
        return i18n._({
            id: "mYjeny"
        });
    },
    pasteEmbedCode: function() {
        return i18n._({
            id: "DjUJcP"
        });
    },
    fromCode: function() {
        return i18n._({
            id: "MP+6T5"
        });
    },
    expand: function() {
        return i18n._({
            id: "1A3EXy"
        });
    },
    matchCase: function() {
        return i18n._({
            id: "+8PP0T"
        });
    },
    matchWholeWord: function() {
        return i18n._({
            id: "MXFksL"
        });
    },
    replace: function() {
        return i18n._({
            id: "fqSfXY"
        });
    },
    replaceAll: function() {
        return i18n._({
            id: "ygUw8s"
        });
    },
    nextMatch: function() {
        return i18n._({
            id: "SiUUCS"
        });
    },
    previousMatch: function() {
        return i18n._({
            id: "oqB2ez"
        });
    },
    toggleReplace: function() {
        return i18n._({
            id: "BWcFbE"
        });
    },
    enableRegex: function() {
        return i18n._({
            id: "pDRGbF"
        });
    },
    width: function() {
        return i18n._({
            id: "aFWU1n"
        });
    },
    height: function() {
        return i18n._({
            id: "PFFhCT"
        });
    },
    pasteImageURL: function() {
        return i18n._({
            id: "abn+nb"
        });
    },
    linkText: function() {
        return i18n._({
            id: "p/wSdQ"
        });
    },
    url: function() {
        return i18n._({
            id: "IagCbF"
        });
    },
    insertTableOfSize: function(rows, columns) {
        return i18n._({
            id: "HQlhJ8",
            values: {
                rows: rows,
                columns: columns
            }
        });
    },
    setTableSizeNotice: function() {
        return i18n._({
            id: "ssudSj"
        });
    },
    clickToReset: function(title) {
        return i18n._({
            id: "ofLom2",
            values: {
                title: title
            }
        });
    },
    increase: function(title) {
        return i18n._({
            id: "/79q9P",
            values: {
                title: title
            }
        });
    },
    decrease: function(title) {
        return i18n._({
            id: "QdE2IN",
            values: {
                title: title
            }
        });
    },
    saved: function() {
        return i18n._({
            id: "idD8Ev"
        });
    },
    saving: function() {
        return i18n._({
            id: "uF9ruK"
        });
    },
    attachmentRecheckCancelled: function() {
        return i18n._({
            id: "JwRiX/"
        });
    },
    recheckAll: function() {
        return i18n._({
            id: "7crEBe"
        });
    },
    attachmentRecheckComplete: function() {
        return i18n._({
            id: "MAnAgZ"
        });
    },
    checkingNoteAttachments: function() {
        return i18n._({
            id: "ChVDyh"
        });
    },
    checkingAllAttachments: function() {
        return i18n._({
            id: "Ga6ahd"
        });
    },
    passed: function() {
        return i18n._({
            id: "nqMwPi"
        });
    },
    failed: function() {
        return i18n._({
            id: "7Bj3x9"
        });
    },
    cacheClearedDesc: function() {
        return i18n._({
            id: "g4NdQG"
        });
    },
    restoreBackupConfirm: function() {
        return i18n._({
            id: "Sc9Vwr"
        });
    },
    serversConfigurationDesc: function() {
        return i18n._({
            id: "NV3klk"
        });
    },
    prioritySupport: function() {
        return i18n._({
            id: "Jzu7Gb"
        });
    },
    boostProductivityNotebook: function() {
        return i18n._({
            id: "R923gq"
        });
    },
    notebookNotes: function() {
        return i18n._({
            id: "bhhhf3"
        });
    },
    notebookNotesDesc: function() {
        return i18n._({
            id: "z2hsFn"
        });
    },
    workAndOffice: function() {
        return i18n._({
            id: "UcUDOi"
        });
    },
    workAndOfficeDesc: function() {
        return i18n._({
            id: "/3jHhL"
        });
    },
    tasks: function() {
        return i18n._({
            id: "GtycJ/"
        });
    },
    taskAValue: function() {
        return i18n._({
            id: "XE8bXP"
        });
    },
    taskBValue: function() {
        return i18n._({
            id: "+v8D0N"
        });
    },
    meetings: function() {
        return i18n._({
            id: "jzmguI"
        });
    },
    easyAccess: function() {
        return i18n._({
            id: "2XfHyl"
        });
    },
    easyAccessDesc: function() {
        return i18n._({
            id: "y+sLct"
        });
    },
    schoolWork: function() {
        return i18n._({
            id: "yTib47"
        });
    },
    schoolWorkDesc: function() {
        return i18n._({
            id: "Rgmtpn"
        });
    },
    recipes: function() {
        return i18n._({
            id: "KBgc8y"
        });
    },
    recipesDesc: function() {
        return i18n._({
            id: "cFjY5V"
        });
    },
    error: function() {
        return i18n._({
            id: "SlfejT"
        });
    },
    deleteContainingNotes: function(count) {
        return i18n._({
            id: "CLq03J",
            values: {
                count: count
            }
        });
    },
    emailCopied: function() {
        return i18n._({
            id: "uUd0dt"
        });
    },
    redeemGiftCode: function() {
        return i18n._({
            id: "AmbVkT"
        });
    },
    redeemGiftCodeDesc: function() {
        return i18n._({
            id: "l/RgqT"
        });
    },
    redeemingGiftCode: function() {
        return i18n._({
            id: "KnUgSL"
        });
    },
    redeem: function() {
        return i18n._({
            id: "VCG/e6"
        });
    },
    searchForNotesNotebooksAndTags: function() {
        return i18n._({
            id: "U0q6Ox"
        });
    },
    executeACommand: function() {
        return i18n._({
            id: "yC5H3j"
        });
    },
    execute: function() {
        return i18n._({
            id: "ZC2VJP"
        });
    },
    quickOpen: function() {
        return i18n._({
            id: "nsSg3L"
        });
    },
    commandPalette: function() {
        return i18n._({
            id: "ZjtgI+"
        });
    },
    navigate: function() {
        return i18n._({
            id: "dbDjdV"
        });
    },
    nextTab: function() {
        return i18n._({
            id: "l46MqT"
        });
    },
    previousTab: function() {
        return i18n._({
            id: "Mh/4hd"
        });
    },
    goForwardInTab: function() {
        return i18n._({
            id: "U9p5gM"
        });
    },
    goBackInTab: function() {
        return i18n._({
            id: "pAYvSQ"
        });
    },
    attachmentManager: function() {
        return i18n._({
            id: "yVxQLg"
        });
    },
    newTag: function() {
        return i18n._({
            id: "86Pgbp"
        });
    },
    closeCurrentTab: function() {
        return i18n._({
            id: "5EACUW"
        });
    },
    closeAllTabs: function() {
        return i18n._({
            id: "Svc6xL"
        });
    },
    toggleTheme: function() {
        return i18n._({
            id: "2N0C4b"
        });
    },
    actionsForNote: function(title) {
        return i18n._({
            id: "EyghQz",
            values: {
                title: title
            }
        });
    },
    actionsForNotebook: function(title) {
        return i18n._({
            id: "blZli3",
            values: {
                title: title
            }
        });
    },
    actionsForTag: function(title) {
        return i18n._({
            id: "7YrzGY",
            values: {
                title: title
            }
        });
    },
    recents: function() {
        return i18n._({
            id: "AQbgLJ"
        });
    },
    removeFromRecents: function() {
        return i18n._({
            id: "o9t9Y1"
        });
    },
    releaseTrack: function() {
        return i18n._({
            id: "rmB/cf"
        });
    },
    releaseTrackDesc: function() {
        return i18n._({
            id: "snI4Um"
        });
    },
    stable: function() {
        return i18n._({
            id: "B6aXGH"
        });
    },
    beta: function() {
        return i18n._({
            id: "YBt9YP"
        });
    },
    zoom: function() {
        return i18n._({
            id: "ACjxWW"
        });
    },
    toggleFocusMode: function() {
        return i18n._({
            id: "USzHtL"
        });
    },
    fontLigatures: function() {
        return i18n._({
            id: "BiAIlV"
        });
    },
    fontLigaturesDesc: function() {
        return i18n._({
            id: "UvCidZ"
        });
    },
    expandSidebar: function() {
        return i18n._({
            id: "tugdy6"
        });
    },
    viewAllLimits: function() {
        return "View all limits";
    },
    freePlan: function() {
        return i18n._({
            id: "xYSDvt"
        });
    },
    proPlan: function() {
        return i18n._({
            id: "r5je1s"
        });
    },
    essentialPlan: function() {
        return i18n._({
            id: "N0ka8i"
        });
    },
    believerPlan: function() {
        return i18n._({
            id: "ENAZeM"
        });
    },
    storage: function() {
        return i18n._({
            id: "BrrIs8"
        });
    },
    used: function() {
        return i18n._({
            id: "lasgrr"
        });
    },
    editProfile: function() {
        return i18n._({
            id: "9OpVZg"
        });
    },
    linkNotes: function() {
        return i18n._({
            id: "1zIWOq"
        });
    },
    linkingNotesTo: function(title) {
        return i18n._({
            id: "lRQERy",
            values: {
                title: title
            }
        });
    },
    addToNotebook: function() {
        return i18n._({
            id: "WueHPs"
        });
    },
    notebookAdded: function() {
        return i18n._({
            id: "Etx4yc"
        });
    },
    addNotes: function() {
        return i18n._({
            id: "GquPwe"
        });
    },
    setAsHomepage: function() {
        return i18n._({
            id: "Ugo6Bq"
        });
    },
    defaultSidebarTab: function() {
        return i18n._({
            id: "eh8emh"
        });
    },
    defaultSidebarTabDesc: function() {
        return i18n._({
            id: "JY8tIN"
        });
    },
    unsetAsHomepage: function() {
        return i18n._({
            id: "U74/0K"
        });
    },
    archive: function() {
        return i18n._({
            id: "B495Gs"
        });
    },
    yourArchiveIsEmpty: function() {
        return i18n._({
            id: "Ty9F+4"
        });
    },
    unarchive: function() {
        return i18n._({
            id: "5JOLV9"
        });
    },
    moveNotebookDesc: function() {
        return i18n._({
            id: "AMlxpi"
        });
    },
    words: function() {
        return i18n._({
            id: "5tK0NB"
        });
    },
    characters: function() {
        return i18n._({
            id: "wQoVcC"
        });
    },
    paragraphs: function() {
        return i18n._({
            id: "m2tQ9E"
        });
    },
    noNotebooksSelectedToMove: function() {
        return i18n._({
            id: "OV5Fxa"
        });
    },
    scrollToTop: function() {
        return i18n._({
            id: "bUUv3P"
        });
    },
    scrollToBottom: function() {
        return i18n._({
            id: "oOi11l"
        });
    },
    emailConfirmedDesc: function() {
        return i18n._({
            id: "gGMI1i"
        });
    },
    charactersCount: function(count) {
        return i18n._({
            id: "LqgM2j",
            values: {
                count: count
            }
        });
    },
    iAlreadyHaveAnAccount: function() {
        return i18n._({
            id: "Hm0uw5"
        });
    },
    upgradePlan: function() {
        return i18n._({
            id: "KE88un"
        });
    },
    upgrade: function() {
        return i18n._({
            id: "kwkhPe"
        });
    },
    checkoutFaqs: [
        {
            question: function() {
                return i18n._({
                    id: "NoZggZ"
                });
            },
            answer: function() {
                return i18n._({
                    id: "UqT8D/"
                });
            }
        },
        {
            question: function() {
                return i18n._({
                    id: "e35mET"
                });
            },
            answer: function() {
                return i18n._({
                    id: "FazHKz"
                });
            }
        },
        {
            question: function() {
                return i18n._({
                    id: "Gqxtjk"
                });
            },
            answer: function() {
                return i18n._({
                    id: "QmdvrG"
                });
            }
        },
        {
            question: function() {
                return i18n._({
                    id: "ARUksB"
                });
            },
            answer: function() {
                return i18n._({
                    id: "4mMsTH"
                });
            }
        }
    ],
    upgradePlanTo: function(plan) {
        return i18n._({
            id: "AQ7OuY",
            values: {
                plan: plan
            }
        });
    },
    tryItForFree: function() {
        return i18n._({
            id: "pt3+Lv"
        });
    },
    getThisAndSoMuchMore: function() {
        return i18n._({
            id: "40iQTS"
        });
    },
    cloudSpace: function() {
        return i18n._({
            id: "p5LG02"
        });
    },
    appLockFeatureBenefit: function() {
        return i18n._({
            id: "ABxxw9"
        });
    },
    advancedNoteTaking: [
        function() {
            return i18n._({
                id: "1YvVSQ"
            });
        },
        function() {
            return i18n._({
                id: "pLTIUL"
            });
        },
        function() {
            return i18n._({
                id: "4QzHRH"
            });
        }
    ],
    cancelAnytime: function() {
        return i18n._({
            id: "CAjul7"
        });
    },
    googleReminderTrial: function() {
        return i18n._({
            id: "/cX7ea"
        });
    },
    exploreAllPlans: function() {
        return i18n._({
            id: "Hfwdg7"
        });
    },
    tryPlanForFree: function(plan) {
        return i18n._({
            id: "Czpc0C",
            values: {
                plan: plan
            }
        });
    },
    plan: function(plan) {
        return i18n._({
            id: "B/4b46",
            values: {
                plan: plan
            }
        });
    },
    notesnookPlans: [
        function() {
            return i18n._({
                id: "ESunTD"
            });
        },
        function() {
            return i18n._({
                id: "lWy5a1"
            });
        }
    ],
    readyToTakeNextStep: function() {
        return i18n._({
            id: "+DCdy9"
        });
    },
    percentOff: function(discount) {
        return "".concat(discount, "% off");
    },
    recommendedByPrivacyGuides: function() {
        return i18n._({
            id: "D0/VKq"
        });
    },
    featuredOn: function() {
        return i18n._({
            id: "wsb6+3"
        });
    },
    comparePlans: function() {
        return i18n._({
            id: "awM9hH"
        });
    },
    faqs: function() {
        return i18n._({
            id: "aJ4pMe"
        });
    },
    thankYouForSubscribing: function() {
        return i18n._({
            id: "6ErVzz"
        });
    },
    settingUpPlan: function() {
        return i18n._({
            id: "67ATyS"
        });
    },
    hdImages: function() {
        return i18n._({
            id: "/BHUNi"
        });
    },
    billedAnnually: function(price) {
        return i18n._({
            id: "vuXJ6F",
            values: {
                price: price
            }
        });
    },
    billedMonthly: function(price) {
        return i18n._({
            id: "kKosvY",
            values: {
                price: price
            }
        });
    },
    dueToday: function() {
        return i18n._({
            id: "1iShX0"
        });
    },
    daysFree: function(days) {
        return i18n._({
            id: "HaC9r/",
            values: {
                days: days
            }
        });
    },
    due: function(date) {
        return i18n._({
            id: "aX6SE5",
            values: {
                date: date
            }
        });
    },
    "5yearPlanConditions": function() {
        return [
            i18n._({
                id: "lSRdqw"
            }),
            i18n._({
                id: "oXLx0f"
            })
        ];
    },
    trialPlanConditions: [
        function(duration) {
            return i18n._({
                id: "V9KOtk",
                values: {
                    duration: duration
                }
            });
        },
        function(platform) {
            return i18n._({
                id: "P47RW+",
                values: {
                    0: platform === "ios" ? "Apple" : "Google"
                }
            });
        }
    ],
    purchase: function() {
        return i18n._({
            id: "zZk9Yz"
        });
    },
    subscribe: function() {
        return i18n._({
            id: "EDl9kS"
        });
    },
    subscribeAndStartTrial: function() {
        return i18n._({
            id: "gcfXEl"
        });
    },
    oneTimePurchase: function() {
        return i18n._({
            id: "otIvtG"
        });
    },
    cancelAnytimeAlt: function() {
        return i18n._({
            id: "HrpPZd"
        });
    },
    subTerms: [
        function() {
            return i18n._({
                id: "Y4Y6Ah"
            });
        },
        function() {
            return i18n._({
                id: "R6S6Qx"
            });
        },
        function() {
            return i18n._({
                id: "HZFm5R"
            });
        },
        function() {
            return i18n._({
                id: "7ocWGL"
            });
        }
    ],
    bestValue: function() {
        return i18n._({
            id: "SAExBL"
        });
    },
    planLimits: function() {
        return i18n._({
            id: "1nVO3g"
        });
    },
    unlimited: function() {
        return i18n._({
            id: "NIuIk1"
        });
    },
    fiveYearPlan: function() {
        return i18n._({
            id: "RLK/cy"
        });
    },
    educationPlan: function() {
        return i18n._({
            id: "KFYrBh"
        });
    },
    welcomeToPlan: function(plan) {
        return i18n._({
            id: "UPjUXr",
            values: {
                plan: plan
            }
        });
    },
    thankYouForPurchase: function() {
        return i18n._({
            id: "a2NvrJ"
        });
    },
    changePlan: function() {
        return i18n._({
            id: "/A54X+"
        });
    },
    contactSupportToChangePlan: function() {
        return i18n._({
            id: "72uiiv"
        });
    },
    alreadySubscribed: function() {
        return i18n._({
            id: "0J06oG"
        });
    },
    specialOffer: function() {
        return i18n._({
            id: "3UVZUn"
        });
    },
    changePlanOnWeb: function() {
        return i18n._({
            id: "xaZ/bC"
        });
    },
    announcement: function() {
        return i18n._({
            id: "kMnh9o"
        });
    },
    cannotChangePlan: function() {
        return i18n._({
            id: "MjboUb"
        });
    },
    upgradeToRedeem: function() {
        return i18n._({
            id: "IZ6eB6"
        });
    },
    redeemCode: function() {
        return i18n._({
            id: "9N09E7"
        });
    },
    notesnookCircle: function() {
        return i18n._({
            id: "L62OwN"
        });
    },
    notesnookCircleDesc: function() {
        return i18n._({
            id: "VM0lAj"
        });
    },
    trialUserCircleNotice: function() {
        return "Notesnook Circle is reserved for members with an active subscription. You'll get full access after your trial period is over and your subscription is confirmed.";
    },
    freeUserCircleNotice: function() {
        return i18n._({
            id: "+MxSuo"
        });
    },
    finishPurchaseInBrowser: function() {
        return i18n._({
            id: "wShM65"
        });
    },
    goBack: function() {
        return i18n._({
            id: "CKyk7Q"
        });
    },
    clickToDirectlyClaimPromo: function() {
        return i18n._({
            id: "AWm+Wg"
        });
    },
    loginToUploadAttachments: function() {
        return i18n._({
            id: "6jyWhp"
        });
    },
    views: function() {
        return i18n._({
            id: "1I6UoR"
        });
    },
    clickToUpdate: function() {
        return i18n._({
            id: "cj9qLY"
        });
    },
    noPassword: function() {
        return i18n._({
            id: "xmDTKg"
        });
    },
    publishToTheWeb: function() {
        return i18n._({
            id: "PDZX//"
        });
    },
    addToHome: function() {
        return i18n._({
            id: "xxAZE/"
        });
    },
    clickToSave: function() {
        return i18n._({
            id: "LLQiGA"
        });
    },
    lineHeight: function() {
        return i18n._({
            id: "Wqh8xb"
        });
    },
    lineHeightDesc: function() {
        return i18n._({
            id: "S+NIdX"
        });
    },
    enterTitle: function() {
        return i18n._({
            id: "AbxxQV"
        });
    },
    dayFormat: function() {
        return i18n._({
            id: "HZwJCg"
        });
    },
    dayFormatDesc: function() {
        return i18n._({
            id: "wm9y5l"
        });
    },
    trialOnGoing: function(trialExpiryDate) {
        return i18n._({
            id: "03Agmk",
            values: {
                trialExpiryDate: trialExpiryDate
            }
        });
    },
    weekFormat: function() {
        return i18n._({
            id: "hUOJ1a"
        });
    },
    weekFormatDesc: function() {
        return i18n._({
            id: "Xjwuf0"
        });
    },
    editCreationDate: function() {
        return i18n._({
            id: "FpzuFl"
        });
    },
    unlockIncomingNote: function() {
        return i18n._({
            id: "m/ozDx"
        });
    },
    unlockIncomingNoteDesc: function() {
        return i18n._({
            id: "9qk77f"
        });
    },
    setExpiry: function() {
        return i18n._({
            id: "S0xPqr"
        });
    },
    unsetExpiry: function() {
        return i18n._({
            id: "7tMTqZ"
        });
    },
    expiryDate: function() {
        return i18n._({
            id: "Jy5Uk6"
        });
    },
    exportCsv: function() {
        return i18n._({
            id: "2KAI4N"
        });
    },
    importCsv: function() {
        return i18n._({
            id: "2CeOI3"
        });
    },
    noContent: function() {
        return i18n._({
            id: "VUWVKx"
        });
    },
    deleteData: function() {
        return i18n._({
            id: "CTqVxU"
        });
    },
    failedToAttachFile: function() {
        return i18n._({
            id: "dVc0Yo"
        });
    },
    unlockNoteToMergeConflicts: function() {
        return i18n._({
            id: "aRWBGp"
        });
    },
    confirmationEmailSent: function() {
        return i18n._({
            id: "13PnPF"
        });
    },
    back: function() {
        return i18n._({
            id: "iH8pgl"
        });
    },
    invalidRecoveryKey: function() {
        return i18n._({
            id: "VH7eet"
        });
    },
    featureNotAvailable: function() {
        return i18n._({
            id: "A5FBSc"
        });
    },
    valueMustBeBetween: function(min, max) {
        return i18n._({
            id: "+FcnLY",
            values: {
                min: min,
                max: max
            }
        });
    },
    passwordRequired: function() {
        return i18n._({
            id: "GZ6qi2"
        });
    },
    confirmPasswordRequired: function() {
        return i18n._({
            id: "GE6VsT"
        });
    },
    enterAValidEmailAddress: function() {
        return i18n._({
            id: "OtjenF"
        });
    },
    giftCodeRequired: function() {
        return i18n._({
            id: "LI2BH+"
        });
    },
    deleteAttachment: function() {
        return i18n._({
            id: "V/W2Mq"
        });
    },
    deleteAttachmentConfirm: function() {
        return i18n._({
            id: "1oL0IJ"
        });
    },
    attachmentDeleted: function() {
        return i18n._({
            id: "iDEbsu"
        });
    },
    titleIsRequired: function() {
        return i18n._({
            id: "9udQT9"
        });
    },
    nameIsRequired: function() {
        return i18n._({
            id: "f/bxrN"
        });
    },
    currentPasswordRequired: function() {
        return i18n._({
            id: "y7aUa0"
        });
    },
    loginToRestoreAttachments: function() {
        return i18n._({
            id: "Q3W+tW"
        });
    },
    loginToRestoreAttachmentsDesc: function() {
        return i18n._({
            id: "D0hAtg"
        });
    },
    pleaseLoginToDownloadAttachments: function() {
        return i18n._({
            id: "wltMKs"
        });
    },
    attachingFiles: function() {
        return i18n._({
            id: "QY/r87"
        });
    },
    closeCountdown: function(seconds) {
        return i18n._({
            id: "Kf7qcE",
            values: {
                seconds: seconds
            }
        });
    },
    compressing: function() {
        return i18n._({
            id: "e0SMQK"
        });
    },
    encrypting: function() {
        return i18n._({
            id: "Li5ndG"
        });
    },
    fileSizeLimitExceededPleaseUpgrade: function() {
        return i18n._({
            id: "Ez9NuY"
        });
    },
    compressionFailed: function() {
        return i18n._({
            id: "iniAM4"
        });
    },
    openingLocalFile: function() {
        return i18n._({
            id: "PDjvF/"
        });
    },
    openingLocalFileDesc: function(filePath) {
        return i18n._({
            id: "/B9Mfp",
            values: {
                filePath: filePath
            }
        });
    },
    cantOpenFileLinksInBrowsers: function() {
        return i18n._({
            id: "vc/JJv"
        });
    },
    expiryDateMustBeInTheFuture: function() {
        return i18n._({
            id: "1+sYIT"
        });
    },
    expiryDateCannotBeMoreThan1YearInTheFuture: function() {
        return i18n._({
            id: "msf5Pd"
        });
    },
    expiryDateSet: function() {
        return i18n._({
            id: "/QxJH4"
        });
    },
    creationDateCannotBeAfterLastEditedDate: function() {
        return i18n._({
            id: "t6WpPB"
        });
    },
    noteDuplicated: function() {
        return i18n._({
            id: "KVFcVl"
        });
    },
    maximumReminderDate: function(maxDate) {
        return i18n._({
            id: "rbA63c",
            values: {
                maxDate: maxDate
            }
        });
    },
    invalidThemeFileFormat: function() {
        return i18n._({
            id: "y3MIjF"
        });
    },
    themeMissingRequiredFields: function() {
        return i18n._({
            id: "bBwtBM"
        });
    },
    copyLogs: function() {
        return i18n._({
            id: "pS6C6D"
        });
    },
    permissionRequiredToSaveQRCode: function() {
        return i18n._({
            id: "kjHCiP"
        });
    }
};

export { setI18nGlobal, strings };
